// src/components/sort-filters/sort-filters.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
  "@swc/helpers - typeof";

  return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment ClientSideAnalyticsFragment on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      ...EGUisMicroMessageFragment\n    }\n  }\n\n  fragment EGUisMicroMessageFragment on EGUisMicroMessage {\n    schemaName\n    messageContent\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment ClientSideImpressionEventAnalyticsFragment on ClientSideImpressionEventAnalytics {\n    event\n    linkName\n    referrerId\n    uisPrimeMessages {\n      ...EGUisMicroMessageFragment\n    }\n  }\n\n  fragment EGUisMicroMessageFragment on EGUisMicroMessage {\n    schemaName\n    messageContent\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    disabled\n    accessibility\n    icon {\n      id\n      description\n      token\n      title\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    action {\n      accessibility\n    }\n  }\n\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment EGDSRemovablePillFragment on EGDSRemovablePill {\n    primary\n    accessibility\n    disabled\n    action {\n      accessibility\n      analytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSearchCriteriaFragment on ShoppingSearchCriteria {\n    selections {\n      id\n      value\n    }\n    booleans {\n      id\n      value\n    }\n    counts {\n      id\n      value\n    }\n    dates {\n      id\n      value {\n        day\n        month\n        year\n      }\n    }\n    ranges {\n      id\n      max\n      min\n    }\n  }\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment AppliedFilterFragment on ShoppingSortAndFilterAppliedFilter {\n    pill {\n      ...EGDSRemovablePillFragment\n    }\n    nextSearchCriteria {\n      ...ShoppingSearchCriteriaFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment IconFragment on Icon {\n    id\n    title\n    token\n    description\n    size\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicRemovablePillFragment on EGDSBasicRemovablePill {\n    primary\n    name\n    accessibility\n    id\n    disabled\n    removeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    icon {\n      ...IconFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment FilterAppliedFragment on ShoppingAppliedFilter {\n    filter {\n      ...EGDSBasicRemovablePillFragment\n    }\n    nextSearchCriteria {\n      ...ShoppingSearchCriteriaFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsAppliedFiltersFragment on ShoppingSortAndFilters {\n    appliedFilters {\n      ...AppliedFilterFragment\n    }\n    filtersApplied {\n      ...FilterAppliedFragment\n    }\n    clearAll {\n      egdsElementId\n      ...EGDSButtonFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSCarouselFragment on EGDSCarousel {\n    nextButton {\n      accessibility\n      analytics {\n        eventType\n        linkName\n        referrerId\n      }\n    }\n    previousButton {\n      accessibility\n      analytics {\n        eventType\n        linkName\n        referrerId\n      }\n    }\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSortAndFiltersCarouselFragment on ShoppingSortAndFilters {\n    carousel {\n      ...EGDSCarouselFragment\n    }\n    scrollEndAnalytics {\n      eventType\n      linkName\n      referrerId\n    }\n  }\n\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment EGDSTertiaryButtonFragment on UITertiaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment SortFilterToolbarFragment on UIToolbar {\n    __typename\n    primary\n    actions {\n      primary {\n        ...EGDSTertiaryButtonFragment\n      }\n      secondaries {\n        ...EGDSTertiaryButtonFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment EGDSSecondaryButtonFragment on UISecondaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment UIPrimaryFloatingActionButtonFragment on UIPrimaryFloatingActionButton {\n    primary\n    badge\n    accessibility\n    action {\n      accessibility\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    impressionAnalytics {\n      ...ClientSideImpressionEventAnalyticsFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    egdsElementId\n    disabled\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment UISecondaryFloatingActionButtonFragment on UISecondaryFloatingActionButton {\n    primary\n    badge\n    accessibility\n    action {\n      accessibility\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    impressionAnalytics {\n      ...ClientSideImpressionEventAnalyticsFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    egdsElementId\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment UIFloatingActionButtonFragment on UIFloatingActionButton {\n    __typename\n    accessibility\n\n    ... on UIPrimaryFloatingActionButton {\n      ...UIPrimaryFloatingActionButtonFragment\n    }\n\n    ... on UISecondaryFloatingActionButton {\n      ...UISecondaryFloatingActionButtonFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSortAndFilterDialogContainerFragment on ShoppingSortAndFilterDialogContainer {\n    view\n    revealAction {\n      ...UIFloatingActionButtonFragment\n    }\n    applyAction {\n      ...UIFloatingActionButtonFragment\n    }\n    toolbar {\n      ...SortFilterToolbarFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSortAndFilterCenteredSheetAIContainerFragment on ShoppingSortAndFilterCenteredSheetAIContainer {\n    view\n    revealAction {\n      ...EGDSSecondaryButtonFragment\n    }\n    applyAction {\n      ...UIFloatingActionButtonFragment\n    }\n    toolbar {\n      ...SortFilterToolbarFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSortAndFilterContainersFragment on ShoppingSortAndFilters {\n    containers {\n      ...ShoppingSortAndFilterDialogContainerFragment\n      ...ShoppingSortAndFilterCenteredSheetAIContainerFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment AllFilterSheetFooterFragment on ShoppingSortAndFilters {\n    footerLabel\n    containers {\n      ... on ShoppingSortAndFilterDialogContainer {\n        view\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicPillFragment on EGDSBasicPill {\n    accessibility\n    disabled\n    name\n    primary\n    selected\n    selectedText\n    value\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicTriggerPillFragment on EGDSBasicTriggerPill {\n    id\n    disabled\n    primary\n    selected\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    accessibility\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment EGDSPillFragment on EGDSPill {\n    __typename\n\n    ...EGDSBasicPillFragment\n    ...EGDSBasicTriggerPillFragment\n    ...EGDSBasicRemovablePillFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment DropdownFieldFragment on ShoppingDropdownField {\n    __typename\n    primary\n    secondary\n    dropdownOptions: options {\n      accessibility\n      id\n      primary\n      value\n      defaultOption: default\n      selected\n      selectAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      deselectAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment EGDSPrimaryButtonFragment on UIPrimaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ", "\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment QuickAccessFilterSheetFooterFragment on ShoppingSortAndFilterQuickFilter {\n    resultCountLabel\n    applyAction {\n      ...EGDSPrimaryButtonFragment\n    }\n    filterPill {\n      id\n    }\n  }\n\n  ", "\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment TemplateModelFragment on TemplateModel {\n    key\n    source\n  }\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment EGDSBasicLocalizedTextFragment on EGDSBasicLocalizedText {\n    template\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment EGDSCardinalLocalizedTextFragment on EGDSCardinalLocalizedText {\n    egdsElementId\n    text\n    models {\n      ...TemplateModelFragment\n    }\n    templates {\n      ...CardinalTemplateFragment\n    }\n  }\n\n  fragment CardinalTemplateFragment on CardinalTemplate {\n    template\n    category\n  }\n\n  ", "\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  fragment EGDSCompositeLocalizedTextFragment on EGDSCompositeLocalizedText {\n    egdsElementId\n    text\n    template\n    models {\n      ...CompositeLocalizedTextModelFragment\n    }\n  }\n\n  fragment CompositeLocalizedTextModelFragment on CompositeLocalizedTextModel {\n    key\n    models {\n      ...EGDSTemplateModelsFragment\n    }\n  }\n\n  fragment EGDSTemplateModelsFragment on EGDSTemplateModels {\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject32() {
  var data = _tagged_template_literal(["\n  fragment EGDSLocalizedTextFragment on EGDSLocalizedText {\n    ...EGDSBasicLocalizedTextFragment\n    ...EGDSCardinalLocalizedTextFragment\n    ...EGDSCompositeLocalizedTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject32 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject33() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n  }\n"]);
  _templateObject33 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject34() {
  var data = _tagged_template_literal(["\n  fragment SortAndFilterSignalReceiverFragment on SortAndFilterSignalReceiver {\n    signalId\n  }\n"]);
  _templateObject34 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject35() {
  var data = _tagged_template_literal(["\n  fragment SortAndFilterSignalEmitterFragment on SortAndFilterSignalEmitter {\n    signalId\n    condition\n    payload {\n      ...SortAndFilterSignalPayloadFragment\n    }\n  }\n\n  fragment SortAndFilterSignalPayloadFragment on SortAndFilterSignalPayload {\n    ...SortAndFilterBasicFilterPayloadFragment\n    ...SortAndFilterSelectedFilterPillPayloadFragment\n  }\n\n  fragment SortAndFilterBasicFilterPayloadFragment on SortAndFilterBasicFilterPayload {\n    filterId\n    type\n  }\n\n  fragment SortAndFilterSelectedFilterPillPayloadFragment on SortAndFilterSelectedFilterPillPayload {\n    deselectionSignalId\n    filter {\n      ...EGDSBasicRemovablePillPartialFragment\n    }\n    filterName {\n      ...SortAndFilterSignalDataSourceFragment\n    }\n  }\n\n  fragment EGDSBasicRemovablePillPartialFragment on EGDSBasicRemovablePill {\n    name\n    accessibility\n    id\n    removeAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  fragment SortAndFilterSignalDataSourceFragment on SortAndFilterSignalDataSource {\n    ...EGDSPlainTextFragment\n    ...EGDSBasicLocalizedTextFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject35 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject36() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionStackedTileFieldOptionFragment on ShoppingSelectableFilterOption {\n    __typename\n    fieldId: id\n    primary\n    selected\n    value\n    accessibility\n    disabled\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    icon {\n      ...IconFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject36 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject37() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionStackedTileFieldFragment on ShoppingMultiSelectionStackedTileField {\n    __typename\n    multiOptions: options {\n      ...MultiSelectionStackedTileFieldOptionFragment\n    }\n    primary\n    secondary\n  }\n  ", "\n"]);
  _templateObject37 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject38() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionTileFieldOptionFragment on ShoppingSelectableFilterOption {\n    __typename\n    fieldId: id\n    primary\n    secondary\n    selected\n    value\n    accessibility\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    icon {\n      ...IconFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject38 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject39() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionTileFieldFragment on ShoppingMultiSelectionTileField {\n    __typename\n    multiOptions: options {\n      ...MultiSelectionTileFieldOptionFragment\n    }\n    primary\n    secondary\n  }\n  ", "\n"]);
  _templateObject39 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject40() {
  var data = _tagged_template_literal(["\n  fragment MarkFragment on Mark {\n    description\n    id\n  }\n"]);
  _templateObject40 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject41() {
  var data = _tagged_template_literal(["\n  fragment UIGraphicFragment on UIGraphic {\n    ...MarkFragment\n  }\n\n  ", "\n"]);
  _templateObject41 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject42() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionOptionFieldFragment on ShoppingSelectableFilterOption {\n    __typename\n    accessibility\n    fieldId: id\n    description\n    graphic {\n      ...UIGraphicFragment\n    }\n    primary\n    secondary\n    selected\n    value\n    disabled\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject42 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject43() {
  var data = _tagged_template_literal(["\n  fragment MultiSelectionFieldFragment on ShoppingMultiSelectionField {\n    __typename\n    primary\n    secondary\n    fieldId: id\n    expando {\n      collapseLabel\n      collapseAccessibilityLabel\n      expandAccessibilityLabel\n      collapseAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      expandAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      expandLabel\n      minimalHeight\n      threshold\n      visible\n    }\n    options {\n      ...MultiSelectionOptionFieldFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject43 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject44() {
  var data = _tagged_template_literal(["\n  fragment RangeFieldFragment on ShoppingRangeField {\n    primary\n    range {\n      ...ShoppingRangeFilterOptionFragment\n    }\n  }\n\n  fragment ShoppingRangeFilterOptionFragment on ShoppingRangeFilterOption {\n    characteristics {\n      labels {\n        label\n        value\n      }\n      max\n      maxLabel\n      min\n      minLabel\n      step\n      minStepDistance\n    }\n    id\n    minAccessibility\n    maxAccessibility\n    selected {\n      id\n      max\n      min\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n    sliderType\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject44 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject45() {
  var data = _tagged_template_literal(["\n  fragment RangeTextInputFieldFragment on ShoppingRangeTextInputField {\n    numberFormat\n    fieldId: id\n    minValueInput {\n      ... on EGDSTextInputField {\n        egdsElementId\n        label\n        readOnly\n        value\n      }\n    }\n    maxValueInput {\n      ... on EGDSTextInputField {\n        egdsElementId\n        label\n        readOnly\n        value\n      }\n    }\n    rangeField: range {\n      ...ShoppingRangeTextInputFieldFilterOptionFragment\n    }\n    primary\n    secondary\n    lowerBoundAccessibility\n    upperBoundAccessibility\n    minValueAccessibility {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n        text\n      }\n    }\n    maxValueAccessibility {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n        text\n      }\n    }\n    minValueAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    maxValueAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n  }\n\n  fragment ShoppingRangeTextInputFieldFilterOptionFragment on ShoppingRangeFilterOption {\n    characteristics {\n      max\n      maxLabel\n      min\n      minLabel\n      step\n    }\n    id\n    selected {\n      id\n      max\n      min\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject45 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject46() {
  var data = _tagged_template_literal(["\n  fragment SelectionOptionFieldFragment on ShoppingSelectableFilterOption {\n    __typename\n    accessibility\n    fieldId: id\n    primary\n    secondary\n    selected\n    default\n    value\n    selectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    deselectAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    disabled\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject46 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject47() {
  var data = _tagged_template_literal(["\n  fragment SelectionFieldFragment on ShoppingSelectionField {\n    __typename\n    primary\n    secondary\n    expando {\n      collapseLabel\n      expandLabel\n      collapseAccessibilityLabel\n      expandAccessibilityLabel\n      collapseAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      expandAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      minimalHeight\n      threshold\n      visible\n    }\n    options {\n      ...SelectionOptionFieldFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject47 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject48() {
  var data = _tagged_template_literal(["\n  fragment StepInputFieldFragment on ShoppingStepInputField {\n    __typename\n    primary\n    stepInputId: id\n    stepInput {\n      decreaseText\n      increaseText\n      label\n      max\n      min\n      step\n      subLabel\n      value\n      key\n      decreaseAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n      increaseAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n    accessibility\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject48 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject49() {
  var data = _tagged_template_literal(["\n  fragment MutexFieldFragment on ShoppingMutexField {\n    __typename\n    mutexId: id\n    primary\n    secondary\n    options {\n      __typename\n      mutexOption: option {\n        ...MultiSelectionFieldFragment\n        ...RangeFieldFragment\n        ...MultiSelectionStackedTileFieldFragment\n        ...MultiSelectionTileFieldFragment\n        ...StepInputFieldFragment\n        ...RangeTextInputFieldFragment\n      }\n      mutexValue: value {\n        ...SelectionOptionFieldFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject49 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject50() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSelectedFilterFragment on ShoppingSelectedFilter {\n    filter {\n      ...EGDSBasicRemovablePillFragment\n    }\n\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject50 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject51() {
  var data = _tagged_template_literal(["\n  fragment SelectedFiltersFieldFragment on ShoppingSelectedFiltersField {\n    selectedFiltersFieldAccessiblity: accessibility {\n      ... on EGDSBasicLocalizedText {\n        egdsElementId\n        text\n      }\n      ... on EGDSCardinalLocalizedText {\n        egdsElementId\n        accessibilityText\n        text\n      }\n      ... on EGDSCompositeLocalizedText {\n        egdsElementId\n        text\n      }\n    }\n    primary\n    secondary\n    selectedFiltersOrdering\n    shoppingSelectedFilters {\n      ...ShoppingSelectedFilterFragment\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject51 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject52() {
  var data = _tagged_template_literal(["\n  fragment TextInputFieldFragment on ShoppingTextInputField {\n    __typename\n    id\n    primary\n    secondary\n    label\n    placeholder\n    selected\n    icon {\n      id\n      description\n    }\n    typeaheadInfo {\n      client\n      isDestination\n      lineOfBusiness\n      maxNumberOfResults\n      regionType\n      regionId\n      typeaheadFeatures\n      allowExactMatch\n      listTitle\n      categorize\n      dismissButtonText\n      domain\n      emptyResultsPlaceholder\n      typeaheadMultiSelect {\n        isMultiLocation\n        showPills\n        selectedItemHeading\n        clearAllText\n      }\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    clearButtonAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    multiSelections {\n      text\n      value\n    }\n    receivers {\n      ...SortAndFilterSignalReceiverFragment\n    }\n    emitters {\n      ...SortAndFilterSignalEmitterFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject52 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject53() {
  var data = _tagged_template_literal(["\n  fragment QuickAccessFilterFieldFragment on ShoppingSortAndFilterQuickFilter {\n    ...QuickAccessFilterSheetFooterFragment\n    clearAll {\n      ...EGDSSecondaryButtonFragment\n    }\n    fields {\n      ...DropdownFieldFragment\n      ...MultiSelectionFieldFragment\n      ...RangeFieldFragment\n      ...SelectionFieldFragment\n      ...TextInputFieldFragment\n      ...MultiSelectionStackedTileFieldFragment\n      ...MultiSelectionTileFieldFragment\n      ...StepInputFieldFragment\n      ...MutexFieldFragment\n      ...SelectedFiltersFieldFragment\n      ...RangeTextInputFieldFragment\n    }\n    filterPill {\n      ...EGDSPillFragment\n    }\n    resultCountLabel\n    toolbar {\n      ...SortFilterToolbarFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject53 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject54() {
  var data = _tagged_template_literal(["\n  fragment QuickAccessFilterMoreFiltersFragment on ShoppingSortAndFilterButtonTrigger {\n    container {\n      ... on ShoppingSortAndFilterDialogContainer {\n        revealAction {\n          ...UIFloatingActionButtonFragment\n        }\n        applyAction {\n          ...UIFloatingActionButtonFragment\n        }\n        toolbar {\n          ...SortFilterToolbarFragment\n        }\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject54 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject55() {
  var data = _tagged_template_literal(["\n  fragment ToggleFilterPillFieldFragment on ShoppingSortAndFilterToggleFilter {\n    filterPill {\n      ...EGDSPillFragment\n    }\n    analytics {\n      ...ClientSideAnalyticsFragment\n    }\n    option {\n      id\n      primary\n      ... on ShoppingSelectableFilterOption {\n        value\n      }\n    }\n    __typename\n  }\n  ", "\n  ", "\n"]);
  _templateObject55 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject56() {
  var data = _tagged_template_literal(["\n  fragment ShoppingSortAndFiltersQuickAccessFiltersFragment on ShoppingSortAndFilters {\n    quickAccessFilters {\n      ...QuickAccessFilterFieldFragment\n      ...QuickAccessFilterMoreFiltersFragment\n      ...ToggleFilterPillFieldFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject56 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject57() {
  var data = _tagged_template_literal(["\n  fragment SortAndFilterSectionFragment on ShoppingSortAndFilterSection {\n    __typename\n    id\n    title\n    subTitle\n    fields {\n      ...DropdownFieldFragment\n      ...MultiSelectionFieldFragment\n      ...RangeFieldFragment\n      ...SelectionFieldFragment\n      ...TextInputFieldFragment\n      ...MultiSelectionStackedTileFieldFragment\n      ...MultiSelectionTileFieldFragment\n      ...StepInputFieldFragment\n      ...MutexFieldFragment\n      ...SelectedFiltersFieldFragment\n      ...RangeTextInputFieldFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject57 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject58() {
  var data = _tagged_template_literal(["\n  fragment ToggleButtonFieldFragment on EGDSStandardSwitch {\n    checked\n    checkedAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    checkedDescription\n    checkedLabel\n    uncheckedAnalytics {\n      ...ClientSideAnalyticsFragment\n    }\n    uncheckedDescription\n    uncheckedLabel\n  }\n\n  ", "\n"]);
  _templateObject58 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject59() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsFilterBarFragment on ShoppingSortAndFilters {\n    ...AllFilterSheetFooterFragment\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n    sortSections {\n      ...SortAndFilterSectionFragment\n    }\n    toggleButton {\n      ...ToggleButtonFieldFragment\n    }\n    ...ShoppingSortAndFilterContainersFragment\n    ...ShoppingSortAndFiltersQuickAccessFiltersFragment\n    ...ShoppingSortAndFiltersCarouselFragment\n    tnlFields {\n      key\n      value\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject59 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject60() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsFilterPillFragment on ShoppingSortAndFilters {\n    quickAccessFilters {\n      ...ToggleFilterPillFieldFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject60 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject61() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsFiltersFragment on ShoppingSortAndFilters {\n    toggleButton {\n      ...ToggleButtonFieldFragment\n    }\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n    tnlFields {\n      key\n      value\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject61 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject62() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsSortFragment on ShoppingSortAndFilters {\n    sortSections {\n      id\n      fields {\n        ...DropdownFieldFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject62 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject63() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsSortAndFiltersFragment on ShoppingSortAndFilters {\n    ...AllFilterSheetFooterFragment\n    sections {\n      ...SortAndFilterSectionFragment\n    }\n    sortSections {\n      ...SortAndFilterSectionFragment\n    }\n    toggleButton {\n      ...ToggleButtonFieldFragment\n    }\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n    ...ShoppingSortAndFilterContainersFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject63 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject64() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsFilterDialogFragment on ShoppingSortAndFilters {\n    ...AllFilterSheetFooterFragment\n    sections {\n      ...SortAndFilterSectionFragment\n    }\n    filterSections {\n      ...SortAndFilterSectionFragment\n    }\n    ...ShoppingSortAndFilterContainersFragment\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject64 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject65() {
  var data = _tagged_template_literal(["\n  fragment TabSelectionFieldFragment on ShoppingTabSelectionField {\n    __typename\n    tabOptions: options {\n      __typename\n      accessibility\n      id\n      primary\n      secondary\n      value\n      selected\n      selectAnalytics {\n        ...ClientSideAnalyticsFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject65 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject66() {
  var data = _tagged_template_literal(["\n  fragment SearchToolsSortTabsFragment on ShoppingSortAndFilters {\n    sortSections {\n      id\n      fields {\n        ...TabSelectionFieldFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject66 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject67() {
  var data = _tagged_template_literal(["\n  query ActivityUniversalSortAndFiltersQuery(\n    $context: ContextInput!\n    $destination: ActivityDestinationInput!\n    $dateRange: ActivityDateRangeInput\n    $sort: ActivitySort\n    $filters: ActivitySearchFiltersInput\n    $pagination: PaginationInput\n    $marketing: ActivityMarketingInfoInput\n    $searchViewOptions: [ActivitySearchViewOptions!]\n  ) {\n    activitySearch(\n      context: $context\n      destination: $destination\n      dateRange: $dateRange\n      sort: $sort\n      filters: $filters\n      pagination: $pagination\n      marketing: $marketing\n      searchViewOptions: $searchViewOptions\n    ) {\n      universalSortAndFilter {\n        ...SearchToolsFiltersFragment\n        ...SearchToolsAppliedFiltersFragment\n        ...SearchToolsSortFragment\n        ...SearchToolsSortAndFiltersFragment\n        ...SearchToolsFilterPillFragment\n        ...SearchToolsFilterBarFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject67 = function _templateObject() {
    return data;
  };
  return data;
}
import React61 from "react";
import { gql as gql59, useQuery } from "@apollo/client";
import { EGDSForm } from "@egds/react-core/form";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
// ../internal/src/components/sort-filter/search-tools-applied-filters.tsx
import React6 from "react";
import { gql as gql9 } from "@apollo/client";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSScrollable } from "@egds/react-core/scrollable";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/common/button/egds-button-fragment.ts
import { gql as gql2 } from "@apollo/client";
// ../internal/src/components/common/client-side-analytics.ts
import { gql } from "@apollo/client";
var clientSideAnalyticsFragment = gql(_templateObject());
var clientSideImpressionEventAnalyticsFragment = gql(_templateObject1());
// ../internal/src/components/common/button/egds-button-fragment.ts
var EGDSButtonFragment = gql2(_templateObject2(), clientSideAnalyticsFragment);
// ../internal/src/components/sort-filter/__private/__fragments/applied-filter.tsx
import React2 from "react";
import { gql as gql5 } from "@apollo/client";
// ../internal/src/components/common/removable-pill/egds-removable-pill.tsx
import React from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSRemovablePill } from "@egds/react-core/pill";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/uis-messages-mapper.ts
var mapUisMicroMessage = function (uisPrimeMessages) {
  return uisPrimeMessages.map(function (uisPrimeMessage) {
    return {
      messageContent: JSON.parse(uisPrimeMessage.messageContent),
      schemaName: uisPrimeMessage.schemaName
    };
  });
};
// ../internal/src/components/common/removable-pill/egds-removable-pill.tsx
var __Fragment = gql3(_templateObject3(), clientSideAnalyticsFragment);
var SortAndFilterEGDSRemovablePill = function (param) {
  var data = param.data,
    onClick = param.onClick,
    disabled = param.disabled;
  var primary = data.primary,
    accessibility = data.accessibility,
    action = data.action;
  var clickTracker = useClickTracker();
  var handleClick = function () {
    if (action === null || action === void 0 ? void 0 : action.analytics) {
      var _action_analytics = action.analytics,
        linkName = _action_analytics.linkName,
        referrerId = _action_analytics.referrerId,
        uisPrimeMessages = _action_analytics.uisPrimeMessages;
      clickTracker(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  };
  return /* @__PURE__ */React.createElement(EGDSRemovablePill, {
    id: primary,
    onClick: handleClick,
    altText: accessibility || "",
    a11yRemoveText: (action === null || action === void 0 ? void 0 : action.accessibility) || "",
    disabled: data.disabled || disabled
  }, primary);
};
SortAndFilterEGDSRemovablePill.displayName = "SortAndFilterEGDSRemovablePill";
SortAndFilterEGDSRemovablePill.fragment = __Fragment;
// ../internal/src/components/sort-filter/__private/__fragments/next-search-criteria-fragment.tsx
import { gql as gql4 } from "@apollo/client";
var NextSearchCriteriaFragment = gql4(_templateObject4());
// ../internal/src/components/sort-filter/__private/__fragments/applied-filter.tsx
var __Fragment2 = gql5(_templateObject5(), SortAndFilterEGDSRemovablePill.fragment, NextSearchCriteriaFragment);
var AppliedFilter = function (param) {
  var data = param.data,
    onRemove = param.onRemove,
    allowEmptySelections = param.allowEmptySelections,
    disabled = param.disabled;
  var _nextSearchCriteria_selections;
  var pill = data.pill,
    nextSearchCriteria = data.nextSearchCriteria;
  if (pill.__typename !== "EGDSRemovablePill" || !((_nextSearchCriteria_selections = nextSearchCriteria.selections) === null || _nextSearchCriteria_selections === void 0 ? void 0 : _nextSearchCriteria_selections[0]) && !allowEmptySelections) {
    return null;
  }
  var handleClick = function () {
    onRemove === null || onRemove === void 0 ? void 0 : onRemove(nextSearchCriteria);
  };
  return /* @__PURE__ */React2.createElement(SortAndFilterEGDSRemovablePill, {
    data: pill,
    onClick: handleClick,
    disabled: disabled
  });
};
AppliedFilter.displayName = "AppliedFilter";
AppliedFilter.fragment = __Fragment2;
// ../internal/src/components/sort-filter/__private/__fragments/filter-applied.tsx
import React5 from "react";
import { gql as gql8 } from "@apollo/client";
// ../internal/src/components/common/egds-pill/egds-basic-removable-pill.tsx
import React4 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSRemovablePill as EGDSRemovablePill2 } from "@egds/react-core/pill";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/common/icon.tsx
import React3 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
// ../internal/src/__generated__/types.ts
var SortAndFiltersViewType = /* @__PURE__ */function (SortAndFiltersViewType2) {
  SortAndFiltersViewType2["APPLIED_FILTERS"] = "APPLIED_FILTERS";
  SortAndFiltersViewType2["FILTERS"] = "FILTERS";
  SortAndFiltersViewType2["FILTERS_PILLS"] = "FILTERS_PILLS";
  SortAndFiltersViewType2["FILTER_BAR"] = "FILTER_BAR";
  SortAndFiltersViewType2["FILTER_DIALOG"] = "FILTER_DIALOG";
  SortAndFiltersViewType2["SORT"] = "SORT";
  SortAndFiltersViewType2["SORT_AND_FILTERS"] = "SORT_AND_FILTERS";
  SortAndFiltersViewType2["SORT_TABS"] = "SORT_TABS";
  SortAndFiltersViewType2["USE_REWARDS"] = "USE_REWARDS";
  return SortAndFiltersViewType2;
}(SortAndFiltersViewType || {});
// ../internal/src/components/common/icon.tsx
var __Fragment3 = gql6(_templateObject6());
var _obj;
var iconSizeMap = (_obj = {}, _define_property(_obj, "EXTRA_SMALL" /* EXTRA_SMALL */, EGDSIconSize.EXTRA_SMALL), _define_property(_obj, "SMALL" /* SMALL */, EGDSIconSize.SMALL), _define_property(_obj, "MEDIUM" /* MEDIUM */, EGDSIconSize.MEDIUM), _define_property(_obj, "MEDIUM_LARGE" /* MEDIUM_LARGE */, EGDSIconSize.MEDIUM), _define_property(_obj, "LARGE" /* LARGE */, EGDSIconSize.LARGE), _define_property(_obj, "XLARGE" /* XLARGE */, EGDSIconSize.XLARGE), _obj);
var Icon = function (props) {
  var data = props.data;
  var id = data.id,
    title = data.title,
    description = data.description,
    size = data.size;
  var iconSize = iconSizeMap[size !== null && size !== void 0 ? size : "LARGE"];
  return /* @__PURE__ */React3.createElement(EGDSIcon, {
    id: id,
    name: id,
    title: title !== null && title !== void 0 ? title : description,
    description: description,
    size: iconSize
  });
};
Icon.displayName = "Icon";
Icon.fragment = __Fragment3;
// ../internal/src/components/common/egds-pill/egds-basic-removable-pill.tsx
var __Fragment4 = gql7(_templateObject7(), Icon.fragment, clientSideAnalyticsFragment);
var EGDSBasicRemovablePill = function (param) {
  var data = param.data,
    onClick = param.onClick,
    onRemove = param.onRemove,
    loading = param.loading,
    className = param.className;
  var id = data.id,
    primary = data.primary,
    accessibility = data.accessibility,
    removeAnalytics = data.removeAnalytics,
    name = data.name,
    disabled = data.disabled,
    icon = data.icon;
  var _ref;
  var title = (_ref = id !== null && id !== void 0 ? id : name) !== null && _ref !== void 0 ? _ref : "egds-basic-removable-pill";
  var iconToken = (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "";
  var clickTracker = useClickTracker2();
  var handleOnClick = function (event) {
    if (onClick) {
      onClick();
    }
    if (onRemove) {
      onRemove(event);
    }
    if (removeAnalytics) {
      var referrerId = removeAnalytics.referrerId,
        linkName = removeAnalytics.linkName,
        uisPrimeMessages = removeAnalytics.uisPrimeMessages;
      clickTracker(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
  };
  return /* @__PURE__ */React4.createElement(EGDSRemovablePill2, {
    value: primary || "",
    id: title,
    onClick: handleOnClick,
    icon: iconToken,
    a11yRemoveText: accessibility || "",
    disabled: disabled || loading,
    className: className
  }, primary);
};
EGDSBasicRemovablePill.displayName = "EGDSBasicRemovablePill";
EGDSBasicRemovablePill.fragment = __Fragment4;
// ../internal/src/components/sort-filter/__private/__fragments/filter-applied.tsx
var __Fragment5 = gql8(_templateObject8(), EGDSBasicRemovablePill.fragment, NextSearchCriteriaFragment);
var hasNoCriteria = function (nextSearchCriteria) {
  var _nextSearchCriteria_selections, _nextSearchCriteria_ranges;
  if (!nextSearchCriteria) {
    return true;
  }
  return !(((_nextSearchCriteria_selections = nextSearchCriteria.selections) === null || _nextSearchCriteria_selections === void 0 ? void 0 : _nextSearchCriteria_selections[0]) || ((_nextSearchCriteria_ranges = nextSearchCriteria.ranges) === null || _nextSearchCriteria_ranges === void 0 ? void 0 : _nextSearchCriteria_ranges[0]));
};
var FilterApplied = function (param) {
  var data = param.data,
    onRemove = param.onRemove,
    allowEmptySelections = param.allowEmptySelections,
    loading = param.loading,
    setDefaults = param.setDefaults;
  var filter = data.filter,
    nextSearchCriteria = data.nextSearchCriteria;
  React5.useEffect(function () {
    var _nextSearchCriteria_selections_, _nextSearchCriteria_selections;
    if ((nextSearchCriteria === null || nextSearchCriteria === void 0 ? void 0 : (_nextSearchCriteria_selections = nextSearchCriteria.selections) === null || _nextSearchCriteria_selections === void 0 ? void 0 : (_nextSearchCriteria_selections_ = _nextSearchCriteria_selections[0]) === null || _nextSearchCriteria_selections_ === void 0 ? void 0 : _nextSearchCriteria_selections_.id) === "neighborhood") {
      var _nextSearchCriteria_selections1;
      setDefaults({
        regionId: nextSearchCriteria === null || nextSearchCriteria === void 0 ? void 0 : (_nextSearchCriteria_selections1 = nextSearchCriteria.selections) === null || _nextSearchCriteria_selections1 === void 0 ? void 0 : _nextSearchCriteria_selections1[0].value
      });
    }
  }, []);
  if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill" || hasNoCriteria(nextSearchCriteria) && !allowEmptySelections) {
    return null;
  }
  var handleClick = function () {
    if (onRemove && nextSearchCriteria) {
      onRemove(nextSearchCriteria);
    }
  };
  return /* @__PURE__ */React5.createElement(EGDSBasicRemovablePill, {
    data: filter,
    onClick: handleClick,
    loading: loading
  });
};
FilterApplied.displayName = "FilterApplied";
FilterApplied.fragment = __Fragment5;
// ../internal/src/components/sort-filter/search-tools-applied-filters.tsx
var __Fragment6 = gql9(_templateObject9(), AppliedFilter.fragment, FilterApplied.fragment, EGDSButtonFragment);
var getFilters = function (filtersApplied, appliedFilters_deprecated) {
  if (filtersApplied) {
    return _to_consumable_array(filtersApplied);
  }
  if (appliedFilters_deprecated) {
    return _to_consumable_array(appliedFilters_deprecated);
  }
  return [];
};
var FilterComponent = function (param) {
  var key = param.key,
    filter = param.filter,
    onRemove = param.onRemove,
    allowEmptySelections = param.allowEmptySelections,
    loading = param.loading,
    setDefaults = param.setDefaults;
  if ("pill" in filter) {
    return /* @__PURE__ */React6.createElement(AppliedFilter, {
      key: key,
      data: filter,
      onRemove: onRemove,
      allowEmptySelections: allowEmptySelections,
      disabled: loading
    });
  }
  if ("filter" in filter) {
    return /* @__PURE__ */React6.createElement(FilterApplied, {
      key: key,
      data: filter,
      onRemove: onRemove,
      allowEmptySelections: allowEmptySelections,
      loading: loading,
      setDefaults: setDefaults
    });
  }
  return null;
};
var SearchToolsAppliedFilters = function (param) {
  var data = param.data,
    onEmptyResults = param.onEmptyResults,
    onRemoveAppliedFilter = param.onRemoveAppliedFilter,
    onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters,
    _param_wrapAppliedFilters = param.wrapAppliedFilters,
    wrapAppliedFilters = _param_wrapAppliedFilters === void 0 ? false : _param_wrapAppliedFilters,
    allowEmptySelectionsPills = param.allowEmptySelectionsPills,
    loading = param.loading,
    appliedFiltersSpacing = param.appliedFiltersSpacing;
  var _data_clearAll;
  var appliedFilters_deprecated = data.appliedFilters,
    clearAll = data.clearAll,
    filtersApplied = data.filtersApplied;
  var track = useClickTracker3();
  var clearElementId = clearAll === null || clearAll === void 0 ? void 0 : clearAll.egdsElementId;
  var filters = getFilters(filtersApplied, appliedFilters_deprecated);
  var _React6_useState = _sliced_to_array(React6.useState(void 0), 2),
    defaults = _React6_useState[0],
    setDefaults = _React6_useState[1];
  var handleClearAll = React6.useCallback(function () {
    var _data_clearAll;
    if ((_data_clearAll = data.clearAll) === null || _data_clearAll === void 0 ? void 0 : _data_clearAll.analytics) {
      var _data_clearAll_analytics = data.clearAll.analytics,
        referrerId = _data_clearAll_analytics.referrerId,
        linkName = _data_clearAll_analytics.linkName;
      track(referrerId, linkName);
    }
    onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters(defaults);
  }, [(_data_clearAll = data.clearAll) === null || _data_clearAll === void 0 ? void 0 : _data_clearAll.analytics, onRemoveAllAppliedFilters, track]);
  if (!(filters === null || filters === void 0 ? void 0 : filters.length)) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  return /* @__PURE__ */React6.createElement(EGDSSpacing, _object_spread({}, appliedFiltersSpacing), /* @__PURE__ */React6.createElement(EGDSScrollable, {
    direction: "horizontal"
  }, /* @__PURE__ */React6.createElement(EGDSLayoutFlex, {
    wrap: wrapAppliedFilters ? "wrap" : "nowrap",
    space: wrapAppliedFilters ? "two" : void 0
  }, (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /* @__PURE__ */React6.createElement(React6.Fragment, null, filters.map(function (filter, index) {
    return /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem, {
      shrink: 0,
      key: "applied-filter-".concat(index)
    }, /* @__PURE__ */React6.createElement(FilterComponent, {
      key: "applied-filter-".concat(index),
      filter: filter,
      onRemove: onRemoveAppliedFilter,
      allowEmptySelections: allowEmptySelectionsPills,
      loading: loading,
      setDefaults: setDefaults
    }));
  })), clearAll && /* @__PURE__ */React6.createElement(EGDSLayoutFlexItem, {
    shrink: 0
  }, /* @__PURE__ */React6.createElement(EGDSSpacing, {
    margin: {
      inlineend: "one"
    },
    padding: {
      inlinestart: "two",
      block: "two"
    }
  }, /* @__PURE__ */React6.createElement(EGDSLink, {
    inline: true,
    noWrap: true
  }, /* @__PURE__ */React6.createElement("button", {
    type: "button",
    onClick: handleClearAll,
    disabled: loading,
    "data-test-id": clearElementId
  }, clearAll.primary)))))));
};
SearchToolsAppliedFilters.displayName = "SearchToolsAppliedFilters";
SearchToolsAppliedFilters.fragment = __Fragment6;
// ../internal/src/components/sort-filter/search-tools-filter-bar.tsx
import React53 from "react";
import { gql as gql51 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent2 } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex12, EGDSLayoutFlexItem as EGDSLayoutFlexItem13 } from "@egds/react-core/layout-flex";
import { EGDSPill as EGDSPill3 } from "@egds/react-core/pill";
import { EGDSScrollable as EGDSScrollable2 } from "@egds/react-core/scrollable";
import { EGDSSheet as EGDSSheet4, EGDSSheetTransition as EGDSSheetTransition4 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing20 } from "@egds/react-core/spacing";
import { CarouselInnerSpacingAndOverflow } from "@egds/react-universal-shopping";
import { ITrackType, useClickstreamAnalytics, useClickTracker as useClickTracker29 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment8 } from "@shared-ui/experiment-context";
import { defaultViewSizes as defaultViewSizes5, useMediaQueries as useMediaQueries5 } from "@shared-ui/viewport-context";
// ../internal/src/utils/parse-graphql-pair.ts
var parseGraphQLPair = function (graphQLPairArray, fieldKey) {
  return graphQLPairArray.find(function (element) {
    return element.key === fieldKey;
  });
};
// ../internal/src/utils/referrer-mapper.ts
var referrerMapper = function (referrerId, linkName) {
  var eventType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "click";
  return {
    schemaName: "referrer",
    messageContent: {
      referrerId: referrerId,
      linkName: linkName,
      eventType: eventType
    }
  };
};
// ../internal/src/components/common/carousel/carousel-fragment.ts
import { gql as gql10 } from "@apollo/client";
var EGDSCarouselFragment = gql10(_templateObject10());
var ShoppingSortAndFiltersCarouselFragment = gql10(_templateObject11(), EGDSCarouselFragment);
// ../internal/src/components/common/containers-fragment.ts
import { gql as gql17 } from "@apollo/client";
// ../internal/src/components/sort-filter/__private/__fragments/toolbar.tsx
import React8 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/common/button/egds-tertiary-button.tsx
import React7 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
var __Fragment7 = gql11(_templateObject12(), EGDSButtonFragment);
var SortAndFilterEGDSTertiaryButton = function (param) {
  var onClick = param.onClick,
    isFullWidth = param.isFullWidth,
    size = param.size,
    data = param.data,
    isDisabled = param.isDisabled;
  var egdsElementId = data.egdsElementId,
    primary = data.primary,
    disabled = data.disabled,
    accessibility = data.accessibility,
    analytics = data.analytics,
    icon = data.icon;
  var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_tertiary_button";
  var track = useClickTracker4();
  var disableState = isDisabled || disabled;
  var handleClick = React7.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  }, [analytics, onClick, track]);
  return /* @__PURE__ */React7.createElement(EGDSTertiaryButton, {
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : "",
    id: id,
    "data-test-id": id,
    onClick: handleClick,
    disabled: disableState,
    isFullWidth: isFullWidth,
    size: size
  }, icon && /* @__PURE__ */React7.createElement(EGDSIcon2, {
    name: icon.id
  }), primary);
};
SortAndFilterEGDSTertiaryButton.displayName = "SortAndFilterEGDSTertiaryButton";
SortAndFilterEGDSTertiaryButton.fragment = __Fragment7;
// ../internal/src/components/sort-filter/__private/__fragments/toolbar.tsx
var __Fragment8 = gql12(_templateObject13(), SortAndFilterEGDSTertiaryButton.fragment);
var Toolbar = function (props) {
  var data = props.data,
    onCloseButtonClick = props.onCloseButtonClick,
    onClearAllButtonClick = props.onClearAllButtonClick;
  var actions = data.actions,
    primary = data.primary;
  var close = actions.primary,
    secondaries = actions.secondaries;
  var track = useClickTracker5();
  var _actions_primary_egdsElementId;
  var id = (_actions_primary_egdsElementId = actions.primary.egdsElementId) !== null && _actions_primary_egdsElementId !== void 0 ? _actions_primary_egdsElementId : "";
  var _close_accessibility;
  var closeAccessibility = (_close_accessibility = close.accessibility) !== null && _close_accessibility !== void 0 ? _close_accessibility : "";
  var handleCloseButton = React8.useCallback(function () {
    if (actions.primary.analytics) {
      var _actions_primary_analytics = actions.primary.analytics,
        referrerId = _actions_primary_analytics.referrerId,
        linkName = _actions_primary_analytics.linkName;
      track(referrerId, linkName);
    }
    onCloseButtonClick === null || onCloseButtonClick === void 0 ? void 0 : onCloseButtonClick();
  }, [actions.primary.analytics, onCloseButtonClick, track]);
  if (!primary || !Array.isArray(secondaries) || secondaries.length === 0) {
    return null;
  }
  var _secondaries = _sliced_to_array(secondaries, 1),
    clearAll = _secondaries[0];
  return /* @__PURE__ */React8.createElement(EGDSToolbar, {
    toolbarTitle: primary,
    navigationContent: onCloseButtonClick ? {
      onClick: handleCloseButton,
      navIconLabel: closeAccessibility,
      navButtonId: id
    } : void 0,
    toolbarActionContent: clearAll && /* @__PURE__ */React8.createElement(SortAndFilterEGDSTertiaryButton, {
      data: clearAll,
      onClick: onClearAllButtonClick
    })
  });
};
Toolbar.displayName = "Toolbar";
Toolbar.fragment = __Fragment8;
// ../internal/src/components/common/button/egds-secondary-button.tsx
import React9 from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSSecondaryButton } from "@egds/react-core/button";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
var __Fragment9 = gql13(_templateObject14(), EGDSButtonFragment);
var SortAndFilterEGDSSecondaryButton = function (param) {
  var onClick = param.onClick,
    data = param.data;
  var egdsElementId = data.egdsElementId,
    primary = data.primary,
    analytics = data.analytics;
  var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_secondary_button";
  var track = useClickTracker6();
  var handleClick = React9.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  }, [analytics, onClick, track]);
  return /* @__PURE__ */React9.createElement(EGDSSecondaryButton, {
    id: id,
    onClick: handleClick
  }, primary);
};
SortAndFilterEGDSSecondaryButton.displayName = "SortAndFilterEGDSSecondaryButton";
SortAndFilterEGDSSecondaryButton.fragment = __Fragment9;
// ../internal/src/components/common/ui-floating-action-button/ui-floating-action-button.tsx
import React12 from "react";
import { gql as gql16 } from "@apollo/client";
import { EGDSButtonSize } from "@egds/react-core/button";
// ../internal/src/components/common/ui-floating-action-button/ui-primary-floating-action-button.tsx
import React10 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSNotificationBadge1 } from "@egds/react-core/badge";
import { EGDSPrimaryButton } from "@egds/react-core/button";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
var __Fragment10 = gql14(_templateObject15(), clientSideImpressionEventAnalyticsFragment, clientSideAnalyticsFragment, Icon.fragment);
var UIPrimaryFloatingActionButton = function (props) {
  var data = props.data,
    onClick = props.onClick,
    isFullWidth = props.isFullWidth,
    size = props.size,
    triggerRef = props.triggerRef;
  var primary = data.primary,
    icon = data.icon,
    badge = data.badge,
    analytics = data.analytics,
    egdsElementId = data.egdsElementId,
    disabled = data.disabled;
  var track = useClickTracker7();
  var handleClick = React10.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  }, [analytics, onClick, track]);
  return /* @__PURE__ */React10.createElement(EGDSPrimaryButton, {
    isFullWidth: isFullWidth,
    onClick: handleClick,
    size: size,
    "data-test-id": egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
    domRef: triggerRef,
    disabled: disabled
  }, badge && /* @__PURE__ */React10.createElement(EGDSNotificationBadge1, {
    text: badge.toString()
  }), primary, icon && /* @__PURE__ */React10.createElement(Icon, {
    data: icon
  }));
};
UIPrimaryFloatingActionButton.displayName = "UIPrimaryFloatingActionButton";
UIPrimaryFloatingActionButton.fragment = __Fragment10;
// ../internal/src/components/common/ui-floating-action-button/ui-secondary-floating-action-button.tsx
import React11 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSBadgeNotification, EGDSNotificationBadge1 as EGDSNotificationBadge12 } from "@egds/react-core/badge";
import { EGDSSecondaryButton as EGDSSecondaryButton2 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
var __Fragment11 = gql15(_templateObject16(), clientSideImpressionEventAnalyticsFragment, clientSideAnalyticsFragment, Icon.fragment);
var Badge = function (param) {
  var badge = param.badge,
    withUpdatedNotification = param.withUpdatedNotification;
  if (withUpdatedNotification) {
    return /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React11.createElement(EGDSLayoutPosition, {
      type: "relative",
      position: {
        right: "one",
        bottom: "half"
      }
    }, /* @__PURE__ */React11.createElement(EGDSBadgeNotification, {
      count: badge.toString(),
      theme: "action",
      visible: true
    })));
  }
  return /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React11.createElement(EGDSNotificationBadge12, {
    text: badge.toString()
  }));
};
var UISecondaryFloatingActionButton = function (props) {
  var data = props.data,
    onClick = props.onClick,
    isFullWidth = props.isFullWidth,
    size = props.size,
    withUpdatedNotification = props.withUpdatedNotification,
    triggerRef = props.triggerRef;
  var primary = data.primary,
    icon = data.icon,
    badge = data.badge,
    analytics = data.analytics,
    egdsElementId = data.egdsElementId;
  var track = useClickTracker8();
  var handleClick = React11.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  }, [analytics, onClick, track]);
  return /* @__PURE__ */React11.createElement(EGDSSecondaryButton2, {
    isFullWidth: isFullWidth,
    onClick: handleClick,
    size: size,
    "data-test-id": egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
    domRef: triggerRef
  }, /* @__PURE__ */React11.createElement(EGDSLayoutFlex2, {
    space: withUpdatedNotification && !!badge ? "six" : "two"
  }, !!badge && /* @__PURE__ */React11.createElement(Badge, {
    badge: badge,
    withUpdatedNotification: withUpdatedNotification
  }), icon && !badge && /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React11.createElement(Icon, {
    data: icon
  })), /* @__PURE__ */React11.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React11.createElement("div", null, primary))));
};
UISecondaryFloatingActionButton.displayName = "UISecondaryFloatingActionButton";
UISecondaryFloatingActionButton.fragment = __Fragment11;
// ../internal/src/components/common/ui-floating-action-button/ui-floating-action-button.tsx
var __Fragment12 = gql16(_templateObject17(), UIPrimaryFloatingActionButton.fragment, UISecondaryFloatingActionButton.fragment);
var UIFloatingActionButtonImplementationsMap = {
  UIPrimaryFloatingActionButton: UIPrimaryFloatingActionButton,
  UISecondaryFloatingActionButton: UISecondaryFloatingActionButton
};
var UIFloatingActionButton = function (param) {
  var onClick = param.onClick,
    _param_isFullWidth = param.isFullWidth,
    isFullWidth = _param_isFullWidth === void 0 ? false : _param_isFullWidth,
    _param_size = param.size,
    size = _param_size === void 0 ? EGDSButtonSize.MEDIUM : _param_size,
    data = param.data,
    withUpdatedNotification = param.withUpdatedNotification,
    triggerRef = param.triggerRef;
  var __typename = data.__typename;
  var Button = UIFloatingActionButtonImplementationsMap[__typename];
  if (Button) {
    return /* @__PURE__ */React12.createElement(Button, {
      onClick: onClick,
      isFullWidth: isFullWidth,
      size: size,
      data: data,
      withUpdatedNotification: withUpdatedNotification,
      triggerRef: triggerRef
    });
  }
  return null;
};
UIFloatingActionButton.displayName = "UIFloatingActionButton";
UIFloatingActionButton.fragment = __Fragment12;
// ../internal/src/components/common/containers-fragment.ts
var dialogContainerFragment = gql17(_templateObject18(), Toolbar.fragment, UIFloatingActionButton.fragment);
var centeredSheetAIContainerFragment = gql17(_templateObject19(), Toolbar.fragment, UIFloatingActionButton.fragment, SortAndFilterEGDSSecondaryButton.fragment);
var containersFragment = gql17(_templateObject20(), dialogContainerFragment, centeredSheetAIContainerFragment);
// ../internal/src/components/common/sticky-wrapper.tsx
import React13 from "react";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSSticky } from "@egds/react-core/sticky";
import { EGDSViewRow } from "@egds/react-core/view";
import { useViewportMap } from "@shared-ui/viewport-context";
var StickyWrapper = function (param) {
  var children = param.children,
    isDialogOpen = param.isDialogOpen,
    _param_stickyByViewsize = param.stickyByViewsize,
    stickyByViewsize = _param_stickyByViewsize === void 0 ? {} : _param_stickyByViewsize,
    _param_spacing = param.spacing,
    spacing = _param_spacing === void 0 ? {} : _param_spacing,
    disabled = param.disabled;
  var _React13_useState = _sliced_to_array(React13.useState(false), 2),
    fixed = _React13_useState[0],
    setFixed = _React13_useState[1];
  var _useViewportMap;
  var isStickyViewportWidth = (_useViewportMap = useViewportMap(stickyByViewsize)) !== null && _useViewportMap !== void 0 ? _useViewportMap : false;
  if (!isStickyViewportWidth || disabled) {
    return /* @__PURE__ */React13.createElement(EGDSSpacing2, _object_spread({}, spacing), children);
  }
  return /* @__PURE__ */React13.createElement(EGDSSticky, {
    zIndex: isDialogOpen ? void 0 : 500,
    onFixed: setFixed
  }, /* @__PURE__ */React13.createElement(EGDSSpacing2, {
    padding: {
      inline: "unset"
    }
  }, /* @__PURE__ */React13.createElement(EGDSViewRow, {
    layout: "fullwidth",
    canvasTheme: fixed ? "primary" : "none"
  }, /* @__PURE__ */React13.createElement(EGDSSpacing2, _object_spread_props(_object_spread({}, spacing), {
    border: [fixed ? "blockend" : "unset"]
  }), children))));
};
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-button-and-sheet.tsx
import React16 from "react";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSToolbar as EGDSToolbar2 } from "@egds/react-core/toolbar";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-button.tsx
import React14 from "react";
import { EGDSButtonSize as EGDSButtonSize2, EGDSSecondaryButton as EGDSSecondaryButton3 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon3 } from "@egds/react-core/icons";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { useExperiment } from "@shared-ui/experiment-context";
var AISearchButton = function (param) {
  var onClick = param.onClick,
    domRef = param.domRef,
    shouldAddMarginRight = param.shouldAddMarginRight,
    primary = param.primary,
    className = param.className,
    disabled = param.disabled;
  var isAiFiltersVisualIdentityUpdate = useExperiment("AI_Filters_Visual_Identity_Update").exposure.bucket === 1;
  var button = /* @__PURE__ */React14.createElement(EGDSSecondaryButton3, {
    disabled: disabled,
    onClick: onClick,
    domRef: domRef,
    size: EGDSButtonSize2.SMALL,
    style: {
      whiteSpace: "nowrap"
    },
    className: className
  }, /* @__PURE__ */React14.createElement(EGDSIcon3, {
    name: isAiFiltersVisualIdentityUpdate ? "ai" : "icon__romie"
  }), primary || "");
  return /* @__PURE__ */React14.createElement(EGDSSpacing3, {
    margin: {
      inlineend: shouldAddMarginRight ? "two" : "unset"
    }
  }, button);
};
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-section.tsx
import React15 from "react";
import { EGDSActionListItem } from "@egds/react-core/action-list-item";
import { EGDSBadgeStandard } from "@egds/react-core/badge";
import { EGDSButtonSize as EGDSButtonSize3, EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon4, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSTextArea } from "@egds/react-core/input";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText } from "@egds/react-core/text";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-utils.ts
var defaultSuggestions = ["Top rated properties", "Breakfast included", "Family friendly hotels"];
var getTnlSuggestions = function (fields) {
  var suggestions = fields === null || fields === void 0 ? void 0 : fields.filter(function (param) {
    var key = param.key;
    return key.startsWith("ai_search_suggestion_");
  }).map(function (param) {
    var value = param.value;
    return value;
  });
  if (!(suggestions === null || suggestions === void 0 ? void 0 : suggestions.length)) {
    return defaultSuggestions;
  }
  return suggestions;
};
var getSearchInput = function (fields) {
  var _fields_find;
  return fields === null || fields === void 0 ? void 0 : (_fields_find = fields.find(function (param) {
    var key = param.key;
    return key === "ai_search_input";
  })) === null || _fields_find === void 0 ? void 0 : _fields_find.value;
};
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-section.tsx
var getSubtextSpacing = function () {
  var isSmallViewSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false,
    isAiFiltersVisualIdentityUpdate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  if (isSmallViewSize && isAiFiltersVisualIdentityUpdate) {
    return {
      blockstart: "two"
    };
  }
  if (isAiFiltersVisualIdentityUpdate) {
    return {
      blockstart: "one"
    };
  }
  return void 0;
};
var getSubtext = function (subtext) {
  var isSmallViewSize = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false,
    isAiFiltersVisualIdentityUpdate = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (isSmallViewSize && isAiFiltersVisualIdentityUpdate) {
    return subtext;
  }
  if (isAiFiltersVisualIdentityUpdate) {
    return "Let us know what you\u2019re looking for to find your perfect stay.";
  }
  return subtext;
};
var getContentSpacing = function (defaults, isSmallViewSize, isAiFiltersVisualIdentityUpdate) {
  if (isSmallViewSize) {
    return defaults;
  }
  return _object_spread_props(_object_spread({}, defaults !== null && defaults !== void 0 ? defaults : {}), {
    padding: {
      blockstart: isAiFiltersVisualIdentityUpdate ? "four" : "two"
    }
  });
};
var AISearchSection = function (param) {
  var textInputLabel = param.textInputLabel,
    buttonAriaLabel = param.buttonAriaLabel,
    listTitle = param.listTitle,
    onActionListItemClick = param.onActionListItemClick,
    onTextInputChange = param.onTextInputChange,
    onSubmit = param.onSubmit,
    badgeText = param.badgeText,
    errorStateString = param.errorStateString,
    sectionTitle = param.sectionTitle,
    sectionSpacing = param.sectionSpacing,
    contentSpacing = param.contentSpacing,
    tnlFields = param.tnlFields,
    showSuggestions = param.showSuggestions,
    isSmallViewSize = param.isSmallViewSize,
    subtext = param.subtext,
    _param_placeholder = param.placeholder,
    placeholder = _param_placeholder === void 0 ? "" : _param_placeholder,
    isAiFiltersVisualIdentityUpdate = param.isAiFiltersVisualIdentityUpdate;
  var searchInput = getSearchInput(tnlFields);
  var _React15_useState = _sliced_to_array(React15.useState(searchInput !== null && searchInput !== void 0 ? searchInput : ""), 2),
    textInputValue = _React15_useState[0],
    setTextInputValue = _React15_useState[1];
  var _React15_useState1 = _sliced_to_array(React15.useState(errorStateString), 2),
    errorStateStringTracked = _React15_useState1[0],
    setErrorStateStringTracked = _React15_useState1[1];
  var _React15_useState2 = _sliced_to_array(React15.useState(0), 2),
    submitButtonMargin = _React15_useState2[0],
    setSubmitButtonMargin = _React15_useState2[1];
  var maxCharacterLimit = 100;
  var overCharacterLimit = textInputValue.length > maxCharacterLimit;
  var track = useClickTracker9();
  var suggestions = getTnlSuggestions(tnlFields);
  var searchBarRef = React15.useRef(null);
  var firstRender = React15.useRef(true);
  var calculateInvalidValue = function () {
    if (errorStateStringTracked) {
      return {
        primary: errorStateStringTracked,
        secondary: ""
      };
    }
    if (overCharacterLimit) {
      return {
        primary: "",
        secondary: "".concat(textInputValue.length, "/").concat(maxCharacterLimit)
      };
    }
    return void 0;
  };
  var invalidValue = calculateInvalidValue();
  var isInvalid = Boolean(invalidValue);
  var isCTADisabled = textInputValue.length <= 0 || isInvalid || textInputValue === searchInput;
  React15.useEffect(function () {
    setTextInputValue(searchInput !== null && searchInput !== void 0 ? searchInput : "");
  }, [tnlFields]);
  React15.useEffect(function () {
    setErrorStateStringTracked(errorStateString);
    if (errorStateString && firstRender.current) {
      track("HOT.SR.AISearch.Error", "AI Search dialog error");
    }
    firstRender.current = false;
  }, [errorStateString]);
  React15.useEffect(function () {
    var newButtonMargin = 0;
    if (isInvalid) {
      var _searchBarRef_current;
      var textAreaError = (_searchBarRef_current = searchBarRef.current) === null || _searchBarRef_current === void 0 ? void 0 : _searchBarRef_current.querySelector(".uitk-field-messages");
      newButtonMargin = textAreaError ? textAreaError.getBoundingClientRect().height : 0;
    }
    setSubmitButtonMargin(newButtonMargin);
  }, [isInvalid]);
  var handleTextInputChange = function (e) {
    setErrorStateStringTracked("");
    onTextInputChange === null || onTextInputChange === void 0 ? void 0 : onTextInputChange();
    var curentTextInputValue = e.target.value;
    var textInputValueNoLineBreak = curentTextInputValue.replace(/\n+$/, "");
    setTextInputValue(textInputValueNoLineBreak);
  };
  var handleSubmit = function () {
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(textInputValue);
    track("HOT.SR.AISearch.".concat(textInputValue, ".Applied"), "AI Search user string submitted");
  };
  var handleKeyDown = function (e) {
    if (e.key === "Enter") {
      if (isCTADisabled) {
        e.preventDefault();
      } else {
        handleSubmit();
      }
    }
  };
  var handleActionListItemClick = function (suggestion) {
    onActionListItemClick === null || onActionListItemClick === void 0 ? void 0 : onActionListItemClick(suggestion);
    track("HOT.SR.AISearch.DS.".concat(suggestion, ".Applied"), "AI Search suggestion submitted");
  };
  var handleActionListItemKeyUp = function (e, suggestion) {
    if (e.key === "Enter") {
      handleActionListItemClick(suggestion);
    }
  };
  var handleFocus = function () {
    track("HOT.SR.AISearch.Focused", "AI Search focused");
  };
  return /* @__PURE__ */React15.createElement(EGDSSpacing4, _object_spread({}, sectionSpacing), /* @__PURE__ */React15.createElement("div", null, (!isSmallViewSize && isAiFiltersVisualIdentityUpdate || isSmallViewSize && !isAiFiltersVisualIdentityUpdate) && badgeText && /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    margin: {
      blockend: "one"
    }
  }, /* @__PURE__ */React15.createElement(EGDSBadgeStandard, {
    text: badgeText,
    size: isAiFiltersVisualIdentityUpdate ? "small" : "large"
  })), sectionTitle && /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    padding: {
      blockstart: isAiFiltersVisualIdentityUpdate && !isSmallViewSize ? "half" : void 0
    }
  }, /* @__PURE__ */React15.createElement(EGDSLayoutFlex3, {
    direction: "row",
    space: isSmallViewSize ? "small" : "xsmall",
    alignItems: "center"
  }, /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    padding: {
      blockstart: isAiFiltersVisualIdentityUpdate && !isSmallViewSize ? "one" : void 0,
      blockend: isAiFiltersVisualIdentityUpdate && !isSmallViewSize ? "one" : void 0
    }
  }, /* @__PURE__ */React15.createElement(EGDSHeading, {
    tag: "h3",
    size: isAiFiltersVisualIdentityUpdate && isSmallViewSize ? 6 : 5,
    typeStyle: isAiFiltersVisualIdentityUpdate && isSmallViewSize ? {
      customStyle: "display-small",
      customTheme: "standard"
    } : void 0
  }, isAiFiltersVisualIdentityUpdate ? "Find your perfect stay" : sectionTitle))), (isSmallViewSize && isAiFiltersVisualIdentityUpdate || !isAiFiltersVisualIdentityUpdate) && badgeText && /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React15.createElement(EGDSBadgeStandard, {
    text: badgeText,
    size: "small"
  })))), subtext && (isSmallViewSize && !isAiFiltersVisualIdentityUpdate ? /* @__PURE__ */React15.createElement(EGDSHeading, {
    size: 7
  }, subtext) : /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    padding: getSubtextSpacing(isSmallViewSize, isAiFiltersVisualIdentityUpdate)
  }, /* @__PURE__ */React15.createElement(EGDSText, {
    weight: "regular",
    theme: "standard"
  }, getSubtext(subtext, isSmallViewSize, isAiFiltersVisualIdentityUpdate)))), /* @__PURE__ */React15.createElement(EGDSSpacing4, _object_spread({}, getContentSpacing(contentSpacing, isSmallViewSize, isAiFiltersVisualIdentityUpdate)), /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSLayoutFlex3, {
    alignItems: "center",
    space: "two",
    domRef: searchBarRef
  }, /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem3, {
    grow: 1
  }, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSTextArea, {
    id: "aiSearch",
    label: textInputLabel,
    name: "aiSearchDemo",
    value: textInputValue,
    onChange: handleTextInputChange,
    onKeyDown: handleKeyDown,
    invalid: invalidValue,
    onFocus: handleFocus,
    maxRows: 2,
    placeholder: placeholder
  }))), /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React15.createElement(EGDSPrimaryButton2, {
    disabled: isCTADisabled,
    size: EGDSButtonSize3.MEDIUM,
    onClick: handleSubmit,
    "aria-label": buttonAriaLabel,
    style: {
      marginBlockEnd: "".concat(submitButtonMargin, "px")
    }
  }, /* @__PURE__ */React15.createElement(EGDSIcon4, {
    name: "search"
  })))), showSuggestions && /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React15.createElement(EGDSLayoutFlex3, {
    direction: "column",
    space: isAiFiltersVisualIdentityUpdate ? "four" : void 0
  }, !isAiFiltersVisualIdentityUpdate && /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React15.createElement(EGDSHeading, {
    size: 7
  }, listTitle)), suggestions.map(function (suggestion) {
    return /* @__PURE__ */React15.createElement(EGDSSpacing4, {
      padding: isAiFiltersVisualIdentityUpdate ? {
        block: "unset",
        inline: "unset"
      } : void 0,
      style: isAiFiltersVisualIdentityUpdate ? {
        minBlockSize: "unset"
      } : void 0,
      key: suggestion
    }, /* @__PURE__ */React15.createElement(EGDSActionListItem, {
      "aria-label": suggestion
    }, /* @__PURE__ */React15.createElement(EGDSLayoutFlex3, {
      alignItems: "center",
      space: "two",
      onClick: function () {
        return handleActionListItemClick === null || handleActionListItemClick === void 0 ? void 0 : handleActionListItemClick(suggestion);
      },
      onKeyUp: function (e) {
        return handleActionListItemKeyUp(e, suggestion);
      },
      tabIndex: 0
    }, /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSIcon4, {
      size: isAiFiltersVisualIdentityUpdate ? EGDSIconSize2.EXTRA_SMALL : void 0,
      name: "search"
    }))), /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSText, null, suggestion))))));
  })))))));
};
// ../internal/src/components/sort-filter/__private/__fragments/ai-search/ai-search-button-and-sheet.tsx
var AISearchButtonAndSheet = function (param) {
  var dialogAriaLabel = param.dialogAriaLabel,
    onTriggerClick = param.onTriggerClick,
    onActionListItemClick = param.onActionListItemClick,
    onTextInputChange = param.onTextInputChange,
    onSubmit = param.onSubmit,
    shouldAddMarginRight = param.shouldAddMarginRight,
    onSheetClose = param.onSheetClose,
    closeButtonAriaLabel = param.closeButtonAriaLabel,
    errorStateString = param.errorStateString,
    setErrorStateString = param.setErrorStateString,
    tnlFields = param.tnlFields,
    className = param.className,
    isSmallViewSize = param.isSmallViewSize,
    disabled = param.disabled;
  var triggerRef = React16.useRef(null);
  var _useDialog = _sliced_to_array(useDialog("ai-search-dialog"), 3),
    isAISearchOpen = _useDialog[0],
    _useDialog_ = _useDialog[1],
    openAISearchDialog = _useDialog_.openDialog,
    closeAISearchDialog = _useDialog_.closeDialog,
    AISearchDialogComponent = _useDialog[2];
  var track = useClickTracker10();
  var isAiFiltersVisualIdentityUpdate = useExperiment2("AI_Filters_Visual_Identity_Update").exposure.bucket === 1;
  React16.useEffect(function () {
    if (errorStateString) {
      openAISearchDialog();
    }
  }, [errorStateString]);
  var handleTriggerClick = function () {
    onTriggerClick === null || onTriggerClick === void 0 ? void 0 : onTriggerClick();
    openAISearchDialog();
    track("HOT.SR.AISearch.Open", "AI Search dialog open");
  };
  var handleCloseButtonClick = function () {
    track("HOT.SR.AISearch.Closed", "AI Search dialog closed");
    closeAISearchDialog();
  };
  var handleActionListItemClick = function (suggestion) {
    onActionListItemClick === null || onActionListItemClick === void 0 ? void 0 : onActionListItemClick(suggestion);
  };
  var handleSubmit = function (textInputValue) {
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(textInputValue);
  };
  var handleSheetClose = function () {
    onSheetClose === null || onSheetClose === void 0 ? void 0 : onSheetClose();
    setErrorStateString === null || setErrorStateString === void 0 ? void 0 : setErrorStateString(void 0);
  };
  return /* @__PURE__ */React16.createElement(React16.Fragment, null, /* @__PURE__ */React16.createElement(AISearchButton, {
    primary: isAiFiltersVisualIdentityUpdate ? "AI filters" : "AI Search",
    onClick: handleTriggerClick,
    domRef: triggerRef,
    shouldAddMarginRight: shouldAddMarginRight,
    className: className,
    disabled: disabled
  }), /* @__PURE__ */React16.createElement(EGDSSheetTransition, {
    isVisible: isAISearchOpen,
    closeCallback: handleSheetClose
  }, /* @__PURE__ */React16.createElement(AISearchDialogComponent, null, /* @__PURE__ */React16.createElement(EGDSSheet, {
    type: "full",
    triggerRef: triggerRef,
    isVisible: isAISearchOpen,
    ariaLabel: dialogAriaLabel
  }, /* @__PURE__ */React16.createElement(EGDSToolbar2, {
    toolbarTitle: isAiFiltersVisualIdentityUpdate ? "AI filters" : "AI Search",
    navigationContent: {
      onClick: handleCloseButtonClick,
      navIconLabel: closeButtonAriaLabel
    }
  }), /* @__PURE__ */React16.createElement(EGDSSheetContent, {
    padded: false
  }, /* @__PURE__ */React16.createElement(AISearchSection, {
    textInputLabel: "I'm looking for...",
    buttonAriaLabel: "search",
    listTitle: "Try these",
    badgeText: "Beta",
    sectionTitle: isAiFiltersVisualIdentityUpdate ? "Find your perfect stay" : void 0,
    subtext: isAiFiltersVisualIdentityUpdate ? "Let us know what you\u2019re looking for and we\u2019ll help you find your perfect stay." : "Describe your ideal stay to get the best matches",
    onActionListItemClick: handleActionListItemClick,
    onTextInputChange: onTextInputChange,
    onSubmit: handleSubmit,
    errorStateString: errorStateString,
    tnlFields: tnlFields,
    isSmallViewSize: isSmallViewSize,
    sectionSpacing: {
      padding: {
        inline: "six",
        blockstart: isAiFiltersVisualIdentityUpdate ? "six" : "three",
        blockend: "six"
      }
    },
    contentSpacing: {
      padding: {
        blockstart: isAiFiltersVisualIdentityUpdate ? "six" : "two"
      }
    },
    showSuggestions: true,
    isAiFiltersVisualIdentityUpdate: isAiFiltersVisualIdentityUpdate,
    placeholder: isAiFiltersVisualIdentityUpdate ? "Hotels with breakfast" : void 0
  }))))));
};
// ../internal/src/components/sort-filter/__private/__fragments/filter-sheet-footer/all-filter-sheet-footer.tsx
import React17 from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSParagraph } from "@egds/react-core/text";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
var __Fragment13 = gql18(_templateObject21(), UIFloatingActionButton.fragment);
var AllFilterSheetFooter = function (param) {
  var data = param.data,
    viewType4 = param.viewType,
    onClick = param.onClick,
    footerDataLoading = param.footerDataLoading,
    isButtonTracked = param.isButtonTracked;
  var footerLabel = data.footerLabel,
    containers = data.containers;
  var _containers_find;
  var applyAction = ((_containers_find = containers === null || containers === void 0 ? void 0 : containers.find(function (container) {
    return container.__typename === "ShoppingSortAndFilterDialogContainer" && container.view === viewType4;
  })) !== null && _containers_find !== void 0 ? _containers_find : {}).applyAction;
  var showResultsCount = footerLabel;
  if ((applyAction === null || applyAction === void 0 ? void 0 : applyAction.__typename) !== "UIPrimaryFloatingActionButton") {
    return null;
  }
  var _applyAction_impressionAnalytics;
  var _ref = (_applyAction_impressionAnalytics = applyAction.impressionAnalytics) !== null && _applyAction_impressionAnalytics !== void 0 ? _applyAction_impressionAnalytics : {},
    _ref_referrerId = _ref.referrerId,
    referrerId = _ref_referrerId === void 0 ? "" : _ref_referrerId,
    linkName = _ref.linkName;
  var buttonData = footerDataLoading ? _object_spread_props(_object_spread({}, applyAction), {
    disabled: true
  }) : applyAction;
  return /* @__PURE__ */React17.createElement(EGDSSpacing5, {
    padding: {
      small: "four",
      large: {
        inline: "six"
      }
    },
    border: ["blockstart"]
  }, /* @__PURE__ */React17.createElement(EGDSLayoutFlex4, {
    justifyContent: showResultsCount ? "space-between" : "end",
    alignItems: "center"
  }, showResultsCount && /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem4, null, footerDataLoading ? /* @__PURE__ */React17.createElement(EGDSLineSkeleton, null) : /* @__PURE__ */React17.createElement(EGDSParagraph, null, footerLabel)), /* @__PURE__ */React17.createElement(EGDSLayoutFlexItem4, null, isButtonTracked ? /* @__PURE__ */React17.createElement(IntersectionTracker, {
    referrerId: referrerId,
    linkName: linkName !== null && linkName !== void 0 ? linkName : ""
  }, /* @__PURE__ */React17.createElement(UIFloatingActionButton, {
    data: buttonData,
    onClick: onClick,
    withUpdatedNotification: true
  })) : /* @__PURE__ */React17.createElement(UIFloatingActionButton, {
    data: buttonData,
    onClick: onClick,
    withUpdatedNotification: true
  }))));
};
AllFilterSheetFooter.displayName = "AllFilterSheetFooter";
AllFilterSheetFooter.fragment = __Fragment13;
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filters.tsx
import React50 from "react";
import { gql as gql48 } from "@apollo/client";
import { useExperiment as useExperiment7 } from "@shared-ui/experiment-context";
import { defaultViewSizes as defaultViewSizes4, useMediaQueries as useMediaQueries4 } from "@shared-ui/viewport-context";
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filter-field.tsx
import React47 from "react";
import { gql as gql45 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem11 } from "@egds/react-core/layout-flex";
import { EGDSSheetContent as EGDSSheetContent2 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading13 } from "@egds/react-core/text";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { useExperiment as useExperiment6 } from "@shared-ui/experiment-context";
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2 } from "@shared-ui/viewport-context";
// ../internal/src/components/sort-filter/__private/__fragments/context/utils.ts
var updateSliderValueForMutex = function (field, action) {
  if ((field === null || field === void 0 ? void 0 : field.__typename) === "ShoppingMutexField") {
    var _field_options;
    var _field_options_map;
    return _object_spread_props(_object_spread({}, field), {
      options: (_field_options_map = (_field_options = field.options) === null || _field_options === void 0 ? void 0 : _field_options.map(function (option) {
        var mutexOption = option.mutexOption;
        if (mutexOption.__typename === "ShoppingRangeField") {
          var _mutexOption_range;
          return _object_spread_props(_object_spread({}, option), {
            mutexOption: _object_spread_props(_object_spread({}, mutexOption), {
              range: ((_mutexOption_range = mutexOption.range) === null || _mutexOption_range === void 0 ? void 0 : _mutexOption_range.id) === action.id ? _object_spread_props(_object_spread({}, mutexOption.range), {
                selected: action.min !== -1 && action.max !== -1 ? _object_spread_props(_object_spread({}, mutexOption.range.selected), {
                  min: action.min,
                  max: action.max
                }) : _object_spread_props(_object_spread({}, mutexOption.range.selected), {
                  min: mutexOption.range.characteristics.min,
                  max: mutexOption.range.characteristics.max
                })
              }) : mutexOption.range
            })
          });
        }
        if (mutexOption.__typename === "ShoppingRangeTextInputField") {
          var _mutexOption_rangeField;
          return _object_spread_props(_object_spread({}, option), {
            mutexOption: _object_spread_props(_object_spread({}, mutexOption), {
              rangeField: ((_mutexOption_rangeField = mutexOption.rangeField) === null || _mutexOption_rangeField === void 0 ? void 0 : _mutexOption_rangeField.id) === action.id ? _object_spread_props(_object_spread({}, mutexOption.rangeField), {
                selected: action.min !== -1 && action.max !== -1 ? _object_spread_props(_object_spread({}, mutexOption.rangeField.selected), {
                  min: action.min,
                  max: action.max
                }) : _object_spread_props(_object_spread({}, mutexOption.rangeField.selected), {
                  min: mutexOption.rangeField.characteristics.min,
                  max: mutexOption.rangeField.characteristics.max
                })
              }) : mutexOption.rangeField
            })
          });
        }
        return option;
      })) !== null && _field_options_map !== void 0 ? _field_options_map : null
    });
  }
  return field;
};
var resetSliderValueForMutex = function (field) {
  if ((field === null || field === void 0 ? void 0 : field.__typename) === "ShoppingMutexField") {
    var _field_options;
    var _field_options_map;
    return _object_spread_props(_object_spread({}, field), {
      options: (_field_options_map = (_field_options = field.options) === null || _field_options === void 0 ? void 0 : _field_options.map(function (option) {
        var mutexOption = option.mutexOption;
        if (mutexOption.__typename === "ShoppingRangeField") {
          var _mutexOption_range;
          return _object_spread_props(_object_spread({}, option), {
            mutexOption: _object_spread_props(_object_spread({}, mutexOption), {
              range: ((_mutexOption_range = mutexOption.range) === null || _mutexOption_range === void 0 ? void 0 : _mutexOption_range.id) ? _object_spread_props(_object_spread({}, mutexOption.range), {
                selected: _object_spread_props(_object_spread({}, mutexOption.range.selected), {
                  min: mutexOption.range.characteristics.min,
                  max: mutexOption.range.characteristics.max
                })
              }) : null
            })
          });
        }
        if (mutexOption.__typename === "ShoppingRangeTextInputField") {
          return _object_spread_props(_object_spread({}, option), {
            mutexOption: _object_spread_props(_object_spread({}, mutexOption), {
              rangeField: _object_spread_props(_object_spread({}, mutexOption.rangeField), {
                selected: _object_spread_props(_object_spread({}, mutexOption.rangeField.selected), {
                  min: mutexOption.rangeField.characteristics.min,
                  max: mutexOption.rangeField.characteristics.max
                })
              })
            })
          });
        }
        return option;
      })) !== null && _field_options_map !== void 0 ? _field_options_map : null
    });
  }
  return field;
};
var calculateQuickFilterFields = function (fields) {
  var clearQuickFilterFields = [];
  fields === null || fields === void 0 ? void 0 : fields.forEach(function (field) {
    switch (field.__typename) {
      case "ShoppingStepInputField":
        clearQuickFilterFields.push({
          key: "".concat(field.stepInputId)
        });
        break;
      case "ShoppingRangeField":
        clearQuickFilterFields.push({
          key: field.range.id
        });
        break;
      case "ShoppingMutexField":
        field.options.forEach(function (option) {
          if (option.mutexOption.range) {
            clearQuickFilterFields.push({
              key: "".concat(option.mutexOption.range.id)
            });
          }
          if (option.mutexOption.rangeField) {
            clearQuickFilterFields.push({
              key: "".concat(option.mutexOption.rangeField.id)
            });
          }
        });
        break;
      case "ShoppingRangeTextInputField":
        clearQuickFilterFields.push({
          key: field.fieldId
        });
        break;
      case "ShoppingMultiSelectionField":
      case "ShoppingSelectionField":
        field.options.forEach(function (option) {
          clearQuickFilterFields.push({
            key: option.fieldId,
            value: option.value
          });
        });
        break;
      case "ShoppingMultiSelectionTileField":
        field.multiOptions.forEach(function (option) {
          clearQuickFilterFields.push({
            key: option.fieldId,
            value: option.value
          });
        });
        break;
      case "ShoppingMultiSelectionStackedTileField":
        field.multiOptions.forEach(function (option) {
          clearQuickFilterFields.push({
            key: option.fieldId
          });
        });
        break;
      default:
    }
  });
  return clearQuickFilterFields;
};
// ../internal/src/components/common/egds-pill/egds-pill.tsx
import React20 from "react";
import { gql as gql21 } from "@apollo/client";
// ../internal/src/components/common/egds-pill/egds-basic-pill.tsx
import React18, { useRef } from "react";
import { gql as gql19 } from "@apollo/client";
import { useFormCallback } from "@egds/react-core/form";
import { EGDSPill } from "@egds/react-core/pill";
import { liveAnnounce } from "@egds/react-core/utils";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
var EGDS_BASIC_PILL_PREFIX = "EGDSBasicPill";
var __Fragment14 = gql19(_templateObject22(), clientSideAnalyticsFragment, Icon.fragment);
var EGDSBasicPill = function (props) {
  var data = props.data,
    onChange = props.onChange,
    triggerPill = props.triggerPill,
    onClick = props.onClick,
    active = props.active,
    className = props.className;
  var accessibility = data.accessibility,
    name = data.name,
    primary = data.primary,
    selected = data.selected,
    value = data.value,
    disabled = data.disabled,
    icon = data.icon,
    selectAnalytics = data.selectAnalytics,
    deselectAnalytics = data.deselectAnalytics,
    selectedText = data.selectedText;
  var clickTracker = useClickTracker11();
  var id = name !== null && name !== void 0 ? name : "egds-basic-pill";
  var _React18_useState = _sliced_to_array(React18.useState(selected), 2),
    checked = _React18_useState[0],
    setCheckState = _React18_useState[1];
  var pillRef = useRef(false);
  var onPillSelectText = selectedText || primary;
  var handleOnChange = useFormCallback(id, function (event) {
    var _event_currentTarget = event.currentTarget,
      newSelection = _event_currentTarget.checked;
    setCheckState(newSelection);
    if (!pillRef.current) {
      pillRef.current = true;
    }
    if (onChange) {
      onChange(event);
    }
    if (selectAnalytics && newSelection) {
      var linkName = selectAnalytics.linkName,
        referrerId = selectAnalytics.referrerId,
        uisPrimeMessages = selectAnalytics.uisPrimeMessages;
      clickTracker(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
      return event;
    }
    if (deselectAnalytics && !newSelection) {
      var linkName1 = deselectAnalytics.linkName,
        referrerId1 = deselectAnalytics.referrerId,
        uisPrimeMessages1 = deselectAnalytics.uisPrimeMessages;
      clickTracker(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    return event;
  });
  var handleOnClick = function () {
    if (onClick) {
      onClick();
    }
  };
  React18.useEffect(function () {
    if (pillRef.current) {
      liveAnnounce(accessibility !== null && accessibility !== void 0 ? accessibility : void 0);
    }
  }, [accessibility, pillRef.current]);
  React18.useEffect(function () {
    setCheckState(selected);
  }, [selected]);
  return /* @__PURE__ */React18.createElement(EGDSPill, {
    checked: checked,
    active: active,
    disabled: disabled,
    icon: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "",
    id: id,
    name: "".concat(EGDS_BASIC_PILL_PREFIX, "-").concat(name),
    onChange: handleOnChange,
    value: value !== null && value !== void 0 ? value : "",
    altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
    triggerPill: triggerPill,
    onClick: handleOnClick,
    className: className
  }, checked ? onPillSelectText : primary);
};
EGDSBasicPill.displayName = "EGDSBasicPill";
EGDSBasicPill.fragment = _object_spread_props(_object_spread({}, __Fragment14), {
  __typename: "EGDSBasicPill"
});
// ../internal/src/components/common/egds-pill/egds-basic-trigger-pill.tsx
import React19 from "react";
import { gql as gql20 } from "@apollo/client";
import { useFormCallback as useFormCallback2 } from "@egds/react-core/form";
import { EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSPill as EGDSPill2 } from "@egds/react-core/pill";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
var EGDS_BASIC_TRIGGER_PILL_PREFIX = "EGDSBasicTriggerPill";
var __Fragment15 = gql20(_templateObject23(), clientSideAnalyticsFragment, Icon.fragment);
var EGDSBasicTriggerPill = function (param) {
  var data = param.data,
    triggerPill = param.triggerPill,
    onClick = param.onClick,
    domRef = param.domRef,
    active = param.active,
    _param_shouldRegisterToForm = param.shouldRegisterToForm,
    shouldRegisterToForm = _param_shouldRegisterToForm === void 0 ? true : _param_shouldRegisterToForm,
    className = param.className;
  var id = data.id,
    primary = data.primary,
    selected = data.selected,
    disabled = data.disabled,
    icon = data.icon,
    selectAnalytics = data.selectAnalytics,
    deselectAnalytics = data.deselectAnalytics,
    accessibility = data.accessibility;
  var clickTracker = useClickTracker12();
  var name = id !== null && id !== void 0 ? id : "egds-basic-pill";
  var _React19_useState = _sliced_to_array(React19.useState(active || selected), 2),
    checked = _React19_useState[0],
    setChecked = _React19_useState[1];
  React19.useEffect(function () {
    setChecked(active !== null && active !== void 0 ? active : false);
  }, [active]);
  var handleClick = function (event) {
    onClick === null || onClick === void 0 ? void 0 : onClick();
    if (selectAnalytics && checked) {
      var linkName = selectAnalytics.linkName,
        referrerId = selectAnalytics.referrerId,
        uisPrimeMessages = selectAnalytics.uisPrimeMessages;
      clickTracker(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    } else if (deselectAnalytics && !checked) {
      var linkName1 = deselectAnalytics.linkName,
        referrerId1 = deselectAnalytics.referrerId,
        uisPrimeMessages1 = deselectAnalytics.uisPrimeMessages;
      clickTracker(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    setChecked(!checked);
  };
  var handleClickRegistered = useFormCallback2(name, function (event) {
    handleClick(event);
    return event;
  });
  return /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem5, {
    shrink: 0
  }, /* @__PURE__ */React19.createElement(EGDSPill2, {
    checked: checked,
    active: checked,
    selected: selected,
    disabled: disabled,
    icon: (icon === null || icon === void 0 ? void 0 : icon.__typename) === "Icon" ? icon.token : "",
    id: name,
    name: "".concat(EGDS_BASIC_TRIGGER_PILL_PREFIX, "-").concat(name),
    triggerPill: triggerPill,
    onClick: shouldRegisterToForm ? handleClickRegistered : handleClick,
    altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
    domRef: domRef,
    className: className
  }, primary));
};
EGDSBasicTriggerPill.displayName = "EGDSBasicTriggerPill";
EGDSBasicTriggerPill.fragment = __Fragment15;
// ../internal/src/components/common/egds-pill/egds-pill.tsx
var __Fragment16 = gql21(_templateObject24(), EGDSBasicPill.fragment, EGDSBasicTriggerPill.fragment, EGDSBasicRemovablePill.fragment);
var SortAndFilterEGDSPill = function (props) {
  var data = props.data;
  switch (data.__typename) {
    case "EGDSBasicPill":
      return /* @__PURE__ */React20.createElement(EGDSBasicPill, _object_spread_props(_object_spread({}, props), {
        data: data
      }));
    case "EGDSBasicTriggerPill":
      return /* @__PURE__ */React20.createElement(EGDSBasicTriggerPill, _object_spread_props(_object_spread({}, props), {
        data: data
      }));
    case "EGDSBasicRemovablePill":
      return /* @__PURE__ */React20.createElement(EGDSBasicRemovablePill, _object_spread_props(_object_spread({}, props), {
        data: data
      }));
    default:
      return null;
  }
};
SortAndFilterEGDSPill.displayName = "SortAndFilterEGDSPill";
SortAndFilterEGDSPill.fragment = __Fragment16;
// ../internal/src/components/sort-filter/quick-access-filter-wrappers.tsx
import React21 from "react";
import { EGDSSheet as EGDSSheet2, EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
// ../internal/src/components/sort-filter/__private/__fragments/hooks/use-window-size.tsx
import { useEffect, useState } from "react";
var useWindowSize = function () {
  var isClientSide = (typeof window === "undefined" ? "undefined" : _type_of(window)) === "object";
  var _useState = _sliced_to_array(useState(isClientSide ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {}), 2),
    windowSize = _useState[0],
    setWindowSize = _useState[1];
  var handleWindowResize = function () {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };
  useEffect(function () {
    window.addEventListener("resize", handleWindowResize);
    return function () {
      return window.removeEventListener("resize", handleWindowResize);
    };
  }, []);
  return windowSize;
};
// ../internal/src/components/sort-filter/quick-access-filter-wrappers.tsx
var QuickAccessFilterSheetWrapper = function (_param) {
  var children = _param.children,
    DialogComponent = _param.DialogComponent,
    sheetProps = _object_without_properties(_param, ["children", "DialogComponent"]);
  var _triggerRef_current;
  var triggerRef = sheetProps.triggerRef,
    isVisible = sheetProps.isVisible,
    onDismiss = sheetProps.onDismiss,
    lastQuickfilter = sheetProps.lastQuickfilter,
    isCenteredSheet = sheetProps.isCenteredSheet,
    isBottomSheet = sheetProps.isBottomSheet;
  var isSmallViewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  }) === defaultViewSizes.SMALL;
  var isMediumViewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  }) === defaultViewSizes.MEDIUM;
  var _useWindowSize = useWindowSize(),
    tmp = _useWindowSize.height,
    windowHeight = tmp === void 0 ? 0 : tmp;
  var _triggerRef_current_getBoundingClientRect;
  var _ref = (_triggerRef_current_getBoundingClientRect = triggerRef === null || triggerRef === void 0 ? void 0 : (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.getBoundingClientRect()) !== null && _triggerRef_current_getBoundingClientRect !== void 0 ? _triggerRef_current_getBoundingClientRect : {},
    tmp1 = _ref.bottom,
    triggerBottom = tmp1 === void 0 ? 0 : tmp1;
  var maxHeight = Math.max(windowHeight - triggerBottom - 160, 0);
  var popoverSheetProps = {
    position: {
      inline: isMediumViewSize && lastQuickfilter ? "trailing" : "leading",
      block: "trailing"
    },
    type: "popover",
    width: 400,
    applyBlockStartMargin: true,
    autoFocus: true,
    autoPosition: false,
    triggerRef: triggerRef,
    isVisible: isVisible,
    onDismiss: onDismiss,
    maxHeight: maxHeight
  };
  var bottomSheetProps = {
    type: "bottom",
    isVisible: isVisible,
    triggerRef: triggerRef,
    fullWidth: isMediumViewSize
  };
  var centeredSheetProps = {
    type: "centered",
    centeredSheetSize: "small",
    isVisible: isVisible,
    triggerRef: triggerRef
  };
  if (isSmallViewSize || isBottomSheet) {
    return /* @__PURE__ */React21.createElement(EGDSSheetTransition2, {
      isVisible: isVisible
    }, /* @__PURE__ */React21.createElement(DialogComponent, null, /* @__PURE__ */React21.createElement(EGDSSheet2, _object_spread({}, bottomSheetProps), children)));
  }
  if (isCenteredSheet) {
    return /* @__PURE__ */React21.createElement(EGDSSheetTransition2, {
      isVisible: isVisible
    }, /* @__PURE__ */React21.createElement(DialogComponent, null, /* @__PURE__ */React21.createElement(EGDSSheet2, _object_spread({}, centeredSheetProps), children)));
  }
  return /* @__PURE__ */React21.createElement(EGDSSheetTransition2, {
    isVisible: isVisible
  }, /* @__PURE__ */React21.createElement(EGDSSheet2, _object_spread({}, popoverSheetProps), children));
};
// ../internal/src/components/sort-filter/__private/__fragments/context/field-state-provider.tsx
import React22, { useMemo } from "react";
// ../internal/src/components/sort-filter/__private/__fragments/context/field-state-reducer.tsx
var fieldStateReducer = function (state, action) {
  switch (action.type) {
    case "RESET_STATE" /* RESET_STATE_FOR_MUTEX */:
      {
        var field = resetSliderValueForMutex(state.field);
        return _object_spread_props(_object_spread({}, state), {
          field: field
        });
      }
    case "UPDATE_SLIDER_VALUE" /* UPDATE_SLIDER_VALUE_FOR_MUTEX */:
      {
        var field1 = updateSliderValueForMutex(state.field, action);
        return _object_spread_props(_object_spread({}, state), {
          field: field1
        });
      }
    default:
      return state;
  }
};
// ../internal/src/components/sort-filter/__private/__fragments/context/field-state-provider.tsx
var FieldStateContext = React22.createContext({
  state: {}
});
var FieldStateProvider = function (param) {
  var children = param.children,
    field = param.field;
  var _React22_useReducer = _sliced_to_array(React22.useReducer(fieldStateReducer, {
      field: field
    }), 2),
    state = _React22_useReducer[0],
    dispatch = _React22_useReducer[1];
  var fieldStateContext = useMemo(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state, dispatch]);
  return /* @__PURE__ */React22.createElement(FieldStateContext.Provider, {
    value: fieldStateContext
  }, children);
};
var useFieldStateContext = function () {
  return React22.useContext(FieldStateContext);
};
// ../internal/src/components/sort-filter/__private/__fragments/dropdown-field.tsx
import React23 from "react";
import { gql as gql22 } from "@apollo/client";
import { useFormCallback as useFormCallback3 } from "@egds/react-core/form";
import { EGDSSelect } from "@egds/react-core/input";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
var __Fragment17 = gql22(_templateObject25(), clientSideAnalyticsFragment);
var DropdownField = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    onKeyPress = param.onKeyPress,
    onClick = param.onClick,
    resetFilters = param.resetFilters,
    hasNoSectionTitle = param.hasNoSectionTitle,
    loading = param.loading;
  var _data_dropdownOptions_find;
  var primary = data.primary,
    secondary = data.secondary,
    dropdownOptions = data.dropdownOptions;
  var _ref;
  var label = (_ref = primary !== null && primary !== void 0 ? primary : secondary) !== null && _ref !== void 0 ? _ref : "";
  var _dropdownOptions_;
  var _ref1 = (_dropdownOptions_ = dropdownOptions[0]) !== null && _dropdownOptions_ !== void 0 ? _dropdownOptions_ : {
      id: ""
    },
    id = _ref1.id,
    firstValue = _ref1.value;
  var defaultValue = Array.isArray(data.dropdownOptions) ? (_data_dropdownOptions_find = data.dropdownOptions.find(function (option) {
    return option.selected;
  })) === null || _data_dropdownOptions_find === void 0 ? void 0 : _data_dropdownOptions_find.value : firstValue;
  var _React23_useState = _sliced_to_array(React23.useState(defaultValue), 2),
    selectedFieldValue = _React23_useState[0],
    setSelectedFieldValue = _React23_useState[1];
  var clickTracker = useClickTracker13();
  var handleChange = useFormCallback3(id, function (event) {
    var selectedOption = dropdownOptions.find(function (value) {
      return value.value === event.currentTarget.value;
    });
    var deselectedOption = dropdownOptions.find(function (value) {
      return value.value === selectedFieldValue;
    });
    if (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.deselectAnalytics) {
      var _deselectedOption_deselectAnalytics = deselectedOption.deselectAnalytics,
        referrerId = _deselectedOption_deselectAnalytics.referrerId,
        linkName = _deselectedOption_deselectAnalytics.linkName,
        uisPrimeMessages = _deselectedOption_deselectAnalytics.uisPrimeMessages;
      clickTracker(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectAnalytics) {
      var _selectedOption_selectAnalytics = selectedOption.selectAnalytics,
        referrerId1 = _selectedOption_selectAnalytics.referrerId,
        linkName1 = _selectedOption_selectAnalytics.linkName,
        uisPrimeMessages1 = _selectedOption_selectAnalytics.uisPrimeMessages;
      clickTracker(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    setSelectedFieldValue(event.currentTarget.value);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  var handleOnClick = function () {
    var field = {
      name: id
    };
    onClick === null || onClick === void 0 ? void 0 : onClick(field);
  };
  var handleKeyDown = function (event) {
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
      event.stopPropagation();
    }
  };
  var handleKeyPress = function () {
    onKeyPress === null || onKeyPress === void 0 ? void 0 : onKeyPress();
  };
  React23.useEffect(function () {
    setSelectedFieldValue(defaultValue);
  }, [defaultValue]);
  React23.useEffect(function () {
    if (resetFilters) {
      setSelectedFieldValue(firstValue);
    }
  }, [resetFilters]);
  return /* @__PURE__ */React23.createElement(React23.Fragment, null, hasNoSectionTitle && /* @__PURE__ */React23.createElement(EGDSHeading2, {
    className: "is-visually-hidden",
    tag: "h4"
  }, label), /* @__PURE__ */React23.createElement(EGDSSelect, {
    id: "sort-filter-dropdown-".concat(id),
    value: selectedFieldValue,
    defaultValue: selectedFieldValue,
    name: id,
    label: label,
    emptyState: false,
    onChange: handleChange,
    onKeyPress: handleKeyPress,
    onClick: handleOnClick,
    disabled: loading,
    onKeyDown: handleKeyDown
  }, dropdownOptions.map(function (param, optionIndex) {
    var primaryOption = param.primary,
      selected = param.selected,
      value = param.value;
    return /* @__PURE__ */React23.createElement("option", {
      key: optionIndex,
      value: value,
      "aria-selected": selected,
      "data-opt-id": value
    }, primaryOption);
  })));
};
DropdownField.displayName = "DropdownField";
DropdownField.fragment = _object_spread_props(_object_spread({}, __Fragment17), {
  __typename: "ShoppingDropdownField"
});
// ../internal/src/components/sort-filter/__private/__fragments/filter-sheet-footer/quick-access-filter-sheet-footer.tsx
import React25 from "react";
import { gql as gql24 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize5 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { EGDSSheetFooter } from "@egds/react-core/sheet";
import { EGDSLineSkeleton as EGDSLineSkeleton2 } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSParagraph as EGDSParagraph2 } from "@egds/react-core/text";
// ../internal/src/components/common/button/egds-primary-button.tsx
import React24 from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize4, EGDSFloatingFullWidthButton, EGDSPrimaryButton as EGDSPrimaryButton3 } from "@egds/react-core/button";
import { EGDSScrim } from "@egds/react-core/scrim";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
var __Fragment18 = gql23(_templateObject26(), EGDSButtonFragment);
var SortAndFilterEGDSPrimaryButton = function (param) {
  var data = param.data,
    onClick = param.onClick,
    size = param.size,
    _param_isFullWidth = param.isFullWidth,
    isFullWidth = _param_isFullWidth === void 0 ? true : _param_isFullWidth,
    _param_floating = param.floating,
    floating = _param_floating === void 0 ? false : _param_floating;
  var egdsElementId = data.egdsElementId,
    primary = data.primary,
    analytics = data.analytics,
    disabled = data.disabled;
  var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_primary_button";
  var track = useClickTracker14();
  var handleClick = React24.useCallback(function () {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    onClick();
  }, [analytics, onClick, track]);
  var primaryButtonProps = {
    onClick: handleClick,
    id: id,
    isFullWidth: isFullWidth,
    disabled: disabled,
    size: size || EGDSButtonSize4.LARGE
  };
  return floating ? /* @__PURE__ */React24.createElement(EGDSScrim, {
    type: "fade-button"
  }, /* @__PURE__ */React24.createElement(EGDSFloatingFullWidthButton, _object_spread({}, primaryButtonProps), primary)) : /* @__PURE__ */React24.createElement(EGDSPrimaryButton3, _object_spread({}, primaryButtonProps), primary);
};
SortAndFilterEGDSPrimaryButton.displayName = "SortAndFilterEGDSPrimaryButton";
SortAndFilterEGDSPrimaryButton.fragment = __Fragment18;
// ../internal/src/components/sort-filter/__private/__fragments/filter-sheet-footer/quick-access-filter-sheet-footer.tsx
var __Fragment19 = gql24(_templateObject27(), SortAndFilterEGDSPrimaryButton.fragment);
var QuickAccessFilterSheetFooter = function (param) {
  var data = param.data,
    onClick = param.onClick,
    footerDataLoading = param.footerDataLoading,
    isBexQuickFiltersEnabled = param.isBexQuickFiltersEnabled;
  var resultCountLabel = data.resultCountLabel,
    applyAction = data.applyAction;
  var showResultsCount = resultCountLabel;
  if ((applyAction === null || applyAction === void 0 ? void 0 : applyAction.__typename) !== "UIPrimaryButton") {
    return null;
  }
  var buttonData = footerDataLoading ? _object_spread_props(_object_spread({}, applyAction), {
    disabled: true
  }) : applyAction;
  var buttonProps = {
    data: buttonData,
    onClick: onClick,
    size: EGDSButtonSize5.MEDIUM
  };
  if (isBexQuickFiltersEnabled) {
    return /* @__PURE__ */React25.createElement(EGDSSheetFooter, null, /* @__PURE__ */React25.createElement(EGDSSpacing6, {
      padding: {
        block: "three",
        inline: "two"
      }
    }, /* @__PURE__ */React25.createElement(EGDSLayoutFlex5, null, /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React25.createElement(SortAndFilterEGDSPrimaryButton, _object_spread({}, buttonProps))))));
  }
  return /* @__PURE__ */React25.createElement(EGDSSpacing6, {
    padding: {
      small: "four",
      large: {
        inline: "six"
      }
    }
  }, /* @__PURE__ */React25.createElement(EGDSLayoutFlex5, {
    justifyContent: showResultsCount ? "space-between" : "end",
    alignItems: "center"
  }, showResultsCount && /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem6, null, footerDataLoading ? /* @__PURE__ */React25.createElement(EGDSLineSkeleton2, null) : /* @__PURE__ */React25.createElement(EGDSParagraph2, null, resultCountLabel))), /* @__PURE__ */React25.createElement(EGDSLayoutFlexItem6, null, /* @__PURE__ */React25.createElement(SortAndFilterEGDSPrimaryButton, _object_spread_props(_object_spread({}, buttonProps), {
    isFullWidth: false
  })))));
};
QuickAccessFilterSheetFooter.displayName = "QuickAccessFilterSheetFooter";
QuickAccessFilterSheetFooter.fragment = __Fragment19;
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field.tsx
import React29 from "react";
import { gql as gql29 } from "@apollo/client";
import { EGDSButtonToggleGroup } from "@egds/react-core/button-toggle";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3, EGDSParagraph as EGDSParagraph3 } from "@egds/react-core/text";
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field-option.tsx
import React28, { useState as useState2 } from "react";
import { gql as gql28 } from "@apollo/client";
import { EGDSButtonToggle } from "@egds/react-core/button-toggle";
import { useFormCallback as useFormCallback4 } from "@egds/react-core/form";
import { EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/sort-filter/__private/__fragments/signals/signal-subscriber.tsx
import { useSignalSubscriber } from "@shared-ui/core-signal-manager/context";
import { SortAndFilterSelectedFilterPillSignal } from "@shared-ui/retail-signals-sort-and-filter";
var SignalSubscriber = function (param) {
  var topic = param.topic,
    onSuccess = param.onSuccess,
    onError = param.onError;
  useSignalSubscriber(topic, SortAndFilterSelectedFilterPillSignal, {
    onSuccess: onSuccess,
    onError: onError
  });
  return null;
};
// ../internal/src/components/sort-filter/__private/__fragments/signals/signal-wrapper.tsx
import React26 from "react";
import { SignalContextProvider } from "@shared-ui/core-signal-manager/context";
import { PubSubSignalManager } from "@shared-ui/pubsub-signal-manager";
var SignalWrapper = function (param) {
  var children = param.children;
  var signalManagerInstance = React26.useMemo(function () {
    return new PubSubSignalManager();
  }, []);
  return /* @__PURE__ */React26.createElement(SignalContextProvider, {
    manager: signalManagerInstance
  }, children);
};
// ../internal/src/components/sort-filter/__private/__fragments/signals/signals-fragments.ts
import { gql as gql27 } from "@apollo/client";
// ../internal/src/components/common/egds-text/egds-localized-text-fragments.ts
import { gql as gql25 } from "@apollo/client";
var TemplateModelFragment = gql25(_templateObject28());
var EGDSBasicLocalizedTextFragment = gql25(_templateObject29(), TemplateModelFragment);
var EGDSCardinalLocalizedTextFragment = gql25(_templateObject30(), TemplateModelFragment);
var EGDSCompositeLocalizedTextFragment = gql25(_templateObject31(), TemplateModelFragment);
var EGDSLocalizedTextFragment = gql25(_templateObject32(), EGDSBasicLocalizedTextFragment, EGDSCardinalLocalizedTextFragment, EGDSCompositeLocalizedTextFragment);
// ../internal/src/components/common/egds-text/egds-plain-text.tsx
import React27 from "react";
import { gql as gql26 } from "@apollo/client";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
var fragment = gql26(_templateObject33());
var EGDSPlainText = function (param) {
  var data = param.data;
  return /* @__PURE__ */React27.createElement(EGDSText2, null, data.text);
};
EGDSPlainText.fragment = fragment;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/sort-filter/__private/__fragments/signals/signals-fragments.ts
var ReceiverFragment = gql27(_templateObject34());
var EmitterFragment = gql27(_templateObject35(), clientSideAnalyticsFragment, EGDSPlainText.fragment, EGDSBasicLocalizedTextFragment, EGDSBasicRemovablePill.fragment);
// ../internal/src/components/sort-filter/__private/__fragments/signals/state-utils.ts
import { SortAndFilterBasicFilterSignal, SortAndFilterSelectedFilterPillSignal as SortAndFilterSelectedFilterPillSignal2 } from "@shared-ui/retail-signals-sort-and-filter";
var selectedFiltersReducer = function (state, action) {
  switch (action.type) {
    case "CLEAR_ALL_FILTERS" /* CLEAR_ALL_FILTERS */:
      return _object_spread_props(_object_spread({}, state), {
        selectedFilters: []
      });
    case "CLEAR_FILTER_BY_ID" /* CLEAR_FILTER_BY_ID */:
      return _object_spread_props(_object_spread({}, state), {
        selectedFilters: state.selectedFilters.filter(function (param) {
          var selectedFilter = param.filter;
          if ((selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.__typename) !== "EGDSBasicRemovablePill") {
            return true;
          }
          return selectedFilter.id !== action.payload;
        })
      });
    case "RESET_WITH_QUERY" /* RESET_WITH_QUERY */:
      return _object_spread_props(_object_spread({}, state), {
        selectedFilters: action.payload
      });
    case "SortAndFilterSignal" /* SIGNAL */:
      {
        var payload = action.signal.payload;
        switch (payload.__typename) {
          case "SortAndFilterSelectedFilterPillPayload" /* SELECTED_FILTER_PILL */:
            {
              var newFilter = payload.filter,
                newPrimary = payload.filterNameResolved,
                deselectionSignalId = payload.deselectionSignalId;
              if (newFilter.__typename !== "EGDSBasicRemovablePill") {
                return state;
              }
              var newFilterId = newFilter.id,
                removeAnalytics = newFilter.removeAnalytics;
              var selectedFilters = state.selectedFilters;
              var selectedFilterExists = selectedFilters.some(function (param) {
                var filter = param.filter;
                if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill") {
                  return false;
                }
                return filter.id === newFilterId;
              });
              if (selectedFilterExists) {
                var newSelectedFilters = selectedFilters.map(function (selectedFilter) {
                  var filter = selectedFilter.filter;
                  if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill" || filter.id !== newFilterId) {
                    return selectedFilter;
                  }
                  return _object_spread_props(_object_spread({}, selectedFilter), {
                    filter: _object_spread_props(_object_spread({}, filter), {
                      primary: newPrimary,
                      removeAnalytics: removeAnalytics
                    })
                  });
                });
                return _object_spread_props(_object_spread({}, state), {
                  selectedFilters: newSelectedFilters
                });
              }
              var newSelectedFilter = {
                __typename: "ShoppingSelectedFilter",
                filter: _object_spread_props(_object_spread({}, newFilter), {
                  primary: newPrimary,
                  disabled: false,
                  icon: null
                }),
                emitters: [{
                  __typename: "SortAndFilterSignalEmitter",
                  signalId: deselectionSignalId !== null && deselectionSignalId !== void 0 ? deselectionSignalId : "",
                  condition: "UNSELECTED" /* UNSELECTED */,
                  payload: {
                    __typename: "SortAndFilterBasicFilterPayload" /* BASIC_FILTER */,
                    type: "REMOVE" /* REMOVE */,
                    filterId: newFilterId !== null && newFilterId !== void 0 ? newFilterId : ""
                  }
                }]
              };
              return _object_spread_props(_object_spread({}, state), {
                selectedFilters: _to_consumable_array(selectedFilters).concat([newSelectedFilter])
              });
            }
          case "SortAndFilterBasicFilterPayload" /* BASIC_FILTER */:
            {
              var type = payload.type,
                filterId = payload.filterId;
              switch (type) {
                case "REMOVE" /* REMOVE */:
                  return _object_spread_props(_object_spread({}, state), {
                    selectedFilters: state.selectedFilters.filter(function (param) {
                      var selectedFilter = param.filter;
                      if ((selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.__typename) !== "EGDSBasicRemovablePill") {
                        return true;
                      }
                      return selectedFilter.id !== filterId;
                    })
                  });
                default:
                  return state;
              }
            }
          default:
            return state;
        }
      }
  }
};
var getNewReferrerId = function (removeAnalytics, options) {
  var referrerId = removeAnalytics.referrerId;
  switch (options === null || options === void 0 ? void 0 : options.type) {
    case "RANGE_OPTIONS" /* RANGE_OPTIONS */:
      {
        var analyticsMin = options.analyticsMin,
          analyticsMax = options.analyticsMax;
        return "".concat(referrerId, ".").concat(analyticsMin, ",").concat(analyticsMax);
      }
    case "STEP_INPUT_OPTIONS" /* STEP_INPUT_OPTIONS */:
      {
        var nextValue = options.nextValue;
        return "".concat(referrerId, ".").concat(nextValue);
      }
    case "TYPEAHEAD_OPTIONS" /* TYPEAHEAD_OPTIONS */:
      {
        var selection = options.selection;
        return "".concat(referrerId, ".").concat(selection);
      }
    default:
      return referrerId;
  }
};
var resolveDataValue = function (source, options) {
  switch (source) {
    case "selected.min" /* RANGE_MIN */:
      if ((options === null || options === void 0 ? void 0 : options.type) === "RANGE_OPTIONS" /* RANGE_OPTIONS */) {
        return "".concat(options.nextMin);
      }
      break;
    case "selected.max" /* RANGE_MAX */:
      if ((options === null || options === void 0 ? void 0 : options.type) === "RANGE_OPTIONS" /* RANGE_OPTIONS */) {
        return "".concat(options.nextMax);
      }
      break;
    case "stepInput.value" /* STEP_VALUE */:
      if ((options === null || options === void 0 ? void 0 : options.type) === "STEP_INPUT_OPTIONS" /* STEP_INPUT_OPTIONS */) {
        return "".concat(options.nextValue);
      }
      break;
    case "selected" /* TYPEAHEAD_SELECTED */:
      if ((options === null || options === void 0 ? void 0 : options.type) === "TYPEAHEAD_OPTIONS" /* TYPEAHEAD_OPTIONS */) {
        return "".concat(options.selection);
      }
      break;
  }
  return "";
};
var resolveFilterName = function (filterName, options) {
  switch (filterName.__typename) {
    case "EGDSPlainText" /* PLAIN_TEXT */:
      return filterName.text;
    case "EGDSBasicLocalizedText" /* BASIC_LOCALIZED_TEXT */:
      {
        var template = filterName.template,
          models = filterName.models;
        return models.reduce(function (resolvedTemplate, param) {
          var key = param.key,
            source = param.source;
          var value = resolveDataValue(source, options);
          return resolvedTemplate.replace("{".concat(key, "}"), value);
        }, template);
      }
    default:
      return "";
  }
};
var getGuardClause = function (condition, options) {
  if (!options) {
    return false;
  }
  var optionsType = options.type;
  switch (condition) {
    case "SELECTED" /* SELECTED */:
      switch (optionsType) {
        case "SELECTION_OPTIONS" /* SELECTION_OPTIONS */:
          return options.prevChecked;
        case "TYPEAHEAD_OPTIONS" /* TYPEAHEAD_OPTIONS */:
          return options.selection === "";
        default:
          return true;
      }
    case "UNSELECTED" /* UNSELECTED */:
      switch (optionsType) {
        case "SELECTION_OPTIONS" /* SELECTION_OPTIONS */:
          return !options.prevChecked;
        case "TYPEAHEAD_OPTIONS" /* TYPEAHEAD_OPTIONS */:
          return options.selection !== "";
        default:
          return false;
      }
    case "DEFAULT_TO_NON_DEFAULT" /* DEFAULT_TO_NON_DEFAULT */:
      switch (optionsType) {
        case "RANGE_OPTIONS" /* RANGE_OPTIONS */:
          {
            var prevMin = options.prevMin,
              nextMin = options.nextMin,
              defaultMin = options.defaultMin,
              prevMax = options.prevMax,
              nextMax = options.nextMax,
              defaultMax = options.defaultMax;
            return prevMin !== defaultMin || prevMax !== defaultMax || nextMin === defaultMin && nextMax === defaultMax;
          }
        case "STEP_INPUT_OPTIONS" /* STEP_INPUT_OPTIONS */:
          {
            var prevValue = options.prevValue,
              defaultValue = options.defaultValue;
            return prevValue !== defaultValue;
          }
        default:
          return true;
      }
    case "NON_DEFAULT_TO_NON_DEFAULT" /* NON_DEFAULT_TO_NON_DEFAULT */:
      switch (optionsType) {
        case "RANGE_OPTIONS" /* RANGE_OPTIONS */:
          {
            var prevMin1 = options.prevMin,
              nextMin1 = options.nextMin,
              defaultMin1 = options.defaultMin,
              prevMax1 = options.prevMax,
              nextMax1 = options.nextMax,
              defaultMax1 = options.defaultMax;
            return prevMin1 === defaultMin1 && prevMax1 === defaultMax1 || nextMin1 === defaultMin1 && nextMax1 === defaultMax1;
          }
        case "STEP_INPUT_OPTIONS" /* STEP_INPUT_OPTIONS */:
          {
            var prevValue1 = options.prevValue,
              nextValue = options.nextValue,
              defaultValue1 = options.defaultValue;
            return prevValue1 === defaultValue1 || nextValue === defaultValue1;
          }
        default:
          return true;
      }
    case "NON_DEFAULT_TO_DEFAULT" /* NON_DEFAULT_TO_DEFAULT */:
      switch (optionsType) {
        case "RANGE_OPTIONS" /* RANGE_OPTIONS */:
          {
            var nextMin2 = options.nextMin,
              defaultMin2 = options.defaultMin,
              nextMax2 = options.nextMax,
              defaultMax2 = options.defaultMax;
            return nextMin2 !== defaultMin2 || nextMax2 !== defaultMax2;
          }
        case "STEP_INPUT_OPTIONS" /* STEP_INPUT_OPTIONS */:
          {
            var nextValue1 = options.nextValue,
              defaultValue2 = options.defaultValue;
            return nextValue1 !== defaultValue2;
          }
        default:
          return true;
      }
  }
};
var buildSignal = function (emitter, options) {
  var condition = emitter.condition,
    payload = emitter.payload;
  var guardClause = getGuardClause(condition, options);
  if (guardClause) {
    return null;
  }
  var signalId = emitter.signalId.toUpperCase();
  switch (payload.__typename) {
    case "SortAndFilterSelectedFilterPillPayload" /* SELECTED_FILTER_PILL */:
      {
        var filterNameResolved = resolveFilterName(payload.filterName, options);
        var newPayload = _object_spread_props(_object_spread({}, payload), {
          filterNameResolved: filterNameResolved
        });
        if (newPayload.filter.__typename === "EGDSBasicRemovablePill" && newPayload.filter.removeAnalytics) {
          var newReferrerId = getNewReferrerId(newPayload.filter.removeAnalytics, options);
          newPayload = _object_spread_props(_object_spread({}, newPayload), {
            filter: _object_spread_props(_object_spread({}, newPayload.filter), {
              removeAnalytics: _object_spread_props(_object_spread({}, newPayload.filter.removeAnalytics), {
                referrerId: newReferrerId
              })
            })
          });
        }
        return new SortAndFilterSelectedFilterPillSignal2(signalId, newPayload);
      }
    case "SortAndFilterBasicFilterPayload" /* BASIC_FILTER */:
      {
        var newPayload1 = _object_spread({}, payload);
        if ((options === null || options === void 0 ? void 0 : options.type) === "SELECTION_OPTIONS" /* SELECTION_OPTIONS */) {
          newPayload1.prevChecked = options.prevChecked;
        }
        return new SortAndFilterBasicFilterSignal(signalId, newPayload1);
      }
    default:
      return null;
  }
};
// ../internal/src/components/sort-filter/__private/__fragments/signals/use-signal-emitter.tsx
import { useCallback } from "react";
import { useSignalPublisher } from "@shared-ui/core-signal-manager/context";
var useSignalEmitter = function () {
  var publish = useSignalPublisher().publish;
  return useCallback(function (emitters, options) {
    emitters.forEach(function (emitter) {
      var signal = buildSignal(emitter, options);
      if (signal) {
        publish(signal);
      }
    });
  }, [publish]);
};
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field-option.tsx
var __Fragment20 = gql28(_templateObject36(), clientSideAnalyticsFragment, ReceiverFragment, EmitterFragment, Icon.fragment);
var MultiSelectionStackedTileFieldOptionSubscriptions = function (param) {
  var receivers = param.receivers,
    setChecked = param.setChecked;
  return /* @__PURE__ */React28.createElement(React28.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (receiver, i) {
    var signalId = receiver.signalId.toUpperCase();
    var onSuccess = function (param) {
      var payload = param.payload;
      var type = payload.type,
        prevChecked = payload.prevChecked;
      switch (type) {
        case "REMOVE" /* REMOVE */:
          setChecked(false);
          break;
        case "OPTION" /* OPTION */:
          setChecked(!prevChecked);
          break;
        default:
      }
    };
    return /* @__PURE__ */React28.createElement(SignalSubscriber, {
      onSuccess: onSuccess,
      topic: signalId,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var MultiSelectionStackedTileFieldOption = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    loading = param.loading;
  var fieldId = data.fieldId,
    primary = data.primary,
    selected = data.selected,
    value = data.value,
    icon = data.icon,
    accessibility = data.accessibility,
    disabled = data.disabled,
    __typename = data.__typename,
    receivers = data.receivers,
    emitters = data.emitters;
  var _useState2 = _sliced_to_array(useState2(selected), 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var track = useClickTracker15();
  var emitSignal = useSignalEmitter();
  var handleChange = useFormCallback4(fieldId, function (event) {
    if (data.selectAnalytics && !checked) {
      var _data_selectAnalytics = data.selectAnalytics,
        referrerId = _data_selectAnalytics.referrerId,
        linkName = _data_selectAnalytics.linkName,
        uisPrimeMessages = _data_selectAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (data.deselectAnalytics && checked) {
      var _data_deselectAnalytics = data.deselectAnalytics,
        referrerId1 = _data_deselectAnalytics.referrerId,
        linkName1 = _data_deselectAnalytics.linkName,
        uisPrimeMessages1 = _data_deselectAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    if (emitters) {
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
        type: "SELECTION_OPTIONS" /* SELECTION_OPTIONS */,
        prevChecked: checked
      });
    }
    setChecked(event.currentTarget.checked);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  React28.useEffect(function () {
    if (resetFilters) {
      setChecked(false);
    }
  }, [resetFilters]);
  return /* @__PURE__ */React28.createElement(React28.Fragment, null, receivers && /* @__PURE__ */React28.createElement(MultiSelectionStackedTileFieldOptionSubscriptions, {
    receivers: receivers,
    setChecked: setChecked
  }), /* @__PURE__ */React28.createElement(EGDSButtonToggle, _object_spread_props(_object_spread({
    key: "".concat(fieldId, "-").concat(value),
    name: fieldId,
    id: "".concat(__typename, "-").concat(fieldId, "-").concat(value),
    value: value,
    checked: checked,
    disabled: disabled || loading
  }, icon ? {
    icon: icon === null || icon === void 0 ? void 0 : icon.id
  } : {}), {
    labelText: primary,
    altText: accessibility || "",
    iconSize: EGDSIconSize3.EXTRA_SMALL,
    onChange: handleChange
  })));
};
MultiSelectionStackedTileFieldOption.displayName = "MultiSelectionStackedTileFieldOption";
MultiSelectionStackedTileFieldOption.fragment = __Fragment20;
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-stacked-tile-field.tsx
var __Fragment21 = gql29(_templateObject37(), MultiSelectionStackedTileFieldOption.fragment);
var MultiSelectionStackedTileField = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    loading = param.loading;
  var multiOptions = data.multiOptions,
    primary = data.primary,
    secondary = data.secondary;
  return /* @__PURE__ */React29.createElement("fieldset", null, /* @__PURE__ */React29.createElement("legend", null, primary && /* @__PURE__ */React29.createElement(EGDSSpacing7, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React29.createElement(EGDSHeading3, {
    tag: "h4",
    size: 7
  }, primary))), secondary && /* @__PURE__ */React29.createElement(EGDSParagraph3, null, secondary), multiOptions && /* @__PURE__ */React29.createElement(EGDSSpacing7, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React29.createElement(EGDSButtonToggleGroup, {
    wrapButtons: true
  }, multiOptions === null || multiOptions === void 0 ? void 0 : multiOptions.map(function (option, i) {
    return (
      /**
      * To remove a selected filter on the PWA and reset the state we change the key using the selected prop and reset the filter
      */ /* @__PURE__ */
      React29.createElement(MultiSelectionStackedTileFieldOption, {
        resetFilters: resetFilters,
        data: option,
        key: "".concat(i, "-").concat(option.selected),
        onSelectedField: onSelectedField,
        loading: loading
      })
    );
  }))));
};
MultiSelectionStackedTileField.displayName = "MultiSelectionStackedTileField";
MultiSelectionStackedTileField.fragment = _object_spread_props(_object_spread({}, __Fragment21), {
  __typename: "ShoppingMultiSelectionStackedTileField"
});
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-tile-field.tsx
import React31 from "react";
import { gql as gql31 } from "@apollo/client";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading4, EGDSParagraph as EGDSParagraph4 } from "@egds/react-core/text";
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-tile-field-option.tsx
import React30, { useState as useState3 } from "react";
import { gql as gql30 } from "@apollo/client";
import { EGDSButtonToggle as EGDSButtonToggle2 } from "@egds/react-core/button-toggle";
import { useFormCallback as useFormCallback5 } from "@egds/react-core/form";
import { EGDSIconSize as EGDSIconSize4 } from "@egds/react-core/icons";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
var __Fragment22 = gql30(_templateObject38(), clientSideAnalyticsFragment, Icon.fragment, ReceiverFragment, EmitterFragment);
var MultiSelectionTileFieldOptionSubscriptions = function (param) {
  var receivers = param.receivers,
    setChecked = param.setChecked;
  return /* @__PURE__ */React30.createElement(React30.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (receiver, i) {
    var signalId = receiver.signalId.toUpperCase();
    var onSuccess = function (param) {
      var payload = param.payload;
      var type = payload.type,
        prevChecked = payload.prevChecked;
      switch (type) {
        case "REMOVE" /* REMOVE */:
          setChecked(false);
          break;
        case "OPTION" /* OPTION */:
          setChecked(!payload.prevChecked);
          break;
      }
    };
    return /* @__PURE__ */React30.createElement(SignalSubscriber, {
      key: "".concat(signalId, "-").concat(i),
      topic: signalId,
      onSuccess: onSuccess
    });
  }));
};
var MultiSelectionTileFieldOption = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    loading = param.loading;
  var fieldId = data.fieldId,
    primary = data.primary,
    secondary = data.secondary,
    selected = data.selected,
    value = data.value,
    icon = data.icon,
    accessibility = data.accessibility,
    disabled = data.disabled,
    __typename = data.__typename,
    emitters = data.emitters,
    receivers = data.receivers;
  var _useState3 = _sliced_to_array(useState3(selected), 2),
    checked = _useState3[0],
    setChecked = _useState3[1];
  var track = useClickTracker16();
  var emitSignal = useSignalEmitter();
  var handleChange = useFormCallback5(fieldId, function (event) {
    if (data.selectAnalytics && !checked) {
      var _data_selectAnalytics = data.selectAnalytics,
        referrerId = _data_selectAnalytics.referrerId,
        linkName = _data_selectAnalytics.linkName,
        uisPrimeMessages = _data_selectAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (data.deselectAnalytics && checked) {
      var _data_deselectAnalytics = data.deselectAnalytics,
        referrerId1 = _data_deselectAnalytics.referrerId,
        linkName1 = _data_deselectAnalytics.linkName,
        uisPrimeMessages1 = _data_deselectAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    if (emitters) {
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
        type: "SELECTION_OPTIONS" /* SELECTION_OPTIONS */,
        prevChecked: checked
      });
    }
    setChecked(event.currentTarget.checked);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  React30.useEffect(function () {
    if (resetFilters) {
      setChecked(false);
    }
  }, [resetFilters]);
  return /* @__PURE__ */React30.createElement(React30.Fragment, null, receivers && /* @__PURE__ */React30.createElement(MultiSelectionTileFieldOptionSubscriptions, {
    receivers: receivers,
    setChecked: setChecked
  }), /* @__PURE__ */React30.createElement(EGDSButtonToggle2, _object_spread_props(_object_spread({
    key: "".concat(fieldId, "-").concat(value),
    name: fieldId,
    id: "".concat(__typename, "-").concat(fieldId, "-").concat(value),
    value: value,
    checked: checked,
    disabled: disabled || loading
  }, icon ? {
    icon: icon === null || icon === void 0 ? void 0 : icon.id
  } : {}), {
    labelText: primary,
    subLabelText: secondary || "",
    altText: accessibility || "",
    iconSize: EGDSIconSize4.EXTRA_SMALL,
    onChange: handleChange,
    stacked: true
  })));
};
MultiSelectionTileFieldOption.displayName = "MultiSelectionTileFieldOption";
MultiSelectionTileFieldOption.fragment = __Fragment22;
// ../internal/src/components/sort-filter/__private/__fragments/multi-selection-tile-field.tsx
var __Fragment23 = gql31(_templateObject39(), MultiSelectionTileFieldOption.fragment);
var MultiSelectionTileField = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    loading = param.loading;
  var multiOptions = data.multiOptions,
    primary = data.primary,
    secondary = data.secondary;
  return /* @__PURE__ */React31.createElement("fieldset", null, /* @__PURE__ */React31.createElement("legend", null, primary && /* @__PURE__ */React31.createElement(EGDSSpacing8, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React31.createElement(EGDSHeading4, {
    tag: "h4",
    size: 7
  }, primary))), secondary && /* @__PURE__ */React31.createElement(EGDSParagraph4, null, secondary), multiOptions && /* @__PURE__ */React31.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React31.createElement(EGDSLayoutGrid, {
    space: "two",
    columns: 2
  }, multiOptions === null || multiOptions === void 0 ? void 0 : multiOptions.map(function (option, i) {
    return (
      /**
      * To remove a selected filter on the PWA and reset the state we change the key using the selected prop and reset the filter
      */ /* @__PURE__ */
      React31.createElement(EGDSLayoutGridItem, {
        key: "".concat(i, "-").concat(option.selected)
      }, /* @__PURE__ */React31.createElement(MultiSelectionTileFieldOption, {
        data: option,
        key: "".concat(i, "-").concat(option.selected),
        onSelectedField: onSelectedField,
        resetFilters: resetFilters,
        loading: loading
      }))
    );
  }))));
};
MultiSelectionTileField.displayName = "MultiSelectionTileField";
MultiSelectionTileField.fragment = _object_spread_props(_object_spread({}, __Fragment23), {
  __typename: "ShoppingMultiSelectionTileField"
});
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-field.tsx
import React35 from "react";
import { gql as gql35 } from "@apollo/client";
import { EGDSExpandoList, EGDSExpandoListItem, EGDSExpandoPeek } from "@egds/react-core/expando";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant } from "@shared-ui/experiment-context";
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-option-field.tsx
import React34, { useEffect as useEffect2, useState as useState4 } from "react";
import { gql as gql34 } from "@apollo/client";
import { EGDSCheckbox } from "@egds/react-core/checkbox";
import { useFormCallback as useFormCallback6 } from "@egds/react-core/form";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utils/trigger-input-change-event.ts
var triggerInputChangeEvent = function (value, handler, inputType) {
  var event = new CustomEvent("change");
  var input = document.createElement("input");
  if (inputType) {
    input.type = inputType;
  }
  input.value = value;
  var changeListener = function (inputEvent) {
    handler(inputEvent);
  };
  input.addEventListener("change", changeListener);
  input.dispatchEvent(event);
  input.removeEventListener("change", changeListener);
};
// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
import React33 from "react";
import { gql as gql33 } from "@apollo/client";
// ../internal/src/components/common/ui-graphic/mark.tsx
import React32 from "react";
import { gql as gql32 } from "@apollo/client";
import { EGDSMark } from "@egds/react-core/mark";
var fragment2 = gql32(_templateObject40());
var Mark = function (param) {
  var data = param.data,
    className = param.className;
  return /* @__PURE__ */React32.createElement(EGDSMark, {
    className: className,
    description: data.description,
    id: data.id,
    name: data.id
  });
};
Mark.displayName = "Mark";
Mark.fragment = _object_spread_props(_object_spread({}, fragment2), {
  __typename: "Mark"
});
// ../internal/src/components/common/ui-graphic/ui-graphic.tsx
var fragment3 = gql33(_templateObject41(), Mark.fragment);
var UIGraphic = function (param) {
  var data = param.data,
    markOptions = param.markOptions;
  switch (data.__typename) {
    case "Mark":
      return /* @__PURE__ */React33.createElement(Mark, _object_spread({
        data: data
      }, markOptions));
    default:
      return null;
  }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment3;
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-option-field.tsx
var __Fragment24 = gql34(_templateObject42(), clientSideAnalyticsFragment, UIGraphic.fragment, ReceiverFragment, EmitterFragment);
var MultiSelectionOptionFieldSubscriptions = function (param) {
  var receivers = param.receivers,
    setChecked = param.setChecked,
    setTriggerInputChange = param.setTriggerInputChange;
  return /* @__PURE__ */React34.createElement(React34.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (receiver, i) {
    var signalId = receiver.signalId.toUpperCase();
    var onSuccess = function (param) {
      var payload = param.payload;
      var type = payload.type,
        prevChecked = payload.prevChecked;
      switch (type) {
        case "REMOVE" /* REMOVE */:
          setChecked(false);
          setTriggerInputChange(true);
          break;
        case "OPTION" /* OPTION */:
          setChecked(!prevChecked);
          break;
      }
    };
    return /* @__PURE__ */React34.createElement(SignalSubscriber, {
      key: "".concat(signalId, "-").concat(i),
      topic: signalId,
      onSuccess: onSuccess
    });
  }));
};
var MultiSelectionOptionField = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    ignoreSignals = param.ignoreSignals,
    domRef = param.domRef,
    loading = param.loading;
  var fieldId = data.fieldId,
    primary = data.primary,
    secondary = data.secondary,
    selected = data.selected,
    value = data.value,
    description = data.description,
    emitters = data.emitters,
    receivers = data.receivers,
    disabled = data.disabled,
    graphic = data.graphic,
    accessibility = data.accessibility;
  var _useState4 = _sliced_to_array(useState4(selected), 2),
    checked = _useState4[0],
    setChecked = _useState4[1];
  var _useState41 = _sliced_to_array(useState4(false), 2),
    triggerInputChange = _useState41[0],
    setTriggerInputChange = _useState41[1];
  var inputFieldWithSelectionFormCallback = useFormCallback6(fieldId, function (event) {
    return event;
  });
  var uniqueFieldId = React34.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  var emitSignal = useSignalEmitter();
  var track = useClickTracker17();
  var handleChange = useFormCallback6(fieldId, function (event) {
    if (data.selectAnalytics && !checked) {
      var _data_selectAnalytics = data.selectAnalytics,
        referrerId = _data_selectAnalytics.referrerId,
        linkName = _data_selectAnalytics.linkName,
        uisPrimeMessages = _data_selectAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (data.deselectAnalytics && checked) {
      var _data_deselectAnalytics = data.deselectAnalytics,
        referrerId1 = _data_deselectAnalytics.referrerId,
        linkName1 = _data_deselectAnalytics.linkName,
        uisPrimeMessages1 = _data_deselectAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    if (emitters && !ignoreSignals) {
      emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
        type: "SELECTION_OPTIONS" /* SELECTION_OPTIONS */,
        prevChecked: checked
      });
    }
    setChecked(event.currentTarget.checked);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  useEffect2(function () {
    if (resetFilters) {
      setChecked(false);
    }
  }, [resetFilters]);
  useEffect2(function () {
    setChecked(selected);
  }, [selected]);
  useEffect2(function () {
    if (triggerInputChange) {
      triggerInputChangeEvent(value, inputFieldWithSelectionFormCallback, "checkbox" /* CHECKBOX */);
      onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
      setTriggerInputChange(false);
    }
  }, [triggerInputChange]);
  return /* @__PURE__ */React34.createElement(React34.Fragment, null, receivers && /* @__PURE__ */React34.createElement(MultiSelectionOptionFieldSubscriptions, {
    receivers: receivers,
    setChecked: setChecked,
    setTriggerInputChange: setTriggerInputChange
  }), /* @__PURE__ */React34.createElement(EGDSLayoutFlex6, {
    alignItems: "center",
    space: "two"
  }, /* @__PURE__ */React34.createElement(EGDSSpacing9, {
    padding: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React34.createElement(EGDSLayoutFlexItem7, {
    grow: 1
  }, /* @__PURE__ */React34.createElement("div", null, /* @__PURE__ */React34.createElement(EGDSCheckbox, {
    id: "".concat(fieldId, "-").concat(value, "-").concat(uniqueFieldId),
    name: fieldId,
    value: value,
    checked: checked,
    description: description !== null && description !== void 0 ? description : "",
    onChange: handleChange,
    disabled: disabled || loading,
    a11yLabel: accessibility !== null && accessibility !== void 0 ? accessibility : "",
    domRef: domRef
  }, graphic && /* @__PURE__ */React34.createElement(UIGraphic, {
    data: graphic
  }), " ", primary)))), secondary && /* @__PURE__ */React34.createElement(EGDSLayoutFlexItem7, {
    shrink: 0
  }, /* @__PURE__ */React34.createElement(EGDSText3, null, secondary))));
};
MultiSelectionOptionField.displayName = "MultiSelectionOptionField";
MultiSelectionOptionField.fragment = __Fragment24;
// ../internal/src/components/sort-filter/__private/__fragments/multiselection-field.tsx
var __Fragment25 = gql35(_templateObject43(), clientSideAnalyticsFragment, MultiSelectionOptionField.fragment);
var MultiSelectionField = function (param) {
  var data = param.data,
    keepSectionExpanded = param.keepSectionExpanded,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    ignoreSignals = param.ignoreSignals,
    loading = param.loading,
    shouldAppendRevealRef = param.shouldAppendRevealRef;
  var _data_options, _data_options1;
  var primary = data.primary,
    secondary = data.secondary,
    expando = data.expando,
    options = data.options,
    fieldId = data.fieldId;
  var firstUnexpandedOptionRef = React35.useRef(null);
  var _expando_threshold, _ref;
  var expandoThreshold = (_ref = (_expando_threshold = expando === null || expando === void 0 ? void 0 : expando.threshold) !== null && _expando_threshold !== void 0 ? _expando_threshold : expando === null || expando === void 0 ? void 0 : expando.minimalHeight) !== null && _ref !== void 0 ? _ref : void 0;
  var unexpandedOptions = expandoThreshold != null ? options === null || options === void 0 ? void 0 : options.slice(expandoThreshold) : null;
  var getExpandoIsVisibleState = function () {
    return !!(keepSectionExpanded && (unexpandedOptions === null || unexpandedOptions === void 0 ? void 0 : unexpandedOptions.some(function (option) {
      return option.selected;
    })) || expandoThreshold === 0 && (expando === null || expando === void 0 ? void 0 : expando.visible));
  };
  var _React35_useState = _sliced_to_array(React35.useState(getExpandoIsVisibleState()), 2),
    expandoIsVisible = _React35_useState[0],
    setExpandoIsVisible = _React35_useState[1];
  var track = useClickTracker18();
  var handleClick = React35.useCallback(function () {
    setExpandoIsVisible(!expandoIsVisible);
    if ((expando === null || expando === void 0 ? void 0 : expando.expandAnalytics) && !expandoIsVisible) {
      var _expando_expandAnalytics = expando.expandAnalytics,
        referrerId = _expando_expandAnalytics.referrerId,
        linkName = _expando_expandAnalytics.linkName,
        uisPrimeMessages = _expando_expandAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if ((expando === null || expando === void 0 ? void 0 : expando.collapseAnalytics) && expandoIsVisible) {
      var _expando_collapseAnalytics = expando.collapseAnalytics,
        referrerId1 = _expando_collapseAnalytics.referrerId,
        linkName1 = _expando_collapseAnalytics.linkName,
        uisPrimeMessages1 = _expando_collapseAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
  }, [setExpandoIsVisible, expandoIsVisible]);
  if (!((_data_options = data.options) === null || _data_options === void 0 ? void 0 : _data_options.length)) {
    return null;
  }
  var Base;
  var expandoProps;
  if (expandoThreshold === 0) {
    Base = EGDSExpandoList;
    expandoProps = {
      expandoTitle: /* @__PURE__ */React35.createElement(EGDSHeading5, {
        tag: "h4",
        size: 7
      }, primary),
      triggerPosition: "trailing",
      isVisible: expandoIsVisible,
      onToggle: handleClick
    };
  } else if ((expando === null || expando === void 0 ? void 0 : expando.threshold) && ((_data_options1 = data.options) === null || _data_options1 === void 0 ? void 0 : _data_options1.length) > expando.threshold) {
    Base = EGDSExpandoPeek;
    var _expando_collapseAccessibilityLabel, _expando_expandAccessibilityLabel;
    expandoProps = _object_spread({
      collapseLabel: expando.collapseLabel,
      expandLabel: expando.expandLabel,
      collapseA11yLabel: (_expando_collapseAccessibilityLabel = expando.collapseAccessibilityLabel) !== null && _expando_collapseAccessibilityLabel !== void 0 ? _expando_collapseAccessibilityLabel : void 0,
      expandA11yLabel: (_expando_expandAccessibilityLabel = expando.expandAccessibilityLabel) !== null && _expando_expandAccessibilityLabel !== void 0 ? _expando_expandAccessibilityLabel : void 0,
      items: expandoThreshold,
      isVisible: expandoIsVisible,
      hideScrim: true,
      handleClick: handleClick
    }, shouldAppendRevealRef && {
      revealRef: firstUnexpandedOptionRef
    });
  } else {
    Base = React35.Fragment;
    expandoProps = {};
  }
  var renderOptionField = function (option, optionIndex) {
    var isFirstUnexpandedOption = optionIndex === expandoThreshold;
    return /* @__PURE__ */React35.createElement(EGDSLayoutGridItem2, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value)
    }, /* @__PURE__ */React35.createElement(MultiSelectionOptionField, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value),
      data: option,
      resetFilters: resetFilters,
      onSelectedField: onSelectedField,
      ignoreSignals: ignoreSignals,
      domRef: isFirstUnexpandedOption ? firstUnexpandedOptionRef : void 0,
      loading: loading
    }));
  };
  return /* @__PURE__ */React35.createElement("fieldset", {
    "data-stid": fieldId
  }, Base === EGDSExpandoList ? /* @__PURE__ */React35.createElement(EGDSExpandoList, null, /* @__PURE__ */React35.createElement(EGDSExpandoListItem, _object_spread({}, expandoProps), options === null || options === void 0 ? void 0 : options.map(function (option, optionIndex) {
    return renderOptionField(option, optionIndex);
  }))) : /* @__PURE__ */React35.createElement(React35.Fragment, null, secondary ? /* @__PURE__ */React35.createElement(React35.Fragment, null, /* @__PURE__ */React35.createElement("legend", {
    className: "is-visually-hidden"
  }, primary), /* @__PURE__ */React35.createElement(EGDSSpacing10, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React35.createElement(EGDSLayoutFlex7, {
    space: "two"
  }, primary && /* @__PURE__ */React35.createElement(EGDSLayoutFlexItem8, {
    grow: 1
  }, /* @__PURE__ */React35.createElement(EGDSHeading5, {
    tag: "h4",
    size: 7
  }, primary)), secondary && /* @__PURE__ */React35.createElement(EGDSLayoutFlexItem8, {
    shrink: 0
  }, /* @__PURE__ */React35.createElement(EGDSHeading5, {
    tag: "h4",
    size: 7
  }, secondary))))) : /* @__PURE__ */React35.createElement("legend", null, primary && /* @__PURE__ */React35.createElement(EGDSHeading5, {
    tag: "h4",
    size: 7
  }, primary)), /* @__PURE__ */React35.createElement(Experiment, {
    name: "VrBex_Clawback_Filter_Modal_Display_Optimizations"
  }, /* @__PURE__ */React35.createElement(ExperimentControl, null, /* @__PURE__ */React35.createElement(Base, _object_spread({}, expandoProps), options === null || options === void 0 ? void 0 : options.map(function (option, optionIndex) {
    return renderOptionField(option, optionIndex);
  }))), /* @__PURE__ */React35.createElement(ExperimentVariant, {
    bucket: 1
  }, /* @__PURE__ */React35.createElement(Base, _object_spread({}, expandoProps), /* @__PURE__ */React35.createElement(EGDSLayoutGrid2, {
    columns: options && (options === null || options === void 0 ? void 0 : options.length) >= 2 ? 2 : 1,
    alignContent: "start",
    alignItems: "start"
  }, options === null || options === void 0 ? void 0 : options.map(function (option, optionIndex) {
    return renderOptionField(option, optionIndex);
  })))), /* @__PURE__ */React35.createElement(ExperimentVariant, {
    bucket: 2
  }, /* @__PURE__ */React35.createElement(Base, _object_spread({}, expandoProps), /* @__PURE__ */React35.createElement(EGDSLayoutGrid2, {
    columns: options && (options === null || options === void 0 ? void 0 : options.length) >= 2 ? 2 : 1,
    alignContent: "start",
    alignItems: "start"
  }, options === null || options === void 0 ? void 0 : options.map(function (option, optionIndex) {
    return renderOptionField(option, optionIndex);
  })))))));
};
MultiSelectionField.displayName = "MultiSelectionField";
MultiSelectionField.fragment = _object_spread_props(_object_spread({}, __Fragment25), {
  __typename: "ShoppingMultiSelectionField"
});
// ../internal/src/components/sort-filter/__private/__fragments/mutex-field.tsx
import React41 from "react";
import { gql as gql41 } from "@apollo/client";
import { useFormCallback as useFormCallback8 } from "@egds/react-core/form";
import { EGDSRadioButtonGroup as EGDSRadioButtonGroup2 } from "@egds/react-core/radio-button";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading10 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker23 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment4 } from "@shared-ui/experiment-context";
// ../internal/src/components/sort-filter/__private/__fragments/range-field.tsx
import React36, { useEffect as useEffect3, useState as useState5 } from "react";
import { gql as gql36 } from "@apollo/client";
import { EGDSSlider } from "@egds/react-core/slider";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading6 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
var __Fragment26 = gql36(_templateObject44(), clientSideAnalyticsFragment, ReceiverFragment, EmitterFragment);
var RangeFieldSubscriptions = function (param) {
  var receivers = param.receivers,
    onSignalCallback = param.onSignalCallback;
  return /* @__PURE__ */React36.createElement(React36.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (receiver, i) {
    var signalId = receiver.signalId.toUpperCase();
    var onSuccess = function (param) {
      var payload = param.payload;
      if (payload.type === "REMOVE" /* REMOVE */) {
        onSignalCallback();
      }
    };
    return /* @__PURE__ */React36.createElement(SignalSubscriber, {
      onSuccess: onSuccess,
      topic: signalId,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var RangeField = function (param) {
  var data = param.data,
    onRangeSelectionChange = param.onRangeSelectionChange,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    _param_shouldFireSignalOnMount = param.shouldFireSignalOnMount,
    shouldFireSignalOnMount = _param_shouldFireSignalOnMount === void 0 ? false : _param_shouldFireSignalOnMount;
  var primary = data.primary,
    range = data.range;
  var _ref = range || {},
    selected = _ref.selected,
    characteristics = _ref.characteristics,
    _ref_id = _ref.id,
    id = _ref_id === void 0 ? "" : _ref_id,
    emitters = _ref.emitters,
    receivers = _ref.receivers,
    minAccessibility = _ref.minAccessibility,
    maxAccessibility = _ref.maxAccessibility,
    sliderType = _ref.sliderType;
  var _ref1 = characteristics || {},
    _ref_min = _ref1.min,
    min = _ref_min === void 0 ? 0 : _ref_min,
    _ref_max = _ref1.max,
    max = _ref_max === void 0 ? 0 : _ref_max,
    step = _ref1.step;
  var _ref2 = selected || {},
    initialMin = _ref2.min,
    initialMax = _ref2.max;
  var _useState5 = _sliced_to_array(useState5(initialMin), 2),
    currentMin = _useState5[0],
    setMin = _useState5[1];
  var _useState51 = _sliced_to_array(useState5(initialMax), 2),
    currentMax = _useState51[0],
    setMax = _useState51[1];
  var _useState52 = _sliced_to_array(useState5(false), 2),
    triggerInputChange = _useState52[0],
    setTriggerInputChange = _useState52[1];
  var track = useClickTracker19();
  var unboundedPriceRangeValue = -1;
  var emitSignal = useSignalEmitter();
  var sliderTypeValue = sliderType === "SINGLE" /* SINGLE */ ? "single" : "dual";
  var onSignalCallback = React36.useCallback(function () {
    setMin(min);
    setMax(max);
    setTriggerInputChange(true);
  }, [min, max]);
  var formatValue = function (number) {
    var _characteristics_labels;
    var currentLabel = characteristics === null || characteristics === void 0 ? void 0 : (_characteristics_labels = characteristics.labels) === null || _characteristics_labels === void 0 ? void 0 : _characteristics_labels.find(function (param) {
      var value = param.value;
      return value === number;
    });
    var _currentLabel_label;
    return (_currentLabel_label = currentLabel === null || currentLabel === void 0 ? void 0 : currentLabel.label) !== null && _currentLabel_label !== void 0 ? _currentLabel_label : "";
  };
  var handleSliderChange = function (lowerValue, upperValue) {
    var safeLowerValue = upperValue ? lowerValue : min;
    var safeUpperValue = upperValue || lowerValue;
    var rangeOptions = {
      type: "RANGE_OPTIONS" /* RANGE_OPTIONS */,
      analyticsMin: safeLowerValue,
      analyticsMax: safeUpperValue,
      defaultMax: formatValue(max),
      defaultMin: formatValue(min),
      nextMax: formatValue(safeUpperValue),
      nextMin: formatValue(safeLowerValue),
      prevMax: formatValue(currentMax),
      prevMin: formatValue(currentMin)
    };
    var minDistanceBetweenHandles = step && (characteristics === null || characteristics === void 0 ? void 0 : characteristics.minStepDistance) ? step * characteristics.minStepDistance : 0;
    if (minDistanceBetweenHandles === 0 || typeof upperValue === "undefined" || safeUpperValue - safeLowerValue >= minDistanceBetweenHandles) {
      if (emitters) {
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], rangeOptions);
      }
      setMin(safeLowerValue);
      setMax(safeUpperValue);
    }
  };
  var handleSliderAfterChange = function (lowerValue, upperValue, event) {
    var safeLowerValue = upperValue ? lowerValue : min;
    var safeUpperValue = upperValue || lowerValue;
    var isRangeSetToDefault = min === safeLowerValue && max === safeUpperValue;
    if (currentMin === (selected === null || selected === void 0 ? void 0 : selected.min) && currentMax === (selected === null || selected === void 0 ? void 0 : selected.max)) {
      return;
    }
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    var sliderEvent = event;
    if (sliderEvent) {
      sliderEvent.target.checked = !isRangeSetToDefault;
    }
    if (isRangeSetToDefault) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      }, sliderEvent);
    } else {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: safeLowerValue,
        max: safeUpperValue
      }, sliderEvent);
    }
    if (range === null || range === void 0 ? void 0 : range.analytics) {
      track("".concat(range.analytics.referrerId).concat(!isRangeSetToDefault, ".").concat(safeLowerValue, ",").concat(safeUpperValue), range.analytics.linkName, void 0, mapUisMicroMessage(range.analytics.uisPrimeMessages));
    }
  };
  useEffect3(function () {
    if (resetFilters) {
      setMin(min);
      setMax(max);
    }
  }, [resetFilters]);
  useEffect3(function () {
    setMax(initialMax);
    setMin(initialMin);
  }, [initialMin, initialMax]);
  useEffect3(function () {
    if (triggerInputChange) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      });
      onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
      setTriggerInputChange(false);
    }
  }, [triggerInputChange]);
  useEffect3(function () {
    if (shouldFireSignalOnMount) {
      var rangeOptions = {
        type: "RANGE_OPTIONS" /* RANGE_OPTIONS */,
        analyticsMax: max,
        analyticsMin: min,
        defaultMax: formatValue(max),
        defaultMin: formatValue(min),
        nextMax: formatValue(selected === null || selected === void 0 ? void 0 : selected.max),
        nextMin: formatValue(selected === null || selected === void 0 ? void 0 : selected.min),
        prevMax: formatValue(currentMax),
        prevMin: formatValue(currentMin)
      };
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], rangeOptions);
    }
  }, [shouldFireSignalOnMount]);
  if (!range) {
    return null;
  }
  return /* @__PURE__ */React36.createElement(React36.Fragment, null, /* @__PURE__ */React36.createElement(RangeFieldSubscriptions, {
    receivers: receivers,
    onSignalCallback: onSignalCallback
  }), /* @__PURE__ */React36.createElement(EGDSSpacing11, {
    margin: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React36.createElement("div", null, /* @__PURE__ */React36.createElement("fieldset", null, /* @__PURE__ */React36.createElement("legend", null, /* @__PURE__ */React36.createElement(EGDSHeading6, {
    tag: "h4",
    size: 7
  }, primary)), /* @__PURE__ */React36.createElement(EGDSSpacing11, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React36.createElement("div", null, /* @__PURE__ */React36.createElement(EGDSSlider, {
    id: id,
    key: "".concat(id, "-shopping-range-field"),
    name: id,
    type: sliderTypeValue,
    min: min,
    max: max,
    step: step,
    handleChange: handleSliderChange,
    handleAfterChange: handleSliderAfterChange,
    lowerValue: currentMin,
    upperValue: currentMax,
    formatValueForDisplay: formatValue,
    formatSecondaryValueForDisplay: formatValue,
    gap: 0,
    primaryLabel: minAccessibility !== null && minAccessibility !== void 0 ? minAccessibility : void 0,
    secondaryLabel: maxAccessibility !== null && maxAccessibility !== void 0 ? maxAccessibility : void 0
  })))))));
};
RangeField.displayName = "RangeField";
RangeField.fragment = _object_spread_props(_object_spread({}, __Fragment26), {
  __typename: "ShoppingRangeField"
});
// ../internal/src/components/sort-filter/__private/__fragments/range-text-input-field.tsx
import React37, { useEffect as useEffect4, useState as useState6 } from "react";
import { gql as gql37 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7 } from "@egds/react-core/text";
import { SliderTextInputs } from "@egds/react-lodging";
import { useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment3 } from "@shared-ui/experiment-context";
import numberFormatter from "number-formatter";
var __Fragment27 = gql37(_templateObject45(), clientSideAnalyticsFragment, EmitterFragment, ReceiverFragment);
var RangeTextInputFieldSubscriptions = function (param) {
  var receivers = param.receivers,
    onSignalCallback = param.onSignalCallback;
  return /* @__PURE__ */React37.createElement(React37.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (receiver, i) {
    var signalId = receiver.signalId.toUpperCase();
    var onSuccess = function (param) {
      var payload = param.payload;
      var type = payload.type;
      switch (type) {
        case "REMOVE" /* REMOVE */:
          onSignalCallback();
          break;
      }
    };
    return /* @__PURE__ */React37.createElement(SignalSubscriber, {
      key: "".concat(signalId, "-").concat(i),
      topic: signalId,
      onSuccess: onSuccess
    });
  }));
};
var RangeTextInputField = function (param) {
  var data = param.data,
    onRangeSelectionChange = param.onRangeSelectionChange,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    shouldFireSignalOnMount = param.shouldFireSignalOnMount,
    type = param.type,
    loading = param.loading;
  var primary = data.primary,
    fieldId = data.fieldId,
    minValueInput = data.minValueInput,
    maxValueInput = data.maxValueInput,
    rangeField = data.rangeField,
    minValueAccessibility = data.minValueAccessibility,
    maxValueAccessibility = data.maxValueAccessibility,
    lowerBoundAccessibility = data.lowerBoundAccessibility,
    upperBoundAccessibility = data.upperBoundAccessibility,
    numberFormat = data.numberFormat,
    minValueAnalytics = data.minValueAnalytics,
    maxValueAnalytics = data.maxValueAnalytics;
  var selected = rangeField.selected,
    characteristics = rangeField.characteristics,
    _rangeField_id = rangeField.id,
    id = _rangeField_id === void 0 ? "" : _rangeField_id,
    emitters = rangeField.emitters,
    receivers = rangeField.receivers;
  var min = characteristics.min,
    max = characteristics.max,
    step = characteristics.step,
    minLabel = characteristics.minLabel,
    maxLabel = characteristics.maxLabel;
  var _useState6 = _sliced_to_array(useState6(false), 2),
    filterPillRemoved = _useState6[0],
    setFilterPillRemoved = _useState6[1];
  var _useState61 = _sliced_to_array(useState6(false), 2),
    triggerInputChange = _useState61[0],
    setTriggerInputChange = _useState61[1];
  var unboundedPriceRangeValue = -1;
  var minDistanceBetweenHandles = step || 0;
  var track = useClickTracker20();
  var emitSignal = useSignalEmitter();
  var onSignalCallback = React37.useCallback(function () {
    setFilterPillRemoved(true);
    setTriggerInputChange(true);
  }, []);
  var _useExperiment3 = useExperiment3("Flexible_Max_Price_Text_Input"),
    flexibleMaxExposure = _useExperiment3.exposure;
  var formatValue = function (input) {
    if (input === min) {
      return minLabel;
    }
    if (input === max) {
      return maxLabel;
    }
    if (numberFormat) {
      return numberFormatter(numberFormat, input);
    }
    return input;
  };
  var initialRangeOptions = {
    type: "RANGE_OPTIONS" /* RANGE_OPTIONS */,
    analyticsMin: min,
    analyticsMax: max,
    defaultMin: formatValue(min),
    defaultMax: formatValue(max),
    nextMin: formatValue(selected === null || selected === void 0 ? void 0 : selected.min),
    nextMax: formatValue(selected === null || selected === void 0 ? void 0 : selected.max),
    prevMin: formatValue(min),
    prevMax: formatValue(max)
  };
  var handleMinChange = function (event, lower, upper) {
    var safeLowerValue = upper ? lower : min;
    var safeUpperValue = upper || lower;
    var rangeOptions = _object_spread_props(_object_spread({}, initialRangeOptions), {
      analyticsMin: safeLowerValue,
      analyticsMax: safeUpperValue,
      nextMin: formatValue(safeLowerValue),
      nextMax: formatValue(safeUpperValue)
    });
    var isRangeSetToDefault = min === safeLowerValue && max === safeUpperValue;
    if (isRangeSetToDefault) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      });
    } else {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: safeLowerValue,
        max: safeUpperValue
      });
    }
    if (minDistanceBetweenHandles === 0 || typeof upper === "undefined" || safeUpperValue - safeLowerValue >= minDistanceBetweenHandles) {
      if (emitters) {
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], rangeOptions);
      }
    }
    if (minValueAnalytics) {
      track("".concat(minValueAnalytics.referrerId, ".").concat(lower, ".").concat(upper), minValueAnalytics.linkName);
    }
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    setFilterPillRemoved(false);
    return event;
  };
  var handleMaxChange = function (event, lower, upper) {
    var safeLowerValue = upper ? lower : min;
    var safeUpperValue = upper || lower;
    var rangeOptions = _object_spread_props(_object_spread({}, initialRangeOptions), {
      analyticsMin: safeLowerValue,
      analyticsMax: safeUpperValue,
      nextMin: formatValue(safeLowerValue),
      nextMax: formatValue(safeUpperValue)
    });
    var isRangeSetToDefault = min === safeLowerValue && max === safeUpperValue;
    if (isRangeSetToDefault) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      });
    } else {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: safeLowerValue,
        max: safeUpperValue
      });
    }
    if (minDistanceBetweenHandles === 0 || typeof upper === "undefined" || safeUpperValue - safeLowerValue >= minDistanceBetweenHandles) {
      if (emitters) {
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], rangeOptions);
      }
    }
    if (maxValueAnalytics) {
      track("".concat(maxValueAnalytics.referrerId, ".").concat(lower, ".").concat(upper), maxValueAnalytics.linkName);
    }
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    setFilterPillRemoved(false);
    return event;
  };
  var handleRangeSelectionChange = React37.useCallback(function (lower, upper) {
    var safeLowerValue = upper ? lower : min;
    var safeUpperValue = upper || lower;
    var rangeOptions = _object_spread_props(_object_spread({}, initialRangeOptions), {
      analyticsMin: safeLowerValue,
      analyticsMax: safeUpperValue,
      nextMin: formatValue(safeLowerValue),
      nextMax: formatValue(safeUpperValue)
    });
    if (minDistanceBetweenHandles === 0 || typeof upper === "undefined" || safeUpperValue - safeLowerValue >= minDistanceBetweenHandles) {
      if (emitters) {
        emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], rangeOptions);
      }
    }
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    setFilterPillRemoved(false);
  }, [rangeField, onSelectedField]);
  var handleRangeAfterChange = function (e, lower, upper) {
    var safeLowerValue = upper ? lower : min;
    var safeUpperValue = upper || lower;
    var isRangeSetToDefault = min === safeLowerValue && max === safeUpperValue;
    if (safeLowerValue === (selected === null || selected === void 0 ? void 0 : selected.min) && safeUpperValue === (selected === null || selected === void 0 ? void 0 : selected.max)) {
      return;
    }
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    if (isRangeSetToDefault) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      });
    } else {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: safeLowerValue,
        max: safeUpperValue
      });
    }
    if (rangeField === null || rangeField === void 0 ? void 0 : rangeField.analytics) {
      track("".concat(rangeField.analytics.referrerId).concat(!isRangeSetToDefault, ".").concat(safeLowerValue, ",").concat(safeUpperValue), rangeField.analytics.linkName, void 0, mapUisMicroMessage(rangeField.analytics.uisPrimeMessages));
    }
  };
  useEffect4(function () {
    if (shouldFireSignalOnMount) {
      var rangeOptions = _object_spread({}, initialRangeOptions);
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], rangeOptions);
    }
  }, [shouldFireSignalOnMount]);
  useEffect4(function () {
    if (triggerInputChange) {
      onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange({
        id: id,
        min: unboundedPriceRangeValue,
        max: unboundedPriceRangeValue
      });
      onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
      setTriggerInputChange(false);
    }
  }, [triggerInputChange]);
  if ((minValueAccessibility === null || minValueAccessibility === void 0 ? void 0 : minValueAccessibility.__typename) !== "EGDSBasicLocalizedText" || (maxValueAccessibility === null || maxValueAccessibility === void 0 ? void 0 : maxValueAccessibility.__typename) !== "EGDSBasicLocalizedText") {
    return null;
  }
  var _minValueAccessibility_models, _maxValueAccessibility_models;
  return /* @__PURE__ */React37.createElement(React37.Fragment, null, /* @__PURE__ */React37.createElement(RangeTextInputFieldSubscriptions, {
    receivers: receivers,
    onSignalCallback: onSignalCallback
  }), /* @__PURE__ */React37.createElement("fieldset", {
    "data-testid": fieldId
  }, primary && /* @__PURE__ */React37.createElement(EGDSSpacing12, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React37.createElement("legend", null, /* @__PURE__ */React37.createElement(EGDSHeading7, {
    tag: "h4",
    size: 7
  }, primary))), /* @__PURE__ */React37.createElement(SliderTextInputs, {
    onRangeChange: handleRangeSelectionChange,
    onRangeAfterChange: handleRangeAfterChange,
    onMinChange: handleMinChange,
    onMaxChange: handleMaxChange,
    fieldId: fieldId !== null && fieldId !== void 0 ? fieldId : "",
    minValueInput: minValueInput,
    maxValueInput: maxValueInput,
    range: rangeField,
    minValueAccessibility: _object_spread_props(_object_spread({}, minValueAccessibility), {
      models: _to_consumable_array((_minValueAccessibility_models = minValueAccessibility === null || minValueAccessibility === void 0 ? void 0 : minValueAccessibility.models) !== null && _minValueAccessibility_models !== void 0 ? _minValueAccessibility_models : [])
    }),
    maxValueAccessibility: _object_spread_props(_object_spread({}, maxValueAccessibility), {
      models: _to_consumable_array((_maxValueAccessibility_models = maxValueAccessibility === null || maxValueAccessibility === void 0 ? void 0 : maxValueAccessibility.models) !== null && _maxValueAccessibility_models !== void 0 ? _maxValueAccessibility_models : [])
    }),
    lowerBoundAccessibility: lowerBoundAccessibility !== null && lowerBoundAccessibility !== void 0 ? lowerBoundAccessibility : "",
    upperBoundAccessibility: upperBoundAccessibility !== null && upperBoundAccessibility !== void 0 ? upperBoundAccessibility : "",
    numberFormat: numberFormat !== null && numberFormat !== void 0 ? numberFormat : "",
    resetFilters: filterPillRemoved || resetFilters,
    type: type !== null && type !== void 0 ? type : primary,
    allowUserMax: flexibleMaxExposure.bucket === 1,
    loading: loading
  })));
};
RangeTextInputField.displayName = "RangeTextInputField";
RangeTextInputField.fragment = _object_spread_props(_object_spread({}, __Fragment27), {
  __typename: "ShoppingRangeTextInputField"
});
// ../internal/src/components/sort-filter/__private/__fragments/selection-field.tsx
import React39 from "react";
import { gql as gql39 } from "@apollo/client";
import { EGDSExpandoList as EGDSExpandoList2, EGDSExpandoListItem as EGDSExpandoListItem2, EGDSExpandoPeek as EGDSExpandoPeek2 } from "@egds/react-core/expando";
import { useFormCallback as useFormCallback7 } from "@egds/react-core/form";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSRadioButtonGroup } from "@egds/react-core/radio-button";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading8 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker21 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/sort-filter/__private/__fragments/selection-option-field.tsx
import React38 from "react";
import { gql as gql38 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSRadioButton } from "@egds/react-core/radio-button";
import { EGDSText as EGDSText4 } from "@egds/react-core/text";
var __Fragment28 = gql38(_templateObject46(), clientSideAnalyticsFragment);
var SelectionOptionField = function (param) {
  var loading = param.loading,
    data = param.data;
  var fieldId = data.fieldId,
    primary = data.primary,
    secondary = data.secondary,
    disabled = data.disabled,
    value = data.value;
  var uniqueFieldId = React38.useMemo(function () {
    return Math.random().toString(36).slice(2, 5);
  }, []);
  return /* @__PURE__ */React38.createElement(EGDSLayoutFlex8, {
    alignItems: "center",
    space: "two"
  }, /* @__PURE__ */React38.createElement(EGDSLayoutFlexItem9, {
    grow: 1
  }, /* @__PURE__ */React38.createElement("div", null, /* @__PURE__ */React38.createElement(EGDSRadioButton, {
    name: fieldId,
    disabled: disabled || loading,
    id: "".concat(fieldId, "-").concat(value, "-").concat(uniqueFieldId),
    value: value
  }, primary))), secondary && /* @__PURE__ */React38.createElement(EGDSLayoutFlexItem9, {
    shrink: 0
  }, /* @__PURE__ */React38.createElement(EGDSText4, null, secondary)));
};
SelectionOptionField.displayName = "SelectionOptionField";
SelectionOptionField.fragment = __Fragment28;
// ../internal/src/components/sort-filter/__private/__fragments/selection-field.tsx
var __Fragment29 = gql39(_templateObject47(), clientSideAnalyticsFragment, SelectionOptionField.fragment);
var SelectionFieldSubscriptions = function (param) {
  var options = param.options,
    setSelectedFieldValue = param.setSelectedFieldValue;
  var _options_find;
  var defaultValue = (_options_find = options.find(function (option) {
    return option.selected;
  })) === null || _options_find === void 0 ? void 0 : _options_find.value;
  var receivers = options.map(function (option) {
    var _option_receivers;
    return (_option_receivers = option.receivers) !== null && _option_receivers !== void 0 ? _option_receivers : [];
  }).flat();
  return /* @__PURE__ */React39.createElement(React39.Fragment, null, receivers.map(function (receiver, i) {
    var signalId = receiver.signalId.toUpperCase();
    var onSuccess = function (param) {
      var payload = param.payload;
      var type = payload.type,
        filterId = payload.filterId;
      switch (type) {
        case "OPTION" /* OPTION */:
          setSelectedFieldValue(filterId);
          break;
        case "REMOVE" /* REMOVE */:
          setSelectedFieldValue(defaultValue);
          break;
      }
    };
    return /* @__PURE__ */React39.createElement(SignalSubscriber, {
      key: "".concat(signalId, "-").concat(i),
      topic: signalId,
      onSuccess: onSuccess
    });
  }));
};
var SelectionField = function (param) {
  var data = param.data,
    keepSectionExpanded = param.keepSectionExpanded,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    loading = param.loading;
  var _options_find;
  var primary = data.primary,
    secondary = data.secondary,
    expando = data.expando,
    options = data.options;
  var _expando_threshold, _ref;
  var expandoThreshold = (_ref = (_expando_threshold = expando === null || expando === void 0 ? void 0 : expando.threshold) !== null && _expando_threshold !== void 0 ? _expando_threshold : expando === null || expando === void 0 ? void 0 : expando.minimalHeight) !== null && _ref !== void 0 ? _ref : void 0;
  var unexpandedOptions = expandoThreshold != null ? options === null || options === void 0 ? void 0 : options.slice(expandoThreshold || 1) : null;
  var getExpandoIsVisibleState = function () {
    return !!(keepSectionExpanded && (unexpandedOptions === null || unexpandedOptions === void 0 ? void 0 : unexpandedOptions.some(function (option) {
      return option.selected;
    })) || expandoThreshold === 0 && (expando === null || expando === void 0 ? void 0 : expando.visible));
  };
  var defaultValue = options === null || options === void 0 ? void 0 : (_options_find = options.find(function (option) {
    return option.selected;
  })) === null || _options_find === void 0 ? void 0 : _options_find.value;
  var _React39_useState = _sliced_to_array(React39.useState(defaultValue), 2),
    selectedFieldValue = _React39_useState[0],
    setSelectedFieldValue = _React39_useState[1];
  var _React39_useState1 = _sliced_to_array(React39.useState(getExpandoIsVisibleState()), 2),
    expandoIsVisible = _React39_useState1[0],
    setExpandoIsVisible = _React39_useState1[1];
  var emitSignal = useSignalEmitter();
  var track = useClickTracker21();
  var fieldId = (options === null || options === void 0 ? void 0 : options.length) && options[0] ? options[0].fieldId : "";
  var handleChange = useFormCallback7(fieldId, function (event) {
    var _data_options, _data_options1;
    var deselectedOption = (_data_options = data.options) === null || _data_options === void 0 ? void 0 : _data_options.find(function (option) {
      return option.value === selectedFieldValue;
    });
    var selectedOption = (_data_options1 = data.options) === null || _data_options1 === void 0 ? void 0 : _data_options1.find(function (option) {
      return option.value === event.currentTarget.value;
    });
    if (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.deselectAnalytics) {
      var _deselectedOption_deselectAnalytics = deselectedOption.deselectAnalytics,
        referrerId = _deselectedOption_deselectAnalytics.referrerId,
        linkName = _deselectedOption_deselectAnalytics.linkName,
        uisPrimeMessages = _deselectedOption_deselectAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.selectAnalytics) {
      var _selectedOption_selectAnalytics = selectedOption.selectAnalytics,
        referrerId1 = _selectedOption_selectAnalytics.referrerId,
        linkName1 = _selectedOption_selectAnalytics.linkName,
        uisPrimeMessages1 = _selectedOption_selectAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    var _deselectedOption_emitters;
    emitSignal((_deselectedOption_emitters = deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.emitters) !== null && _deselectedOption_emitters !== void 0 ? _deselectedOption_emitters : [], {
      type: "SELECTION_OPTIONS" /* SELECTION_OPTIONS */,
      prevChecked: true
    });
    var _selectedOption_emitters;
    emitSignal((_selectedOption_emitters = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.emitters) !== null && _selectedOption_emitters !== void 0 ? _selectedOption_emitters : [], {
      type: "SELECTION_OPTIONS" /* SELECTION_OPTIONS */,
      prevChecked: false
    });
    setSelectedFieldValue(event.currentTarget.value);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  var handleClick = React39.useCallback(function () {
    setExpandoIsVisible(!expandoIsVisible);
    if ((expando === null || expando === void 0 ? void 0 : expando.expandAnalytics) && !expandoIsVisible) {
      var _expando_expandAnalytics = expando.expandAnalytics,
        referrerId = _expando_expandAnalytics.referrerId,
        linkName = _expando_expandAnalytics.linkName,
        uisPrimeMessages = _expando_expandAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if ((expando === null || expando === void 0 ? void 0 : expando.collapseAnalytics) && expandoIsVisible) {
      var _expando_collapseAnalytics = expando.collapseAnalytics,
        referrerId1 = _expando_collapseAnalytics.referrerId,
        linkName1 = _expando_collapseAnalytics.linkName,
        uisPrimeMessages1 = _expando_collapseAnalytics.uisPrimeMessages;
      track(referrerId1, linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
  }, [setExpandoIsVisible, expandoIsVisible]);
  React39.useEffect(function () {
    setSelectedFieldValue(defaultValue);
  }, [defaultValue]);
  React39.useEffect(function () {
    var _options_find;
    var defaultOptionValue = options === null || options === void 0 ? void 0 : (_options_find = options.find(function (option) {
      return option.default;
    })) === null || _options_find === void 0 ? void 0 : _options_find.value;
    if (resetFilters) {
      setSelectedFieldValue(defaultOptionValue);
    }
  }, [resetFilters]);
  if (!(options === null || options === void 0 ? void 0 : options.length)) {
    return null;
  }
  var Base;
  var expandoProps;
  if (expandoThreshold === 0) {
    Base = EGDSExpandoList2;
    expandoProps = {
      expandoTitle: /* @__PURE__ */React39.createElement(EGDSHeading8, {
        tag: "h4",
        size: 7
      }, primary),
      triggerPosition: "trailing",
      isVisible: expandoIsVisible,
      onToggle: handleClick
    };
  } else if ((expando === null || expando === void 0 ? void 0 : expando.threshold) && (options === null || options === void 0 ? void 0 : options.length) > expando.threshold) {
    Base = EGDSExpandoPeek2;
    var _expando_collapseAccessibilityLabel, _expando_expandAccessibilityLabel;
    expandoProps = {
      collapseLabel: expando.collapseLabel,
      expandLabel: expando.expandLabel,
      collapseA11yLabel: (_expando_collapseAccessibilityLabel = expando.collapseAccessibilityLabel) !== null && _expando_collapseAccessibilityLabel !== void 0 ? _expando_collapseAccessibilityLabel : void 0,
      expandA11yLabel: (_expando_expandAccessibilityLabel = expando.expandAccessibilityLabel) !== null && _expando_expandAccessibilityLabel !== void 0 ? _expando_expandAccessibilityLabel : void 0,
      items: expandoThreshold,
      isVisible: expandoIsVisible,
      hideScrim: true,
      handleClick: handleClick
    };
  } else {
    Base = React39.Fragment;
    expandoProps = {};
  }
  return /* @__PURE__ */React39.createElement(React39.Fragment, null, /* @__PURE__ */React39.createElement(SelectionFieldSubscriptions, {
    options: options,
    setSelectedFieldValue: setSelectedFieldValue
  }), /* @__PURE__ */React39.createElement("fieldset", null, Base === EGDSExpandoList2 ? /* @__PURE__ */React39.createElement(EGDSExpandoList2, null, /* @__PURE__ */React39.createElement(EGDSExpandoListItem2, _object_spread({}, expandoProps), options && /* @__PURE__ */React39.createElement(EGDSRadioButtonGroup, {
    key: selectedFieldValue,
    group: primary !== null && primary !== void 0 ? primary : "",
    selected: selectedFieldValue,
    onChange: handleChange,
    defaultChecked: true
  }, options.map(function (option, optionIndex) {
    return /* @__PURE__ */React39.createElement(SelectionOptionField, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value),
      loading: loading,
      data: option
    });
  })))) : /* @__PURE__ */React39.createElement(React39.Fragment, null, /* @__PURE__ */React39.createElement(EGDSSpacing13, {
    margin: {
      blockend: "two"
    }
  }, secondary ? /* @__PURE__ */React39.createElement(React39.Fragment, null, /* @__PURE__ */React39.createElement("legend", {
    className: "is-visually-hidden"
  }, primary), /* @__PURE__ */React39.createElement(EGDSLayoutFlex9, {
    space: "two"
  }, primary && /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem10, {
    grow: 1
  }, /* @__PURE__ */React39.createElement(EGDSHeading8, {
    tag: "h4",
    size: 7
  }, primary)), /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem10, {
    shrink: 0
  }, /* @__PURE__ */React39.createElement(EGDSHeading8, {
    tag: "h4",
    size: 7
  }, secondary)))) : /* @__PURE__ */React39.createElement("legend", null, primary && /* @__PURE__ */React39.createElement(EGDSHeading8, {
    tag: "h4",
    size: 7
  }, primary))), options && /* @__PURE__ */React39.createElement(EGDSRadioButtonGroup, {
    key: selectedFieldValue,
    group: primary !== null && primary !== void 0 ? primary : "",
    selected: selectedFieldValue,
    onChange: handleChange,
    defaultChecked: true
  }, /* @__PURE__ */React39.createElement(Base, _object_spread({}, expandoProps), options.map(function (option, optionIndex) {
    return /* @__PURE__ */React39.createElement(SelectionOptionField, {
      key: "option-".concat(option.fieldId, "-").concat(optionIndex, "-").concat(option.value),
      loading: loading,
      data: option
    });
  }))))));
};
SelectionField.displayName = "SelectionField";
SelectionField.fragment = _object_spread_props(_object_spread({}, __Fragment29), {
  __typename: "ShoppingSelectionField"
});
// ../internal/src/components/sort-filter/__private/__fragments/step-input-field.tsx
import React40, { useEffect as useEffect5, useState as useState7 } from "react";
import { gql as gql40 } from "@apollo/client";
import { EGDSStepInput } from "@egds/react-core/step-input";
import { EGDSHeading as EGDSHeading9 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker22 } from "@shared-ui/clickstream-analytics-context";
var __Fragment30 = gql40(_templateObject48(), clientSideAnalyticsFragment, ReceiverFragment, EmitterFragment);
var StepInputFieldSubscriptions = function (param) {
  var defaultMin = param.defaultMin,
    receivers = param.receivers,
    setCounter = param.setCounter,
    setTriggerInputChange = param.setTriggerInputChange;
  return /* @__PURE__ */React40.createElement(React40.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (receiver, i) {
    var signalId = receiver.signalId.toUpperCase();
    var onSuccess = function (param) {
      var payload = param.payload;
      if (payload.type === "REMOVE" /* REMOVE */) {
        setCounter(defaultMin);
        setTriggerInputChange(true);
      }
    };
    return /* @__PURE__ */React40.createElement(SignalSubscriber, {
      onSuccess: onSuccess,
      topic: signalId,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var StepInputField = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    resetFilters = param.resetFilters,
    onStepInputChange = param.onStepInputChange;
  var primary = data.primary,
    stepInput = data.stepInput,
    stepInputId = data.stepInputId,
    emitters = data.emitters,
    receivers = data.receivers,
    accessibility = data.accessibility;
  var decreaseText = stepInput.decreaseText,
    increaseText = stepInput.increaseText,
    max = stepInput.max,
    min = stepInput.min,
    label = stepInput.label,
    step = stepInput.step,
    subLabel = stepInput.subLabel,
    value = stepInput.value,
    increaseAnalytics = stepInput.increaseAnalytics,
    decreaseAnalytics = stepInput.decreaseAnalytics;
  var defaultProps = EGDSStepInput.defaultProps;
  var tmp = defaultProps.min,
    defaultPropsMin = tmp === void 0 ? 0 : tmp;
  var defaultMin = min !== null && min !== void 0 ? min : defaultPropsMin;
  var _useState7 = _sliced_to_array(useState7(value), 2),
    counter = _useState7[0],
    setCounter = _useState7[1];
  var _useState71 = _sliced_to_array(useState7(false), 2),
    triggerInputChange = _useState71[0],
    setTriggerInputChange = _useState71[1];
  var track = useClickTracker22();
  var emitSignal = useSignalEmitter();
  useEffect5(function () {
    if (resetFilters) {
      setCounter(defaultMin);
    }
  }, [resetFilters]);
  useEffect5(function () {
    if (triggerInputChange) {
      onStepInputChange === null || onStepInputChange === void 0 ? void 0 : onStepInputChange(stepInputId !== null && stepInputId !== void 0 ? stepInputId : "", counter);
      onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
      setTriggerInputChange(false);
    }
  }, [triggerInputChange]);
  var handleStepInputChange = function (e) {
    var newValue = Number(e.target.value);
    if (increaseAnalytics && newValue > counter) {
      var linkName = increaseAnalytics.linkName,
        referrerId = increaseAnalytics.referrerId,
        uisPrimeMessages = increaseAnalytics.uisPrimeMessages;
      track("".concat(referrerId, ".").concat(newValue !== value), linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    if (decreaseAnalytics && newValue < counter) {
      var linkName1 = decreaseAnalytics.linkName,
        referrerId1 = decreaseAnalytics.referrerId,
        uisPrimeMessages1 = decreaseAnalytics.uisPrimeMessages;
      track("".concat(referrerId1, ".").concat(newValue !== value), linkName1, void 0, mapUisMicroMessage(uisPrimeMessages1));
    }
    var stepInputOptions = {
      type: "STEP_INPUT_OPTIONS" /* STEP_INPUT_OPTIONS */,
      prevValue: counter,
      nextValue: newValue,
      defaultValue: defaultMin
    };
    if (emitters) {
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters, stepInputOptions);
    }
    setCounter(newValue);
    onStepInputChange === null || onStepInputChange === void 0 ? void 0 : onStepInputChange(stepInputId !== null && stepInputId !== void 0 ? stepInputId : "", newValue);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
  };
  return /* @__PURE__ */React40.createElement(React40.Fragment, null, receivers && /* @__PURE__ */React40.createElement(StepInputFieldSubscriptions, {
    defaultMin: defaultMin,
    receivers: receivers,
    setCounter: setCounter,
    setTriggerInputChange: setTriggerInputChange
  }), /* @__PURE__ */React40.createElement(EGDSHeading9, {
    tag: "h4",
    size: 7
  }, primary), /* @__PURE__ */React40.createElement("fieldset", null, /* @__PURE__ */React40.createElement("legend", {
    className: "is-visually-hidden"
  }, accessibility), /* @__PURE__ */React40.createElement(EGDSStepInput, {
    decrementText: decreaseText !== null && decreaseText !== void 0 ? decreaseText : "",
    incrementText: increaseText !== null && increaseText !== void 0 ? increaseText : "",
    max: max !== null && max !== void 0 ? max : defaultProps.max,
    min: defaultMin,
    label: label,
    onChange: handleStepInputChange,
    value: counter,
    step: step || defaultProps.step,
    description: subLabel !== null && subLabel !== void 0 ? subLabel : ""
  })));
};
StepInputField.displayName = "StepInputField";
StepInputField.fragment = _object_spread_props(_object_spread({}, __Fragment30), {
  __typename: "ShoppingStepInputField"
});
// ../internal/src/components/sort-filter/__private/__fragments/mutex-field.tsx
var __Fragment31 = gql41(_templateObject49(), MultiSelectionField.fragment, RangeField.fragment, MultiSelectionStackedTileField.fragment, MultiSelectionTileField.fragment, StepInputField.fragment, SelectionOptionField.fragment, RangeTextInputField.fragment, ReceiverFragment, EmitterFragment);
var validFieldComponents = [DropdownField, MultiSelectionField, RangeField, SelectionField, MultiSelectionStackedTileField, MultiSelectionTileField, StepInputField, RangeTextInputField];
var MutexFieldSubscriptions = function (param) {
  var options = param.options,
    setSelectedFieldValue = param.setSelectedFieldValue;
  var defaultValue = options === null || options === void 0 ? void 0 : options.find(function (option) {
    return option.mutexValue.selected;
  });
  var mutexValueReceivers = options === null || options === void 0 ? void 0 : options.map(function (option) {
    var _option_mutexValue_receivers;
    return (_option_mutexValue_receivers = option.mutexValue.receivers) !== null && _option_mutexValue_receivers !== void 0 ? _option_mutexValue_receivers : [];
  }).flat();
  return /* @__PURE__ */React41.createElement(React41.Fragment, null, mutexValueReceivers === null || mutexValueReceivers === void 0 ? void 0 : mutexValueReceivers.map(function (receiver, i) {
    var signalId = receiver.signalId.toUpperCase();
    var onSuccess = function (param) {
      var payload = param.payload;
      if (payload.type === "REMOVE" /* REMOVE */) {
        setSelectedFieldValue(defaultValue);
      }
    };
    return /* @__PURE__ */React41.createElement(SignalSubscriber, {
      onSuccess: onSuccess,
      topic: signalId,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var MutexField = function (props) {
  var data = props.data,
    onFieldClick = props.onFieldClick,
    onRangeSelectionChange = props.onRangeSelectionChange,
    onStepInputChange = props.onStepInputChange,
    onSelectedField = props.onSelectedField,
    resetFilters = props.resetFilters,
    type = props.type,
    isDatedSearch = props.isDatedSearch,
    loading = props.loading;
  var _useFieldStateContext = useFieldStateContext(),
    dispatch = _useFieldStateContext.dispatch,
    state = _useFieldStateContext.state;
  var mutexStateData = state.field.__typename === data.__typename ? state.field : data;
  var initSignalOnMount = mutexStateData.primary !== null || mutexStateData.secondary !== null;
  var primary = mutexStateData.primary,
    options = mutexStateData.options,
    mutexId = mutexStateData.mutexId;
  var defaultValue = options === null || options === void 0 ? void 0 : options.find(function (option) {
    return option.mutexValue.selected;
  });
  var defaultResetOption = options === null || options === void 0 ? void 0 : options.find(function (option) {
    return option.mutexValue.default;
  });
  var _React41_useState = _sliced_to_array(React41.useState(defaultValue), 2),
    selectedFieldValue = _React41_useState[0],
    setSelectedFieldValue = _React41_useState[1];
  var fieldId = mutexId || "";
  var track = useClickTracker23();
  var emitSignal = useSignalEmitter();
  var handleChange = useFormCallback8(fieldId, function (event) {
    var deselectedOption = options === null || options === void 0 ? void 0 : options.find(function (option) {
      return option.mutexValue.value === (selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value);
    });
    var selectedOption = options === null || options === void 0 ? void 0 : options.find(function (option) {
      return option.mutexValue.value === event.currentTarget.value;
    });
    if (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.mutexValue.deselectAnalytics) {
      var _deselectedOption_mutexValue_deselectAnalytics = deselectedOption.mutexValue.deselectAnalytics,
        referrerId = _deselectedOption_mutexValue_deselectAnalytics.referrerId,
        linkName = _deselectedOption_mutexValue_deselectAnalytics.linkName;
      track(referrerId, linkName);
    }
    if (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.mutexValue.selectAnalytics) {
      var _selectedOption_mutexValue_selectAnalytics = selectedOption.mutexValue.selectAnalytics,
        referrerId1 = _selectedOption_mutexValue_selectAnalytics.referrerId,
        linkName1 = _selectedOption_mutexValue_selectAnalytics.linkName;
      track(referrerId1, linkName1);
    }
    var deselectedOptionEmittedSignalValue = (deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.mutexValue.selected) || true;
    var _deselectedOption_mutexValue_emitters;
    emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal((_deselectedOption_mutexValue_emitters = deselectedOption === null || deselectedOption === void 0 ? void 0 : deselectedOption.mutexValue.emitters) !== null && _deselectedOption_mutexValue_emitters !== void 0 ? _deselectedOption_mutexValue_emitters : [], {
      type: "SELECTION_OPTIONS" /* SELECTION_OPTIONS */,
      prevChecked: deselectedOptionEmittedSignalValue
    });
    var selectedOptionEmittedSignalValue = false;
    var _selectedOption_mutexValue_emitters;
    emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal((_selectedOption_mutexValue_emitters = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.mutexValue.emitters) !== null && _selectedOption_mutexValue_emitters !== void 0 ? _selectedOption_mutexValue_emitters : [], {
      type: "SELECTION_OPTIONS" /* SELECTION_OPTIONS */,
      prevChecked: selectedOptionEmittedSignalValue
    });
    setSelectedFieldValue(selectedOption);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
    return event;
  });
  var handleRangeSelectionChange = function (selected) {
    var id = selected.id,
      min = selected.min,
      max = selected.max;
    dispatch({
      type: "UPDATE_SLIDER_VALUE" /* UPDATE_SLIDER_VALUE_FOR_MUTEX */,
      id: id,
      min: min,
      max: max
    });
    onRangeSelectionChange === null || onRangeSelectionChange === void 0 ? void 0 : onRangeSelectionChange(selected);
    onSelectedField === null || onSelectedField === void 0 ? void 0 : onSelectedField();
  };
  var _useExperiment4 = useExperiment4("VrBex_Default_Pricing_Filter"),
    defaultPricingExposure = _useExperiment4.exposure,
    defaultPricingExperiment = _useExperiment4.logExperiment;
  React41.useEffect(function () {
    if (defaultPricingExposure && isDatedSearch) {
      defaultPricingExperiment(defaultPricingExposure);
    }
  }, [defaultPricingExposure, defaultPricingExperiment, isDatedSearch]);
  React41.useEffect(function () {
    if (resetFilters) {
      dispatch({
        type: "RESET_STATE" /* RESET_STATE_FOR_MUTEX */
      });
      if (defaultPricingExposure.bucket === 1) {
        setSelectedFieldValue(defaultResetOption);
      } else {
        setSelectedFieldValue(defaultValue);
      }
    }
  }, [resetFilters]);
  if (!options) {
    return null;
  }
  return /* @__PURE__ */React41.createElement(React41.Fragment, null, options && /* @__PURE__ */React41.createElement(MutexFieldSubscriptions, {
    options: options,
    setSelectedFieldValue: setSelectedFieldValue
  }), /* @__PURE__ */React41.createElement("fieldset", {
    "data-testid": fieldId
  }, /* @__PURE__ */React41.createElement("legend", null, primary && /* @__PURE__ */React41.createElement(EGDSSpacing14, {
    margin: {
      blockend: "two"
    }
  }, /* @__PURE__ */React41.createElement(EGDSHeading10, {
    "data-testid": primary,
    tag: "h4",
    size: 7
  }, primary))), options && /* @__PURE__ */React41.createElement(EGDSRadioButtonGroup2, {
    selected: selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value,
    key: defaultPricingExposure.bucket === 1 ? selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value : "",
    "data-testid": fieldId,
    onChange: handleChange,
    group: fieldId,
    legendLabel: " ",
    defaultChecked: true
  }, options.map(function (mutexOption, mutexOptionIndex) {
    return /* @__PURE__ */React41.createElement(SelectionOptionField, {
      key: "option-".concat(mutexOption.mutexValue.primary, "-").concat(mutexOptionIndex),
      data: mutexOption.mutexValue
    });
  })), options.map(function (param, optionIndex) {
    var mutexOption = param.mutexOption,
      mutexValue = param.mutexValue;
    var Field = validFieldComponents.find(function (component) {
      return component.fragment.__typename === (selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexOption.__typename);
    });
    var isSelected = mutexValue.value === (selectedFieldValue === null || selectedFieldValue === void 0 ? void 0 : selectedFieldValue.mutexValue.value);
    if (!Field || !isSelected) {
      return null;
    }
    switch (mutexOption.__typename) {
      case RangeField.fragment.__typename:
      case RangeTextInputField.fragment.__typename:
        return /* @__PURE__ */React41.createElement(Field, {
          key: "field-section-".concat(optionIndex),
          data: mutexOption,
          onSelectedField: onSelectedField,
          onRangeSelectionChange: handleRangeSelectionChange,
          resetFilters: resetFilters,
          type: primary !== null && primary !== void 0 ? primary : type,
          shouldFireSignalOnMount: initSignalOnMount,
          loading: loading
        });
      default:
        return /* @__PURE__ */React41.createElement(Field, {
          key: "field-section-".concat(optionIndex),
          data: mutexOption,
          onClick: onFieldClick,
          onSelectedField: onSelectedField,
          resetFilters: resetFilters,
          onStepInputChange: onStepInputChange,
          loading: loading
        });
    }
  })));
};
MutexField.displayName = "MutexField";
MutexField.fragment = _object_spread_props(_object_spread({}, __Fragment31), {
  __typename: "ShoppingMutexField"
});
// ../internal/src/components/sort-filter/__private/__fragments/selected-filters-field.tsx
import React43, { useEffect as useEffect6, useReducer } from "react";
import { gql as gql43 } from "@apollo/client";
import { EGDSPillContainer } from "@egds/react-core/pill";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading11, EGDSParagraph as EGDSParagraph5 } from "@egds/react-core/text";
import { Level, liveAnnounce as liveAnnounce2 } from "@egds/react-core/utils";
import { useExperiment as useExperiment5 } from "@shared-ui/experiment-context";
// ../internal/src/utils/sort-by-selected-fields-ordering.ts
var sortBySelectedFieldsOrdering = function (originalArray, sortingArray) {
  var sortingMap = new Map(sortingArray.map(function (item, index) {
    return [item, index];
  }));
  var shoppingSelectedFilters = JSON.parse(JSON.stringify(originalArray));
  return shoppingSelectedFilters.sort(function (previousFilter, currentFilter) {
    var _previousFilter_filter, _currentFilter_filter;
    if (((_previousFilter_filter = previousFilter.filter) === null || _previousFilter_filter === void 0 ? void 0 : _previousFilter_filter.__typename) === "EGDSBasicRemovablePill" && previousFilter.filter.id && ((_currentFilter_filter = currentFilter.filter) === null || _currentFilter_filter === void 0 ? void 0 : _currentFilter_filter.__typename) === "EGDSBasicRemovablePill" && currentFilter.filter.id) {
      var previousIndex = sortingMap.get(previousFilter.filter.id);
      var currentIndex = sortingMap.get(currentFilter.filter.id);
      if (previousIndex === void 0 && currentIndex === void 0) {
        return 0;
      }
      if (previousIndex === void 0) {
        return 1;
      }
      if (currentIndex === void 0) {
        return -1;
      }
      return previousIndex - currentIndex;
    }
    return 0;
  });
};
// ../internal/src/components/sort-filter/__private/__fragments/selected-filter.tsx
import React42 from "react";
import { gql as gql42 } from "@apollo/client";
var __Fragment32 = gql42(_templateObject50(), EmitterFragment, EGDSBasicRemovablePill.fragment);
var SelectedFilter = function (param) {
  var data = param.data,
    loading = param.loading,
    onRemoveFilterPill = param.onRemoveFilterPill;
  var filter = data.filter,
    emitters = data.emitters;
  var emitSignal = useSignalEmitter();
  if ((filter === null || filter === void 0 ? void 0 : filter.__typename) !== "EGDSBasicRemovablePill") {
    return null;
  }
  var id = filter.id,
    primary = filter.primary,
    name = filter.name,
    accessibility = filter.accessibility;
  if (!id || !primary || !name || !accessibility) {
    return null;
  }
  var handleClick = function () {
    onRemoveFilterPill === null || onRemoveFilterPill === void 0 ? void 0 : onRemoveFilterPill(id);
    if (emitters) {
      emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : []);
    }
  };
  return /* @__PURE__ */React42.createElement(EGDSBasicRemovablePill, {
    data: filter,
    loading: loading,
    onClick: handleClick
  });
};
SelectedFilter.displayName = "SelectedFilter";
SelectedFilter.fragment = __Fragment32;
// ../internal/src/components/sort-filter/__private/__fragments/selected-filters-field.tsx
var __Fragment33 = gql43(_templateObject51(), SelectedFilter.fragment, ReceiverFragment);
var SelectedFiltersFieldSubscriptions = function (param) {
  var receivers = param.receivers,
    dispatch = param.dispatch;
  return /* @__PURE__ */React43.createElement(React43.Fragment, null, receivers.map(function (receiver, i) {
    var signalId = receiver.signalId.toUpperCase();
    var onSuccess = function (signal) {
      dispatch({
        type: "SortAndFilterSignal" /* SIGNAL */,
        signal: signal
      });
    };
    return /* @__PURE__ */React43.createElement(SignalSubscriber, {
      key: "".concat(signalId, "-").concat(i),
      topic: signalId,
      onSuccess: onSuccess
    });
  }));
};
var SelectedFiltersField = function (param) {
  var data = param.data,
    resetFilters = param.resetFilters,
    focusNextElement = param.focusNextElement,
    loading = param.loading;
  var _useExperiment5 = useExperiment5("Filter_Facet_Counts_native_BEXGH"),
    filterFacetCountsExposure = _useExperiment5.exposure;
  var filterFacetCountsExposureBucketValue = filterFacetCountsExposure.bucket === 1;
  var selectedFiltersFieldAccessiblity = data.selectedFiltersFieldAccessiblity,
    primary = data.primary,
    secondary = data.secondary,
    shoppingSelectedFilters = data.shoppingSelectedFilters,
    receivers = data.receivers,
    selectedFiltersOrdering = data.selectedFiltersOrdering;
  var _useReducer = _sliced_to_array(useReducer(selectedFiltersReducer, {
      selectedFilters: _to_consumable_array(shoppingSelectedFilters !== null && shoppingSelectedFilters !== void 0 ? shoppingSelectedFilters : [])
    }), 2),
    selectedFilters = _useReducer[0].selectedFilters,
    dispatch = _useReducer[1];
  var _ref;
  var ariaLabel = (_ref = (selectedFiltersFieldAccessiblity === null || selectedFiltersFieldAccessiblity === void 0 ? void 0 : selectedFiltersFieldAccessiblity.__typename) === "EGDSCardinalLocalizedText" ? selectedFiltersFieldAccessiblity.accessibilityText : selectedFiltersFieldAccessiblity === null || selectedFiltersFieldAccessiblity === void 0 ? void 0 : selectedFiltersFieldAccessiblity.text) !== null && _ref !== void 0 ? _ref : "";
  var liveAnnounceRef = React43.useRef(null);
  var prevSelectedFiltersLength = React43.useRef(selectedFilters.length);
  useEffect6(function () {
    if (resetFilters) {
      dispatch({
        type: "CLEAR_ALL_FILTERS" /* CLEAR_ALL_FILTERS */
      });
    }
  }, [resetFilters]);
  useEffect6(function () {
    if (filterFacetCountsExposureBucketValue) {
      dispatch({
        type: "RESET_WITH_QUERY" /* RESET_WITH_QUERY */,
        payload: _to_consumable_array(shoppingSelectedFilters !== null && shoppingSelectedFilters !== void 0 ? shoppingSelectedFilters : [])
      });
    }
  }, [JSON.stringify(shoppingSelectedFilters)]);
  useEffect6(function () {
    if (prevSelectedFiltersLength.current === 0 && selectedFilters.length === 1) {
      liveAnnounce2("A list of your filter selections have been added. Check headings menu to review.", Level.POLITE, "is-visually-hidden", liveAnnounceRef, "selected-filter-field-live");
    }
    prevSelectedFiltersLength.current = selectedFilters.length;
  }, [selectedFilters.length]);
  if (selectedFilters.length === 0) {
    return receivers ? /* @__PURE__ */React43.createElement(SelectedFiltersFieldSubscriptions, {
      receivers: receivers,
      dispatch: dispatch
    }) : null;
  }
  var orderedSelectedFilters = selectedFiltersOrdering ? sortBySelectedFieldsOrdering(selectedFilters, selectedFiltersOrdering) : selectedFilters;
  var handleFilterClick = function (id) {
    var _lastOrderedSelectedFilter_filter;
    var lastOrderedSelectedFilter = orderedSelectedFilters.at(-1);
    var isLastFilterPill = (lastOrderedSelectedFilter === null || lastOrderedSelectedFilter === void 0 ? void 0 : (_lastOrderedSelectedFilter_filter = lastOrderedSelectedFilter.filter) === null || _lastOrderedSelectedFilter_filter === void 0 ? void 0 : _lastOrderedSelectedFilter_filter.__typename) === "EGDSBasicRemovablePill" && lastOrderedSelectedFilter.filter.id === id;
    if (isLastFilterPill) {
      focusNextElement === null || focusNextElement === void 0 ? void 0 : focusNextElement();
    }
    dispatch({
      type: "CLEAR_FILTER_BY_ID" /* CLEAR_FILTER_BY_ID */,
      payload: id
    });
  };
  return /* @__PURE__ */React43.createElement(React43.Fragment, null, receivers && /* @__PURE__ */React43.createElement(SelectedFiltersFieldSubscriptions, {
    receivers: receivers,
    dispatch: dispatch
  }), /* @__PURE__ */React43.createElement("fieldset", {
    "data-testid": "selected-filter-field",
    ref: liveAnnounceRef
  }, /* @__PURE__ */React43.createElement("legend", null, primary && /* @__PURE__ */React43.createElement(EGDSHeading11, {
    tag: "h4",
    size: 7,
    "aria-label": ariaLabel
  }, primary)), secondary && /* @__PURE__ */React43.createElement(EGDSParagraph5, null, secondary), /* @__PURE__ */React43.createElement(EGDSSpacing15, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React43.createElement(EGDSPillContainer, {
    wrap: true
  }, orderedSelectedFilters.map(function (selectedFilter, index) {
    return /* @__PURE__ */React43.createElement(SelectedFilter, {
      key: "selected-filter-".concat(index),
      data: selectedFilter,
      onRemoveFilterPill: handleFilterClick,
      loading: loading
    });
  })))));
};
SelectedFiltersField.displayName = "SelectedFiltersField";
SelectedFiltersField.fragment = _object_spread_props(_object_spread({}, __Fragment33), {
  __typename: "ShoppingSelectedFiltersField"
});
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field.tsx
import React46 from "react";
import { gql as gql44 } from "@apollo/client";
import { EGDSTextInput } from "@egds/react-core/input";
import { EGDSHeading as EGDSHeading12 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker26 } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field-multi-typeahead.tsx
import React44 from "react";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { EGDSTypeahead, ESSAdapter } from "@egds/react-core/typeahead";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker24 } from "@shared-ui/clickstream-analytics-context";
var TextInputFieldMultiTypeahead = function (props) {
  var onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onSelectionChange = props.onSelectionChange,
    label = props.label,
    placeholder = props.placeholder,
    icon = props.icon,
    multiSelections = props.multiSelections,
    id = props.id,
    typeaheadInfo = props.typeaheadInfo,
    typeaheadAdapter = props.typeaheadAdapter,
    analytics = props.analytics,
    typeaheadLogger = props.typeaheadLogger,
    resetFilters = props.resetFilters;
  var context = useBexApi().context;
  var _ref = typeaheadInfo || {},
    client = _ref.client,
    isDestination = _ref.isDestination,
    lineOfBusiness = _ref.lineOfBusiness,
    maxNumberOfResults = _ref.maxNumberOfResults,
    regionType = _ref.regionType,
    typeaheadFeatures = _ref.typeaheadFeatures,
    categorize = _ref.categorize,
    allowExactMatch = _ref.allowExactMatch,
    dismissButtonText = _ref.dismissButtonText,
    listTitle = _ref.listTitle,
    typeaheadMultiSelect = _ref.typeaheadMultiSelect,
    emptyResultsPlaceholder = _ref.emptyResultsPlaceholder;
  var _ref1 = typeaheadMultiSelect || {},
    isMultiLocation = _ref1.isMultiLocation,
    showPills = _ref1.showPills,
    selectedItemHeading = _ref1.selectedItemHeading,
    clearAllText = _ref1.clearAllText;
  var identity = context.identity,
    locale = context.locale,
    siteId = context.siteId;
  var expuserid = Number(identity === null || identity === void 0 ? void 0 : identity.expUserId) || -1;
  var _ref2 = identity || {},
    guid = _ref2.duaid;
  var defaultMaxNumberOfResults = 10;
  var essAdapter = typeaheadAdapter !== null && typeaheadAdapter !== void 0 ? typeaheadAdapter : new ESSAdapter({
    client: client !== null && client !== void 0 ? client : "",
    domain: "https://www.expedia.com/",
    dest: isDestination !== null && isDestination !== void 0 ? isDestination : true,
    expuserid: expuserid,
    features: typeaheadFeatures !== null && typeaheadFeatures !== void 0 ? typeaheadFeatures : "",
    guid: guid,
    lob: lineOfBusiness !== null && lineOfBusiness !== void 0 ? lineOfBusiness : "",
    locale: locale,
    maxResults: maxNumberOfResults || defaultMaxNumberOfResults,
    regionType: regionType || 128,
    siteId: siteId,
    typeaheadLogger: typeaheadLogger
  });
  var currentMultiSelection = React44.useMemo(function () {
    return multiSelections ? multiSelections.map(function (item) {
      return {
        term: item.text,
        data: {
          value: item.value
        }
      };
    }) : [];
  }, [multiSelections]);
  var _React44_useState = _sliced_to_array(React44.useState(currentMultiSelection), 2),
    selection = _React44_useState[0],
    setSelection = _React44_useState[1];
  React44.useEffect(function () {
    setSelection(resetFilters ? [] : currentMultiSelection);
  }, [currentMultiSelection, resetFilters]);
  var track = useClickTracker24();
  var handleUpdate = function (typeaheadSelection) {
    var isNewSelectionRepeated = selection.find(function (item) {
      return item === typeaheadSelection;
    });
    if (!isNewSelectionRepeated && typeaheadSelection.data) {
      setSelection(function (prevSelection) {
        return _to_consumable_array(prevSelection).concat([typeaheadSelection]);
      });
      onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(typeaheadSelection, id);
    }
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      track(referrerId, linkName);
    }
  };
  var handleRemove = function (selectedIndex) {
    if (selection.length > 0) {
      setSelection(selection.filter(function (_, i) {
        return i !== selectedIndex;
      }));
      var selectedSelection = selection[selectedIndex];
      if (selectedSelection) {
        onMultiSelectItemRemove === null || onMultiSelectItemRemove === void 0 ? void 0 : onMultiSelectItemRemove(selectedSelection, id);
      }
    }
  };
  var handleClear = function () {
    setSelection([]);
    onMultiSelectClearAll === null || onMultiSelectClearAll === void 0 ? void 0 : onMultiSelectClearAll(id);
    onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
      term: "",
      data: {}
    }, id);
  };
  var handleDismiss = function (renderType) {
    onMultiSelectClose === null || onMultiSelectClose === void 0 ? void 0 : onMultiSelectClose(renderType, id, selection);
  };
  var _ref3, _icon_id;
  return /* @__PURE__ */React44.createElement(EGDSSpacing16, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React44.createElement("div", null, /* @__PURE__ */React44.createElement(EGDSTypeahead, {
    stid: id,
    id: id,
    name: id,
    value: selection.map(function (item) {
      return item.term;
    }),
    label: (_ref3 = label !== null && label !== void 0 ? label : placeholder) !== null && _ref3 !== void 0 ? _ref3 : "",
    icon: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : "",
    typeaheadPlaceholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    adapter: essAdapter,
    onUpdate: handleUpdate,
    onItemRemove: isMultiLocation ? handleRemove : void 0,
    handleClear: handleClear,
    onDismiss: isMultiLocation ? handleDismiss : void 0,
    isMulti: isMultiLocation !== null && isMultiLocation !== void 0 ? isMultiLocation : false,
    categorize: categorize,
    allowExactMatch: allowExactMatch,
    listTitle: listTitle,
    selectedItemHeading: selectedItemHeading !== null && selectedItemHeading !== void 0 ? selectedItemHeading : "",
    clearAllText: clearAllText !== null && clearAllText !== void 0 ? clearAllText : "",
    dismissButtonText: dismissButtonText !== null && dismissButtonText !== void 0 ? dismissButtonText : "",
    showPills: showPills,
    hasClearButton: true,
    typeaheadEmptyResultPlaceholder: emptyResultsPlaceholder !== null && emptyResultsPlaceholder !== void 0 ? emptyResultsPlaceholder : ""
  })));
};
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field-typeahead.tsx
import React45 from "react";
import { EGDSTypeahead as EGDSTypeahead2, ESSAdapter as ESSAdapter2 } from "@egds/react-core/typeahead";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker25 } from "@shared-ui/clickstream-analytics-context";
var TextInputFieldSubscriptions = function (param) {
  var receivers = param.receivers,
    onSignalCallback = param.onSignalCallback;
  return /* @__PURE__ */React45.createElement(React45.Fragment, null, receivers === null || receivers === void 0 ? void 0 : receivers.map(function (receiver, i) {
    var signalId = receiver.signalId.toUpperCase();
    var onSuccess = function (param) {
      var payload = param.payload;
      if (payload.type === "REMOVE" /* REMOVE */) {
        onSignalCallback();
      }
    };
    return /* @__PURE__ */React45.createElement(SignalSubscriber, {
      onSuccess: onSuccess,
      topic: signalId,
      key: "".concat(signalId, "-").concat(i)
    });
  }));
};
var TextInputFieldTypeahead = function (props) {
  var onSelectionChange = props.onSelectionChange,
    label = props.label,
    placeholder = props.placeholder,
    icon = props.icon,
    selected = props.selected,
    id = props.id,
    typeaheadInfo = props.typeaheadInfo,
    typeaheadAdapter = props.typeaheadAdapter,
    analytics = props.analytics,
    typeaheadLogger = props.typeaheadLogger,
    clearButtonAnalytics = props.clearButtonAnalytics,
    resetFilters = props.resetFilters,
    emitters = props.emitters,
    receivers = props.receivers,
    secondary = props.secondary;
  var emitSignal = useSignalEmitter();
  var context = useBexApi2().context;
  var track = useClickTracker25();
  var _React45_useState = _sliced_to_array(React45.useState(selected), 2),
    selection = _React45_useState[0],
    setSelection = _React45_useState[1];
  var onSignalCallback = React45.useCallback(function () {
    setSelection("");
    onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
      term: "",
      data: {}
    }, id);
  }, []);
  React45.useEffect(function () {
    setSelection(resetFilters ? "" : selected);
  }, [selected, resetFilters]);
  var _ref = typeaheadInfo || {},
    client = _ref.client,
    isDestination = _ref.isDestination,
    lineOfBusiness = _ref.lineOfBusiness,
    maxNumberOfResults = _ref.maxNumberOfResults,
    regionType = _ref.regionType,
    regionId = _ref.regionId,
    typeaheadFeatures = _ref.typeaheadFeatures,
    categorize = _ref.categorize,
    allowExactMatch = _ref.allowExactMatch,
    listTitle = _ref.listTitle;
  var identity = context.identity,
    locale = context.locale,
    siteId = context.siteId;
  var expuserid = Number(identity === null || identity === void 0 ? void 0 : identity.expUserId) || -1;
  var _ref1 = identity || {},
    guid = _ref1.duaid;
  var defaultMaxNumberOfResults = 10;
  var essAdapter = typeaheadAdapter !== null && typeaheadAdapter !== void 0 ? typeaheadAdapter : new ESSAdapter2({
    client: client !== null && client !== void 0 ? client : "",
    domain: "https://www.expedia.com/",
    dest: isDestination !== null && isDestination !== void 0 ? isDestination : true,
    expuserid: expuserid,
    features: typeaheadFeatures !== null && typeaheadFeatures !== void 0 ? typeaheadFeatures : "",
    guid: guid,
    lob: lineOfBusiness !== null && lineOfBusiness !== void 0 ? lineOfBusiness : "",
    locale: locale,
    maxResults: maxNumberOfResults || defaultMaxNumberOfResults,
    regionType: regionType || 128,
    siteId: siteId,
    typeaheadLogger: typeaheadLogger,
    regionId: regionId !== null && regionId !== void 0 ? regionId : ""
  });
  var handleUpdate = function (typeaheadSelection) {
    var typeaheadOptions = {
      type: "TYPEAHEAD_OPTIONS" /* TYPEAHEAD_OPTIONS */,
      selection: typeaheadSelection.term
    };
    emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], typeaheadOptions);
    setSelection(typeaheadSelection.term);
    onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(typeaheadSelection, id);
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      var updateReferrerId = "".concat(referrerId).concat(typeaheadSelection.term);
      track(updateReferrerId, linkName);
    }
  };
  var handleClear = function () {
    emitSignal === null || emitSignal === void 0 ? void 0 : emitSignal(emitters !== null && emitters !== void 0 ? emitters : [], {
      type: "TYPEAHEAD_OPTIONS" /* TYPEAHEAD_OPTIONS */,
      selection: ""
    });
    setSelection("");
    onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
      term: "",
      data: {}
    }, id);
    if (clearButtonAnalytics) {
      var referrerId = clearButtonAnalytics.referrerId,
        linkName = clearButtonAnalytics.linkName;
      track(referrerId, linkName);
    }
  };
  var _ref2, _icon_id;
  return /* @__PURE__ */React45.createElement(React45.Fragment, null, receivers && /* @__PURE__ */React45.createElement(TextInputFieldSubscriptions, {
    receivers: receivers,
    onSignalCallback: onSignalCallback
  }), /* @__PURE__ */React45.createElement(EGDSTypeahead2, {
    id: id,
    name: id,
    value: selection !== null && selection !== void 0 ? selection : "",
    label: (_ref2 = label !== null && label !== void 0 ? label : placeholder) !== null && _ref2 !== void 0 ? _ref2 : "",
    icon: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : "",
    typeaheadPlaceholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    adapter: essAdapter,
    onUpdate: handleUpdate,
    handleClear: handleClear,
    categorize: categorize,
    allowExactMatch: allowExactMatch,
    listTitle: listTitle,
    accessibilityLabel: secondary !== null && secondary !== void 0 ? secondary : "",
    hasClearButton: true
  }));
};
// ../internal/src/components/sort-filter/__private/__fragments/text-input-field.tsx
var __Fragment34 = gql44(_templateObject52(), clientSideAnalyticsFragment, ReceiverFragment, EmitterFragment);
var TextInputField = function (props) {
  var _typeaheadInfo_typeaheadMultiSelect, _typeaheadInfo_typeaheadMultiSelect1;
  var data = props.data,
    onKeyDown = props.onKeyDown,
    onDone = props.onDone,
    resetFilters = props.resetFilters,
    loading = props.loading;
  var primary = data.primary,
    label = data.label,
    placeholder = data.placeholder,
    icon = data.icon,
    selected = data.selected,
    id = data.id,
    typeaheadInfo = data.typeaheadInfo,
    analytics = data.analytics;
  var _React46_useState = _sliced_to_array(React46.useState(selected !== null && selected !== void 0 ? selected : ""), 2),
    value = _React46_useState[0],
    setValue = _React46_useState[1];
  var track = useClickTracker26();
  React46.useEffect(function () {
    setValue(resetFilters ? "" : selected || "");
  }, [selected, resetFilters]);
  var handleChange = function (event) {
    setValue(event.target.value);
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
  };
  var handleKeyDown = function (event) {
    if (event.key === "Enter") {
      event.preventDefault();
      var inputElement = event.target;
      setValue(inputElement.value);
      if (onKeyDown) {
        onKeyDown({
          name: id,
          value: inputElement.value
        }, event);
      }
      if (analytics) {
        var referrerId = analytics.referrerId,
          linkName = analytics.linkName,
          uisPrimeMessages = analytics.uisPrimeMessages;
        track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
      }
    }
  };
  var handleBlur = function (event) {
    event.preventDefault();
    setValue(event.target.value);
    if (onDone) {
      onDone({
        name: id,
        value: event.target.value
      }, event);
    }
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName,
        uisPrimeMessages = analytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
  };
  var _icon_id;
  return /* @__PURE__ */React46.createElement(React46.Fragment, null, primary && /* @__PURE__ */React46.createElement(EGDSHeading12, {
    tag: "h4",
    size: 7
  }, primary), !typeaheadInfo && /* @__PURE__ */React46.createElement(EGDSTextInput, {
    label: label !== null && label !== void 0 ? label : "",
    id: id,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
    icon: (_icon_id = icon === null || icon === void 0 ? void 0 : icon.id) !== null && _icon_id !== void 0 ? _icon_id : "",
    value: value,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur,
    disabled: loading
  }), typeaheadInfo && !((_typeaheadInfo_typeaheadMultiSelect = typeaheadInfo.typeaheadMultiSelect) === null || _typeaheadInfo_typeaheadMultiSelect === void 0 ? void 0 : _typeaheadInfo_typeaheadMultiSelect.isMultiLocation) && /* @__PURE__ */React46.createElement(TextInputFieldTypeahead, _object_spread({}, data, props)), (typeaheadInfo === null || typeaheadInfo === void 0 ? void 0 : (_typeaheadInfo_typeaheadMultiSelect1 = typeaheadInfo.typeaheadMultiSelect) === null || _typeaheadInfo_typeaheadMultiSelect1 === void 0 ? void 0 : _typeaheadInfo_typeaheadMultiSelect1.isMultiLocation) && /* @__PURE__ */React46.createElement(TextInputFieldMultiTypeahead, _object_spread({}, data, props)));
};
TextInputField.displayName = "TextInputField";
TextInputField.fragment = _object_spread_props(_object_spread({}, __Fragment34), {
  __typename: "ShoppingTextInputField"
});
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filter-field.tsx
var __Fragment35 = gql45(_templateObject53(), SortAndFilterEGDSPill.fragment, Toolbar.fragment, SortAndFilterEGDSSecondaryButton.fragment, DropdownField.fragment, MultiSelectionField.fragment, RangeField.fragment, SelectionField.fragment, TextInputField.fragment, MultiSelectionStackedTileField.fragment, MultiSelectionTileField.fragment, StepInputField.fragment, MutexField.fragment, SelectedFiltersField.fragment, QuickAccessFilterSheetFooter.fragment, RangeTextInputField.fragment);
var validFieldComponents2 = [DropdownField, MultiSelectionField, RangeField, SelectionField, TextInputField, MultiSelectionStackedTileField, MultiSelectionTileField, StepInputField, MutexField, SelectedFiltersField, RangeTextInputField];
var QuickAccessFilterField = function (param) {
  var data = param.data,
    keepSectionExpanded = param.keepSectionExpanded,
    onSubmit = param.onSubmit,
    onFieldClick = param.onFieldClick,
    onRangeSelectionChange = param.onRangeSelectionChange,
    onStepInputChange = param.onStepInputChange,
    onSelectedField = param.onSelectedField,
    handleClearButtonClick = param.handleClearButtonClick,
    loading = param.loading,
    isSheetVisible = param.isSheetVisible,
    onSheetToggle = param.onSheetToggle,
    sheetIndex = param.sheetIndex,
    onSheetDismiss = param.onSheetDismiss,
    footerDataLoading = param.footerDataLoading,
    lastQuickFilter = param.lastQuickFilter,
    isDatedSearch = param.isDatedSearch,
    quickFilterCarouselButtonExposure = param.quickFilterCarouselButtonExposure,
    quickFiltersVrboArrowExposure = param.quickFiltersVrboArrowExposure,
    shouldDisplayToolbarForQuickAccessFilters = param.shouldDisplayToolbarForQuickAccessFilters,
    xLOBLodgingMwebExposure = param.xLOBLodgingMwebExposure,
    xLOBQAFExposure = param.xLOBQAFExposure,
    isBexSplitViewEnabled = param.isBexSplitViewEnabled,
    className = param.className;
  var filterPill = data.filterPill,
    resultCountLabel = data.resultCountLabel,
    applyAction = data.applyAction,
    fields = data.fields,
    toolbar = data.toolbar;
  var isSmallViewSize = useMediaQueries2({
    viewSizes: defaultViewSizes2
  }) === defaultViewSizes2.SMALL;
  var isMediumViewSize = useMediaQueries2({
    viewSizes: defaultViewSizes2
  }) === defaultViewSizes2.MEDIUM;
  var _useDialog2 = _sliced_to_array(useDialog2("shopping-sort-and-filter-quick-filter-dialog-".concat(sheetIndex)), 3),
    isOpen = _useDialog2[0],
    _useDialog2_ = _useDialog2[1],
    openDialog = _useDialog2_.openDialog,
    closeDialog = _useDialog2_.closeDialog,
    DialogComponent = _useDialog2[2];
  var _useExperiment6 = useExperiment6("Filter_Removal_Phase_1_VrBex"),
    filterRemovalP1Exposure = _useExperiment6.exposure,
    filterRemovalP1ExperimentLogger = _useExperiment6.logExperiment;
  var _React47_useState = _sliced_to_array(React47.useState(false), 2),
    resetFilters = _React47_useState[0],
    setResetFilters = _React47_useState[1];
  var _React47_useState1 = _sliced_to_array(React47.useState([]), 2),
    quickAccessFields = _React47_useState1[0],
    setQuickAccessFields = _React47_useState1[1];
  var domRef = React47.useRef(null);
  var closeButtonClicked = React47.useRef(true);
  var submitButtonClicked = React47.useRef(true);
  var isXLOBMwebEnabled = (xLOBLodgingMwebExposure === null || xLOBLodgingMwebExposure === void 0 ? void 0 : xLOBLodgingMwebExposure.bucket) === 1;
  var useBottomSheetForTablet = isXLOBMwebEnabled && isMediumViewSize;
  var shouldEnableSubmitOnScrimClick = (quickFilterCarouselButtonExposure === null || quickFilterCarouselButtonExposure === void 0 ? void 0 : quickFilterCarouselButtonExposure.bucket) === 1 || (quickFiltersVrboArrowExposure === null || quickFiltersVrboArrowExposure === void 0 ? void 0 : quickFiltersVrboArrowExposure.bucket) === 1 || isBexSplitViewEnabled;
  React47.useEffect(function () {
    if (data.__typename === "ShoppingSortAndFilterQuickFilter") {
      var returnQuickFilterFields = calculateQuickFilterFields(data.fields);
      setQuickAccessFields(returnQuickFilterFields);
    }
  }, [data.__typename, data.fields]);
  React47.useEffect(function () {
    if (resetFilters) {
      setResetFilters(false);
    }
    if (!isSheetVisible && !submitButtonClicked.current) {
      onSheetDismiss === null || onSheetDismiss === void 0 ? void 0 : onSheetDismiss({
        name: "restore" /* RESTORE */,
        value: {}
      });
    }
  }, [resetFilters, isSheetVisible]);
  React47.useEffect(function () {
    if (!isSmallViewSize) {
      if (!isSheetVisible && !closeButtonClicked.current && !submitButtonClicked.current && shouldEnableSubmitOnScrimClick) {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
      }
      closeButtonClicked.current = false;
      submitButtonClicked.current = false;
    }
  }, [isSheetVisible]);
  React47.useEffect(function () {
    if (!isOpen && isSheetVisible) {
      onSheetToggle(sheetIndex, filterPill === null || filterPill === void 0 ? void 0 : filterPill.id);
    }
    if (!isOpen && !closeButtonClicked.current && !submitButtonClicked.current) {
      if (shouldEnableSubmitOnScrimClick && (isSmallViewSize || useBottomSheetForTablet)) {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
      }
      return;
    }
    closeButtonClicked.current = false;
    submitButtonClicked.current = false;
  }, [isOpen]);
  if ((filterPill === null || filterPill === void 0 ? void 0 : filterPill.__typename) !== "EGDSBasicTriggerPill") {
    return null;
  }
  var filterPillData = _object_spread_props(_object_spread({}, filterPill), {
    disabled: loading !== null && loading !== void 0 ? loading : false
  });
  var toolbarPrimary = toolbar === null || toolbar === void 0 ? void 0 : toolbar.primary;
  var toolbarSecondaries = toolbar === null || toolbar === void 0 ? void 0 : toolbar.actions.secondaries;
  var _ref = _sliced_to_array(toolbarSecondaries !== null && toolbarSecondaries !== void 0 ? toolbarSecondaries : [], 1),
    clearAll = _ref[0];
  var clearButtonClick = function () {
    setResetFilters(true);
    handleClearButtonClick === null || handleClearButtonClick === void 0 ? void 0 : handleClearButtonClick(quickAccessFields);
  };
  var toggleSheet = function () {
    if (isSmallViewSize || useBottomSheetForTablet) {
      openDialog();
    }
    onSheetToggle(sheetIndex, filterPill.id);
    var fieldsExceptSortAndPrice = data.fields.filter(function (field) {
      return field.__typename !== "ShoppingMutexField" && field.__typename !== "ShoppingSelectionField";
    });
    if (fieldsExceptSortAndPrice.length !== 0 && !isSheetVisible) {
      filterRemovalP1ExperimentLogger(filterRemovalP1Exposure);
    }
  };
  var handleSubmit = function () {
    if (isSmallViewSize || useBottomSheetForTablet) {
      closeDialog();
    }
    submitButtonClicked.current = true;
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    onSheetToggle(sheetIndex, filterPill.id);
  };
  var closeSheet = function () {
    if (isSmallViewSize || useBottomSheetForTablet) {
      closeDialog();
      closeButtonClicked.current = true;
    }
    onSheetToggle(sheetIndex, filterPill.id);
  };
  var hasSupportedFields = fields.some(function (param) {
    var __typename = param.__typename;
    return validFieldComponents2.find(function (param) {
      var fragment5 = param.fragment;
      return fragment5.__typename === __typename;
    });
  });
  if (!hasSupportedFields) {
    return null;
  }
  var quickAccessFilterSheetFooterData = {
    __typename: "ShoppingSortAndFilterQuickFilter",
    resultCountLabel: resultCountLabel,
    applyAction: applyAction,
    filterPill: {
      __typename: "EGDSBasicTriggerPill",
      id: filterPillData.id
    }
  };
  return /* @__PURE__ */React47.createElement(React47.Fragment, null, /* @__PURE__ */React47.createElement(SortAndFilterEGDSPill, {
    data: filterPillData,
    onClick: toggleSheet,
    active: isSheetVisible,
    domRef: domRef,
    shouldRegisterToForm: false,
    className: className,
    triggerPill: true,
    loading: loading
  }), /* @__PURE__ */React47.createElement(QuickAccessFilterSheetWrapper, {
    DialogComponent: DialogComponent,
    triggerRef: domRef,
    isVisible: isSheetVisible,
    onDismiss: toggleSheet,
    lastQuickfilter: lastQuickFilter,
    isBottomSheet: useBottomSheetForTablet
  }, shouldDisplayToolbarForQuickAccessFilters || isSmallViewSize ? toolbar && /* @__PURE__ */React47.createElement(Toolbar, {
    onClearAllButtonClick: clearButtonClick,
    onCloseButtonClick: closeSheet,
    data: toolbar
  }) : /* @__PURE__ */React47.createElement(EGDSSpacing17, {
    padding: {
      small: "four",
      medium: {
        inlinestart: "six",
        blockstart: "six",
        inlineend: "six",
        blockend: "two"
      }
    }
  }, /* @__PURE__ */React47.createElement(EGDSLayoutFlex10, {
    alignItems: "center",
    justifyContent: "space-between"
  }, /* @__PURE__ */React47.createElement(EGDSLayoutFlexItem11, null, /* @__PURE__ */React47.createElement(EGDSHeading13, {
    tag: "h2",
    size: 6
  }, toolbarPrimary)), /* @__PURE__ */React47.createElement(EGDSLayoutFlexItem11, null, clearAll && /* @__PURE__ */React47.createElement(SortAndFilterEGDSTertiaryButton, {
    data: clearAll,
    onClick: clearButtonClick
  })))), /* @__PURE__ */React47.createElement(EGDSSpacing17, {
    padding: {
      medium: {
        blockstart: "unset",
        blockend: "one",
        inlinestart: "six",
        inlineend: "six"
      }
    }
  }, /* @__PURE__ */React47.createElement(EGDSSheetContent2, {
    padded: false
  }, /* @__PURE__ */React47.createElement(EGDSSpacing17, {
    padding: {
      small: {
        inline: isSmallViewSize ? "three" : "unset"
      }
    }
  }, /* @__PURE__ */React47.createElement("div", null, fields.map(function (field, fieldIndex) {
    var Field = validFieldComponents2.find(function (component) {
      return component.fragment.__typename === field.__typename;
    });
    var fieldSectionMargin = isXLOBMwebEnabled ? {
      block: "two"
    } : {
      blockstart: "six"
    };
    if (!Field) {
      return null;
    }
    switch (field.__typename) {
      case "ShoppingRangeField":
        {
          return /* @__PURE__ */React47.createElement(EGDSSpacing17, {
            margin: fieldSectionMargin,
            key: "field-section-".concat(fieldIndex)
          }, /* @__PURE__ */React47.createElement(FieldStateProvider, {
            field: field
          }, /* @__PURE__ */React47.createElement(Field, {
            data: field,
            onSelectedField: onSelectedField,
            onRangeSelectionChange: onRangeSelectionChange,
            resetFilters: resetFilters
          })));
        }
      default:
        {
          return /* @__PURE__ */React47.createElement(EGDSSpacing17, {
            margin: fieldSectionMargin,
            key: "field-section-".concat(fieldIndex)
          }, /* @__PURE__ */React47.createElement(FieldStateProvider, {
            field: field
          }, /* @__PURE__ */React47.createElement(Field, {
            data: field,
            onClick: onFieldClick,
            onSelectedField: onSelectedField,
            keepSectionExpanded: keepSectionExpanded,
            resetFilters: resetFilters,
            onStepInputChange: onStepInputChange,
            type: toolbarPrimary,
            onRangeSelectionChange: onRangeSelectionChange,
            isDatedSearch: isDatedSearch,
            loading: loading
          })));
        }
    }
  }))))), /* @__PURE__ */React47.createElement(QuickAccessFilterSheetFooter, {
    data: quickAccessFilterSheetFooterData,
    footerDataLoading: footerDataLoading || loading,
    onClick: handleSubmit,
    isBexQuickFiltersEnabled: isSmallViewSize && (xLOBLodgingMwebExposure === null || xLOBLodgingMwebExposure === void 0 ? void 0 : xLOBLodgingMwebExposure.bucket) === 1 || useBottomSheetForTablet || isSmallViewSize && (xLOBQAFExposure === null || xLOBQAFExposure === void 0 ? void 0 : xLOBQAFExposure.bucket) === 1
  })));
};
QuickAccessFilterField.displayName = "QuickAccessFilterField";
QuickAccessFilterField.fragment = _object_spread_props(_object_spread({}, __Fragment35), {
  __typename: "ShoppingSortAndFilterQuickFilter"
});
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filter-more-filters.tsx
import React48 from "react";
import { gql as gql46 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize6, EGDSSecondaryButton as EGDSSecondaryButton4 } from "@egds/react-core/button";
import { EGDSDialogContent } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex11, EGDSLayoutFlexItem as EGDSLayoutFlexItem12 } from "@egds/react-core/layout-flex";
import { EGDSSheet as EGDSSheet3, EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker27 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { defaultViewSizes as defaultViewSizes3, useMediaQueries as useMediaQueries3 } from "@shared-ui/viewport-context";
var __Fragment36 = gql46(_templateObject54(), UIFloatingActionButton.fragment, Toolbar.fragment);
var QuickAccessFilterMoreFilters = function (param) {
  var data = param.data,
    onOpenDialog = param.onOpenDialog,
    onClearFilters = param.onClearFilters,
    onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters,
    onSubmit = param.onSubmit,
    setFiltersActive = param.setFiltersActive,
    setResetFilters = param.setResetFilters,
    setSubmitButtonClicked = param.setSubmitButtonClicked,
    filterSections = param.filterSections,
    loading = param.loading,
    className = param.className;
  var _container_revealAction;
  var container = data.container;
  var _useDialog3 = _sliced_to_array(useDialog3("quick-access-filters-more-filters"), 3),
    isDialogOpen = _useDialog3[0],
    _useDialog3_ = _useDialog3[1],
    openDialog = _useDialog3_.openDialog,
    closeDialog = _useDialog3_.closeDialog,
    DialogComponent = _useDialog3[2];
  var track = useClickTracker27();
  var isSmallViewSize = useMediaQueries3({
    viewSizes: defaultViewSizes3
  }) === defaultViewSizes3.SMALL;
  if (!isSmallViewSize || !filterSections || container.__typename !== "ShoppingSortAndFilterDialogContainer" || ((_container_revealAction = container.revealAction) === null || _container_revealAction === void 0 ? void 0 : _container_revealAction.__typename) !== "UISecondaryFloatingActionButton" || !container.applyAction) {
    return null;
  }
  var toolbar = container.toolbar,
    revealAction = container.revealAction,
    applyAction = container.applyAction;
  var handleTriggerClick = function () {
    onOpenDialog === null || onOpenDialog === void 0 ? void 0 : onOpenDialog();
    openDialog();
    if (revealAction.analytics) {
      var _revealAction_analytics = revealAction.analytics,
        referrerId = _revealAction_analytics.referrerId,
        linkName = _revealAction_analytics.linkName;
      track(referrerId, linkName);
    }
  };
  var handleSubmitClick = function () {
    setSubmitButtonClicked(true);
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    closeDialog();
  };
  var handleCloseButtonClick = function () {
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
      name: "restore" /* RESTORE */,
      value: {}
    });
    setResetFilters(false);
    closeDialog();
  };
  var handleClearButtonClick = function () {
    onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters();
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
      name: "clear" /* CLEAR */,
      value: {}
    });
    setResetFilters(true);
    setFiltersActive(false);
  };
  var _revealAction_egdsElementId;
  return /* @__PURE__ */React48.createElement(React48.Fragment, null, /* @__PURE__ */React48.createElement(EGDSLayoutFlexItem12, {
    shrink: 0
  }, /* @__PURE__ */React48.createElement(EGDSSecondaryButton4, {
    size: EGDSButtonSize6.SMALL,
    disabled: loading,
    onClick: handleTriggerClick,
    "data-test-id": (_revealAction_egdsElementId = revealAction.egdsElementId) !== null && _revealAction_egdsElementId !== void 0 ? _revealAction_egdsElementId : "",
    className: className
  }, revealAction.primary)), /* @__PURE__ */React48.createElement(EGDSSheetTransition3, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React48.createElement(DialogComponent, null, /* @__PURE__ */React48.createElement(EGDSSheet3, {
    type: "full",
    isVisible: true,
    returnFocusOnClose: true,
    triggerRef: null
  }, toolbar && /* @__PURE__ */React48.createElement(Toolbar, {
    data: toolbar,
    onCloseButtonClick: handleCloseButtonClick,
    onClearAllButtonClick: handleClearButtonClick
  }), /* @__PURE__ */React48.createElement(EGDSDialogContent, {
    zeroPadding: true
  }, /* @__PURE__ */React48.createElement(EGDSSpacing18, {
    padding: {
      inline: "six"
    }
  }, filterSections)), /* @__PURE__ */React48.createElement(EGDSSpacing18, {
    padding: {
      small: "four",
      large: {
        inline: "six"
      }
    },
    border: ["blockstart"]
  }, /* @__PURE__ */React48.createElement(EGDSLayoutFlex11, {
    justifyContent: "end",
    alignItems: "center"
  }, /* @__PURE__ */React48.createElement(EGDSLayoutFlexItem12, null, /* @__PURE__ */React48.createElement(UIFloatingActionButton, {
    data: applyAction,
    onClick: handleSubmitClick,
    withUpdatedNotification: true,
    isFullWidth: true
  }))))))));
};
QuickAccessFilterMoreFilters.displayName = "QuickAccessFilterMoreFilters";
QuickAccessFilterMoreFilters.fragment = __Fragment36;
// ../internal/src/components/sort-filter/__private/__fragments/toggle-filter-pill-field.tsx
import React49 from "react";
import { gql as gql47 } from "@apollo/client";
var __Fragment37 = gql47(_templateObject55(), clientSideAnalyticsFragment, SortAndFilterEGDSPill.fragment);
var ToggleFilterPillField = function (param) {
  var loading = param.loading,
    data = param.data,
    onRemoveToggleFilter = param.onRemoveToggleFilter,
    className = param.className;
  var filterPill = data.filterPill,
    option = data.option;
  var handleRemovablePillClick = function (event) {
    var syntheticEvent = {
      target: _object_spread_props(_object_spread({}, event.target), {
        type: "checkbox",
        checked: false
      }),
      isTrusted: true
    };
    switch (option === null || option === void 0 ? void 0 : option.__typename) {
      case "ShoppingSelectableFilterOption":
        onRemoveToggleFilter === null || onRemoveToggleFilter === void 0 ? void 0 : onRemoveToggleFilter(option.id, option.value, syntheticEvent);
        break;
      case "ShoppingRangeFilterOption":
        onRemoveToggleFilter === null || onRemoveToggleFilter === void 0 ? void 0 : onRemoveToggleFilter(option.id, {
          min: -1,
          max: -1
        }, syntheticEvent);
        break;
      default:
        break;
    }
  };
  switch (filterPill === null || filterPill === void 0 ? void 0 : filterPill.__typename) {
    case "EGDSBasicRemovablePill":
      return /* @__PURE__ */React49.createElement(EGDSBasicRemovablePill, {
        data: filterPill,
        onRemove: handleRemovablePillClick,
        loading: loading,
        className: className
      });
    case "EGDSBasicPill":
      return /* @__PURE__ */React49.createElement(SortAndFilterEGDSPill, {
        data: filterPill,
        loading: loading,
        className: className
      });
    default:
      return null;
  }
};
ToggleFilterPillField.displayName = "ToggleFilterPillField";
ToggleFilterPillField.fragment = _object_spread_props(_object_spread({}, __Fragment37), {
  __typename: "ShoppingSortAndFilterToggleFilter"
});
// ../internal/src/components/sort-filter/__private/__fragments/quick-access-filters.tsx
var __Fragment38 = gql48(_templateObject56(), QuickAccessFilterField.fragment, QuickAccessFilterMoreFilters.fragment, ToggleFilterPillField.fragment);
var QuickAccessFilters = function (param) {
  var data = param.data,
    onSelectedField = param.onSelectedField,
    onRangeSelectionChange = param.onRangeSelectionChange,
    onStepInputChange = param.onStepInputChange,
    onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters,
    onClearFilters = param.onClearFilters,
    setFiltersActive = param.setFiltersActive,
    onSubmit = param.onSubmit,
    loading = param.loading,
    isSheetVisibleList = param.isSheetVisibleList,
    setIsSheetVisibleList = param.setIsSheetVisibleList,
    footerDataLoading = param.footerDataLoading,
    isDatedSearch = param.isDatedSearch,
    keepSectionExpanded = param.keepSectionExpanded,
    mappedFilterSections = param.mappedFilterSections,
    onOpenDialog = param.onOpenDialog,
    setResetFilters = param.setResetFilters,
    setSubmitButtonClicked = param.setSubmitButtonClicked,
    onRemoveToggleFilter = param.onRemoveToggleFilter,
    className = param.className;
  var quickAccessFilters = data.quickAccessFilters;
  var isSmallViewSize = useMediaQueries4({
    viewSizes: defaultViewSizes4
  }) === defaultViewSizes4.SMALL;
  var isMediumViewSize = useMediaQueries4({
    viewSizes: defaultViewSizes4
  }) === defaultViewSizes4.MEDIUM;
  var isBexSplitViewEnabled = useExperiment7("Split_View_Side_by_side_BEXG_H").exposure.bucket > 0;
  var _useExperiment7 = useExperiment7("Quick_Filters_VrBex_Arrow_Buttons"),
    quickFiltersVrboArrowExposure = _useExperiment7.exposure;
  var _useExperiment71 = useExperiment7("Quick_Filter_Carousel_Buttons_Native_VrBex"),
    quickFilterCarouselButtonExposure = _useExperiment71.exposure;
  var _useExperiment72 = useExperiment7("Quick_Filters_MVP_xLOB_Flights_Activities_Web"),
    xLOBQAFExposure = _useExperiment72.exposure;
  var _useExperiment73 = useExperiment7("Quick_Filters_xLOB_Lodging_mWeb_Retest"),
    xLOBLodgingMwebExposure = _useExperiment73.exposure;
  if (!quickAccessFilters) {
    return null;
  }
  var shouldDisplayToolbarForQuickAccessFilters = xLOBQAFExposure.bucket === 1 && isSmallViewSize || xLOBLodgingMwebExposure.bucket === 1 && (isSmallViewSize || isMediumViewSize);
  var handleClearButtonClick = function (quickAccessFilterFieldsData) {
    onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters(quickAccessFilterFieldsData);
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
      name: "clear_quick_filters" /* CLEAR_QUICK_FILTERS */,
      value: quickAccessFilterFieldsData
    });
    setFiltersActive(false);
  };
  var handleSheetToggle = function (index) {
    var newIsSheetVisibleList = isSheetVisibleList.map(function (isSheetVisible, sheetIndex) {
      if (sheetIndex === index) {
        return !isSheetVisible;
      }
      return false;
    });
    setIsSheetVisibleList(newIsSheetVisibleList);
  };
  var shoppingSortAndFilterQuickFilterIndex = -1;
  return /* @__PURE__ */React50.createElement(React50.Fragment, null, quickAccessFilters.map(function (quickAccessFilter, index) {
    var lastQuickfilter = index === quickAccessFilters.length - 1;
    switch (quickAccessFilter.__typename) {
      case "ShoppingSortAndFilterQuickFilter":
        {
          var _quickAccessFilter_filterPill;
          shoppingSortAndFilterQuickFilterIndex += 1;
          var _quickAccessFilter_filterPill_id, _isSheetVisibleList_shoppingSortAndFilterQuickFilterIndex;
          return /* @__PURE__ */React50.createElement(QuickAccessFilterField, {
            key: (_quickAccessFilter_filterPill_id = (_quickAccessFilter_filterPill = quickAccessFilter.filterPill) === null || _quickAccessFilter_filterPill === void 0 ? void 0 : _quickAccessFilter_filterPill.id) !== null && _quickAccessFilter_filterPill_id !== void 0 ? _quickAccessFilter_filterPill_id : "quick-access-".concat(index),
            data: quickAccessFilter,
            onFieldClick: onSelectedField,
            onRangeSelectionChange: onRangeSelectionChange,
            onStepInputChange: onStepInputChange,
            handleClearButtonClick: handleClearButtonClick,
            onSubmit: onSubmit,
            loading: loading,
            isSheetVisible: (_isSheetVisibleList_shoppingSortAndFilterQuickFilterIndex = isSheetVisibleList[shoppingSortAndFilterQuickFilterIndex]) !== null && _isSheetVisibleList_shoppingSortAndFilterQuickFilterIndex !== void 0 ? _isSheetVisibleList_shoppingSortAndFilterQuickFilterIndex : false,
            onSheetToggle: handleSheetToggle,
            sheetIndex: shoppingSortAndFilterQuickFilterIndex,
            lastQuickFilter: lastQuickfilter,
            onSheetDismiss: onClearFilters,
            footerDataLoading: footerDataLoading,
            quickFiltersVrboArrowExposure: quickFiltersVrboArrowExposure,
            quickFilterCarouselButtonExposure: quickFilterCarouselButtonExposure,
            isDatedSearch: isDatedSearch,
            shouldDisplayToolbarForQuickAccessFilters: shouldDisplayToolbarForQuickAccessFilters,
            xLOBLodgingMwebExposure: xLOBLodgingMwebExposure,
            xLOBQAFExposure: xLOBQAFExposure,
            keepSectionExpanded: keepSectionExpanded,
            isBexSplitViewEnabled: isBexSplitViewEnabled,
            className: className,
            isQuickFilters: true
          });
        }
      case "ShoppingSortAndFilterButtonTrigger":
        {
          var _quickAccessFilter_container_revealAction;
          return /* @__PURE__ */React50.createElement(QuickAccessFilterMoreFilters, {
            key: quickAccessFilter.container.__typename === "ShoppingSortAndFilterDialogContainer" && ((_quickAccessFilter_container_revealAction = quickAccessFilter.container.revealAction) === null || _quickAccessFilter_container_revealAction === void 0 ? void 0 : _quickAccessFilter_container_revealAction.accessibility) || "quick-access-".concat(index),
            data: quickAccessFilter,
            filterSections: mappedFilterSections,
            onOpenDialog: onOpenDialog,
            onClearFilters: onClearFilters,
            onSubmit: onSubmit,
            onRemoveAllAppliedFilters: onRemoveAllAppliedFilters,
            setFiltersActive: setFiltersActive,
            setResetFilters: setResetFilters,
            setSubmitButtonClicked: setSubmitButtonClicked,
            loading: loading,
            className: className
          });
        }
      case "ShoppingSortAndFilterToggleFilter":
        {
          var _quickAccessFilter_filterPill1;
          var _quickAccessFilter_filterPill_primary;
          return /* @__PURE__ */React50.createElement(ToggleFilterPillField, {
            key: (_quickAccessFilter_filterPill_primary = (_quickAccessFilter_filterPill1 = quickAccessFilter.filterPill) === null || _quickAccessFilter_filterPill1 === void 0 ? void 0 : _quickAccessFilter_filterPill1.primary) !== null && _quickAccessFilter_filterPill_primary !== void 0 ? _quickAccessFilter_filterPill_primary : "quick-access-".concat(index),
            data: quickAccessFilter,
            loading: loading,
            onRemoveToggleFilter: onRemoveToggleFilter,
            className: className
          });
        }
      default:
        {
          return null;
        }
    }
  }));
};
QuickAccessFilters.displayName = "QuickAccessFilters";
QuickAccessFilters.fragment = __Fragment38;
// ../internal/src/components/sort-filter/__private/__fragments/section.tsx
import React51 from "react";
import { gql as gql49 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing19, EGDSSpacingHr } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading14 } from "@egds/react-core/text";
import { Experiment as Experiment2, ExperimentControl as ExperimentControl2, ExperimentVariant as ExperimentVariant2 } from "@shared-ui/experiment-context";
var __Fragment39 = gql49(_templateObject57(), DropdownField.fragment, MultiSelectionField.fragment, RangeField.fragment, SelectionField.fragment, TextInputField.fragment, MultiSelectionStackedTileField.fragment, MultiSelectionTileField.fragment, StepInputField.fragment, MutexField.fragment, SelectedFiltersField.fragment, RangeTextInputField.fragment);
var validFieldComponents3 = [DropdownField, MultiSelectionField, RangeField, SelectionField, TextInputField, MultiSelectionStackedTileField, MultiSelectionTileField, StepInputField, MutexField, SelectedFiltersField, RangeTextInputField];
var SortAndFilterSection = function (props) {
  var data = props.data,
    keepSectionExpanded = props.keepSectionExpanded,
    onFieldClick = props.onFieldClick,
    onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onSelectionChange = props.onSelectionChange,
    typeaheadAdapters = props.typeaheadAdapters,
    onRangeSelectionChange = props.onRangeSelectionChange,
    onStepInputChange = props.onStepInputChange,
    onSelectedField = props.onSelectedField,
    useUnsetMargin = props.useUnsetMargin,
    useUnsetTopBorder = props.useUnsetTopBorder,
    resetFilters = props.resetFilters,
    typeaheadLogger = props.typeaheadLogger,
    isQuickFilters = props.isQuickFilters,
    onDone = props.onDone,
    onKeyDown = props.onKeyDown,
    isDatedSearch = props.isDatedSearch,
    currentView = props.currentView,
    loading = props.loading;
  var fields = data.fields,
    subTitle = data.subTitle,
    title = data.title,
    id = data.id;
  var containerRef = React51.useRef(null);
  var hasSupportedFields = fields.some(function (param) {
    var __typename = param.__typename;
    return validFieldComponents3.find(function (param) {
      var fragment5 = param.fragment;
      return fragment5.__typename === __typename;
    });
  });
  if (!hasSupportedFields && fields.length > 0) {
    return null;
  }
  var isFilterSectionInputType = fields.some(function (param) {
    var __typename = param.__typename;
    return __typename === "ShoppingTextInputField";
  });
  var borderedSpacingProps = {
    border: isFilterSectionInputType ? ["blockend", "blockstart"] : [],
    padding: isFilterSectionInputType ? {
      block: "six"
    } : {},
    margin: !useUnsetMargin ? {
      blockstart: "six"
    } : {
      blockstart: "unset"
    }
  };
  var noTopBorderSpacingProps = {
    border: isFilterSectionInputType ? ["blockend"] : [],
    padding: isFilterSectionInputType ? {
      blockstart: "four",
      blockend: "six"
    } : {},
    margin: isFilterSectionInputType ? {
      blockstart: "unset"
    } : {
      blockstart: "six"
    }
  };
  var fieldSpacingProps = {
    margin: isFilterSectionInputType && fields.length === 1 ? {
      blockstart: "two"
    } : {
      blockstart: "six"
    }
  };
  var spacingProps = useUnsetTopBorder ? noTopBorderSpacingProps : borderedSpacingProps;
  var focusNextElement = function () {
    var _containerRef_current;
    var focusableElements = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.querySelectorAll('button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var currentElement = document.activeElement;
    if (focusableElements && _instanceof(currentElement, HTMLElement)) {
      var index = _to_consumable_array(focusableElements).indexOf(currentElement);
      if (index > -1) {
        var _focusableElements_;
        var nextElement = (_focusableElements_ = focusableElements[index + 1]) !== null && _focusableElements_ !== void 0 ? _focusableElements_ : focusableElements[0];
        nextElement === null || nextElement === void 0 ? void 0 : nextElement.focus();
      }
    }
  };
  var ignoreSignals = currentView !== "FILTER_BAR" /* FILTER_BAR */ && currentView !== "FILTER_DIALOG" /* FILTER_DIALOG */;
  var shouldAppendRevealRef = currentView === "FILTER_DIALOG" /* FILTER_DIALOG */ || currentView === "FILTER_BAR" /* FILTER_BAR */;
  return /* @__PURE__ */React51.createElement(EGDSSpacing19, _object_spread({}, spacingProps), /* @__PURE__ */React51.createElement("div", {
    "data-test-id": id,
    ref: containerRef
  }, title && /* @__PURE__ */React51.createElement(EGDSHeading14, {
    tag: "h3",
    size: 5
  }, title), /* @__PURE__ */React51.createElement(EGDSHeading14, {
    tag: "h4",
    size: 6
  }, subTitle), fields.map(function (field, fieldIndex) {
    var __typename = (field || {}).__typename;
    var typeaheadAdapter = field.__typename === "ShoppingTextInputField" ? typeaheadAdapters === null || typeaheadAdapters === void 0 ? void 0 : typeaheadAdapters.get(field.id) : void 0;
    var Field = validFieldComponents3.find(function (component) {
      return component.fragment.__typename === __typename;
    });
    if (!Field) {
      return null;
    }
    return /* @__PURE__ */React51.createElement(EGDSSpacing19, _object_spread_props(_object_spread({}, fieldSpacingProps), {
      key: fieldIndex
    }), /* @__PURE__ */React51.createElement("div", null, /* @__PURE__ */React51.createElement(FieldStateProvider, {
      field: field
    }, /* @__PURE__ */React51.createElement("div", null, __typename === TextInputField.fragment.__typename && /* @__PURE__ */React51.createElement(Field, {
      key: "field-section-".concat(fieldIndex),
      data: field,
      typeaheadAdapter: typeaheadAdapter,
      onMultiSelectClose: onMultiSelectClose,
      onMultiSelectItemRemove: onMultiSelectItemRemove,
      onMultiSelectClearAll: onMultiSelectClearAll,
      onSelectionChange: onSelectionChange,
      typeaheadLogger: typeaheadLogger,
      onKeyDown: onKeyDown,
      onDone: onDone,
      resetFilters: resetFilters,
      loading: loading
    }), __typename === RangeField.fragment.__typename && /* @__PURE__ */React51.createElement(Field, {
      key: "field-section-".concat(fieldIndex),
      data: field,
      onSelectedField: onSelectedField,
      onRangeSelectionChange: onRangeSelectionChange,
      resetFilters: resetFilters,
      loading: loading
    }), __typename !== TextInputField.fragment.__typename && __typename !== RangeField.fragment.__typename && /* @__PURE__ */React51.createElement(Field, {
      key: "field-section-".concat(fieldIndex),
      data: field,
      onClick: onFieldClick,
      onSelectedField: onSelectedField,
      keepSectionExpanded: keepSectionExpanded,
      resetFilters: resetFilters,
      onStepInputChange: onStepInputChange,
      onRangeSelectionChange: onRangeSelectionChange,
      hasNoSectionTitle: !title,
      focusNextElement: focusNextElement,
      isDatedSearch: isDatedSearch,
      ignoreSignals: ignoreSignals,
      loading: loading,
      shouldAppendRevealRef: shouldAppendRevealRef
    })), /* @__PURE__ */React51.createElement(Experiment2, {
      name: "VrBex_Clawback_Filter_Modal_Display_Optimizations"
    }, /* @__PURE__ */React51.createElement(ExperimentControl2, null), /* @__PURE__ */React51.createElement(ExperimentVariant2, {
      bucket: 1
    }, isQuickFilters || fieldIndex === 0 || fieldIndex === fields.length - 1 || field.__typename === "ShoppingStepInputField" ? /* @__PURE__ */React51.createElement(React51.Fragment, null, " ") : /* @__PURE__ */React51.createElement(EGDSSpacingHr, null)), /* @__PURE__ */React51.createElement(ExperimentVariant2, {
      bucket: 2
    }, isQuickFilters || fieldIndex === 0 || fieldIndex === fields.length - 1 || field.__typename === "ShoppingStepInputField" ? /* @__PURE__ */React51.createElement(React51.Fragment, null, " ") : /* @__PURE__ */React51.createElement(EGDSSpacingHr, null))))));
  })));
};
SortAndFilterSection.displayName = "SortAndFilterSection";
SortAndFilterSection.fragment = __Fragment39;
// ../internal/src/components/sort-filter/__private/__fragments/toggle-button-field.tsx
import React52, { useCallback as useCallback2, useEffect as useEffect7 } from "react";
import { gql as gql50 } from "@apollo/client";
import { EGDSSwitch } from "@egds/react-core/switch";
import { EGDSText as EGDSText5 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker28 } from "@shared-ui/clickstream-analytics-context";
import { useLodgingCompare } from "@shared-ui/retail-compare-providers";
var fragment4 = gql50(_templateObject58(), clientSideAnalyticsFragment);
var ToggleButtonField = function (param) {
  var data = param.data,
    _param_inline = param.inline,
    inline = _param_inline === void 0 ? false : _param_inline;
  var track = useClickTracker28();
  var _useLodgingCompare = _sliced_to_array(useLodgingCompare(), 2),
    enabled = _useLodgingCompare[0].enabled,
    _useLodgingCompare_ = _useLodgingCompare[1],
    enable = _useLodgingCompare_.enable,
    disable = _useLodgingCompare_.disable;
  var checked = data.checked,
    checkedAnalytics = data.checkedAnalytics,
    checkedDescription = data.checkedDescription,
    checkedLabel = data.checkedLabel,
    uncheckedAnalytics = data.uncheckedAnalytics,
    uncheckedDescription = data.uncheckedDescription,
    uncheckedLabel = data.uncheckedLabel;
  useEffect7(function () {
    if (checked && !enabled) {
      enable();
    }
  }, []);
  var handleToggle = useCallback2(function () {
    var nextEnabled = !enabled;
    var _ref;
    var _ref1 = (_ref = nextEnabled ? checkedAnalytics : uncheckedAnalytics) !== null && _ref !== void 0 ? _ref : {},
      referrerId = _ref1.referrerId,
      linkName = _ref1.linkName,
      uisPrimeMessages = _ref1.uisPrimeMessages;
    if (nextEnabled) {
      enable();
    } else {
      disable();
    }
    if (referrerId && linkName) {
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages !== null && uisPrimeMessages !== void 0 ? uisPrimeMessages : []));
    }
  }, [enabled, track, checkedAnalytics, uncheckedAnalytics]);
  var description = enabled ? checkedDescription : uncheckedDescription;
  var label = enabled ? checkedLabel : uncheckedLabel;
  var toggle = /* @__PURE__ */React52.createElement(EGDSSwitch, {
    id: "compare-toggle-filter",
    switchPosition: "trailing",
    checked: enabled,
    onChange: handleToggle,
    description: description || void 0,
    a11yLabel: label
  }, inline ? /* @__PURE__ */React52.createElement(EGDSText5, {
    whiteSpace: "nowrap",
    inline: true
  }, label) : label);
  return toggle;
};
ToggleButtonField.displayName = "CompareToggleField";
ToggleButtonField.fragment = fragment4;
// ../internal/src/components/sort-filter/search-tools-filter-bar.tsx
var __Fragment40 = gql51(_templateObject59(), SortAndFilterSection.fragment, ToggleButtonField.fragment, AllFilterSheetFooter.fragment, ShoppingSortAndFiltersCarouselFragment, containersFragment, QuickAccessFilters.fragment);
var viewType = "FILTER_BAR" /* FILTER_BAR */;
var SearchToolsFilterBar = function (param) {
  var data = param.data,
    onOpenDialog = param.onOpenDialog,
    onRangeSelectionChange = param.onRangeSelectionChange,
    onSelectionChange = param.onSelectionChange,
    onStepInputChange = param.onStepInputChange,
    onSubmit = param.onSubmit,
    onRemoveAllAppliedFilters = param.onRemoveAllAppliedFilters,
    onClearFilters = param.onClearFilters,
    loading = param.loading,
    footerDataLoading = param.footerDataLoading,
    onFieldClick = param.onFieldClick,
    isDatedSearch = param.isDatedSearch,
    stickyByViewsize = param.stickyFilterBarByViewsize,
    spacing = param.filterBarSpacing,
    currentView = param.currentView,
    keepSectionExpanded = param.keepSectionExpanded,
    waitingForQueryResolution = param.waitingForQueryResolution,
    onRemoveToggleFilter = param.onRemoveToggleFilter,
    isMapView = param.isMapView,
    _param_hideQuickAccessFilters = param.hideQuickAccessFilters,
    hideQuickAccessFilters = _param_hideQuickAccessFilters === void 0 ? false : _param_hideQuickAccessFilters;
  var _toolbarData_actions, _toolbarData_actions_secondaries_, _toolbarData_actions1, _revealAction_icon, _carousel_nextButton, _carousel_previousButton;
  var __typename = data.__typename,
    containers = data.containers,
    filterSections = data.filterSections,
    quickAccessFilters = data.quickAccessFilters,
    footerLabel = data.footerLabel,
    sortSections = data.sortSections,
    carousel = data.carousel,
    scrollEndAnalytics = data.scrollEndAnalytics,
    toggleButton = data.toggleButton,
    tnlFields = data.tnlFields;
  var _containers_find;
  var _ref = (_containers_find = containers === null || containers === void 0 ? void 0 : containers.find(function (container) {
      return container.__typename === "ShoppingSortAndFilterDialogContainer" && container.view === viewType;
    })) !== null && _containers_find !== void 0 ? _containers_find : {},
    toolbarData = _ref.toolbar,
    revealAction = _ref.revealAction,
    applyAction = _ref.applyAction;
  var _useDialog4 = _sliced_to_array(useDialog4("".concat(__typename, "-").concat(viewType)), 3),
    isOpen = _useDialog4[0],
    _useDialog4_ = _useDialog4[1],
    openDialog = _useDialog4_.openDialog,
    closeDialog = _useDialog4_.closeDialog,
    DialogComponent = _useDialog4[2];
  var isSmallViewSize = useMediaQueries5({
    viewSizes: defaultViewSizes5
  }) === defaultViewSizes5.SMALL;
  var trackClick = useClickTracker29();
  var track = useClickstreamAnalytics().track;
  var _useExperiment8 = useExperiment8("Quick_Filters_MVP_xLOB_Flights_Activities_Web"),
    xLOBQAFExposure = _useExperiment8.exposure;
  var _useExperiment81 = useExperiment8("Quick_Filter_Carousel_Buttons_Native_VrBex"),
    quickFilterCarouselButtonExposure = _useExperiment81.exposure;
  var _useExperiment82 = useExperiment8("Filter_Removal_Phase_1_VrBex"),
    filterRemovalP1Exposure = _useExperiment82.exposure,
    filterRemovalP1ExperimentLogger = _useExperiment82.logExperiment;
  var isBexSplitViewEnabled = useExperiment8("Split_View_Side_by_side_BEXG_H").exposure.bucket > 0;
  var isInlineToggle = useExperiment8("Property_Compare_on_VRBO_xVector_Web", false).exposure.bucket === 2;
  var isThematicSearchEnabled = useExperiment8("Thematic_search_by_categories_VRBO_M2").exposure.bucket === 1;
  var _React53_useState = _sliced_to_array(React53.useState(toolbarData), 2),
    toolbar = _React53_useState[0],
    setToolbar = _React53_useState[1];
  var _React53_useState1 = _sliced_to_array(React53.useState(false), 2),
    resetFilters = _React53_useState1[0],
    setResetFilters = _React53_useState1[1];
  var _React53_useState2 = _sliced_to_array(React53.useState((toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions = toolbarData.actions) === null || _toolbarData_actions === void 0 ? void 0 : _toolbarData_actions.secondaries) && (toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions1 = toolbarData.actions) === null || _toolbarData_actions1 === void 0 ? void 0 : (_toolbarData_actions_secondaries_ = _toolbarData_actions1.secondaries[0]) === null || _toolbarData_actions_secondaries_ === void 0 ? void 0 : _toolbarData_actions_secondaries_.disabled)), 2),
    filtersActive = _React53_useState2[0],
    setFiltersActive = _React53_useState2[1];
  var _quickAccessFilters_filter_map;
  var _React53_useState3 = _sliced_to_array(React53.useState((_quickAccessFilters_filter_map = quickAccessFilters === null || quickAccessFilters === void 0 ? void 0 : quickAccessFilters.filter(function (quickAccessFilter) {
      return quickAccessFilter.__typename === "ShoppingSortAndFilterQuickFilter";
    }).map(function () {
      return false;
    })) !== null && _quickAccessFilters_filter_map !== void 0 ? _quickAccessFilters_filter_map : []), 2),
    isSheetVisibleList = _React53_useState3[0],
    setIsSheetVisibleList = _React53_useState3[1];
  var _React53_useState4 = _sliced_to_array(React53.useState(false), 2),
    shouldSubmitAISearch = _React53_useState4[0],
    setShouldSubmitAISearch = _React53_useState4[1];
  var _React53_useState5 = _sliced_to_array(React53.useState(function () {
      var _parseGraphQLPair;
      return (_parseGraphQLPair = parseGraphQLPair(tnlFields || [], "ai_search_error_message")) === null || _parseGraphQLPair === void 0 ? void 0 : _parseGraphQLPair.value;
    }), 2),
    errorStateString = _React53_useState5[0],
    setErrorStateString = _React53_useState5[1];
  var _React53_useState6 = _sliced_to_array(React53.useState(true), 2),
    submitButtonClicked = _React53_useState6[0],
    setSubmitButtonClicked = _React53_useState6[1];
  var primaryPillRef = React53.useRef(null);
  var closeButtonClicked = React53.useRef(true);
  React53.useEffect(function () {
    var _toolbar_actions_secondaries;
    if (!toolbar) {
      return;
    }
    setToolbar(_object_spread_props(_object_spread({}, toolbar), {
      actions: {
        __typename: "UIToolbarActions",
        primary: _object_spread({}, toolbar.actions.primary),
        secondaries: ((_toolbar_actions_secondaries = toolbar.actions.secondaries) === null || _toolbar_actions_secondaries === void 0 ? void 0 : _toolbar_actions_secondaries.map(function (element) {
          return _object_spread_props(_object_spread({}, element), {
            disabled: !filtersActive && resetFilters
          });
        })) || []
      }
    }));
  }, [filtersActive, resetFilters]);
  React53.useEffect(function () {
    if (!isOpen && !closeButtonClicked.current && !submitButtonClicked && (quickFilterCarouselButtonExposure.bucket === 1 || isBexSplitViewEnabled)) {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
      return;
    }
    if (!isOpen && !submitButtonClicked) {
      onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
        name: "restore" /* RESTORE */,
        value: {}
      });
      setResetFilters(false);
    }
    if (isOpen) {
      filterRemovalP1ExperimentLogger(filterRemovalP1Exposure);
    }
    setSubmitButtonClicked(false);
    closeButtonClicked.current = false;
  }, [isOpen]);
  React53.useEffect(function () {
    if (shouldSubmitAISearch) {
      onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
      setShouldSubmitAISearch(false);
    }
  }, [shouldSubmitAISearch]);
  var isAISearchError = tnlFields === null || tnlFields === void 0 ? void 0 : tnlFields.some(function (field) {
    return field.key === "ai_search_error_message";
  });
  React53.useEffect(function () {
    if (isAISearchError) {
      var _parseGraphQLPair;
      setErrorStateString((_parseGraphQLPair = parseGraphQLPair(tnlFields || [], "ai_search_error_message")) === null || _parseGraphQLPair === void 0 ? void 0 : _parseGraphQLPair.value);
    }
  }, [tnlFields]);
  var sortAndFilterSections = sortSections && filterSections && _to_consumable_array(sortSections).concat(_to_consumable_array(filterSections));
  if (!(sortAndFilterSections === null || sortAndFilterSections === void 0 ? void 0 : sortAndFilterSections.length) || !revealAction || !applyAction || (revealAction === null || revealAction === void 0 ? void 0 : revealAction.__typename) !== "UISecondaryFloatingActionButton") {
    return null;
  }
  var handleTriggerClick = function () {
    onOpenDialog === null || onOpenDialog === void 0 ? void 0 : onOpenDialog();
    openDialog();
    if (revealAction.analytics) {
      var _revealAction_analytics = revealAction.analytics,
        referrerId = _revealAction_analytics.referrerId,
        linkName = _revealAction_analytics.linkName;
      trackClick(referrerId, linkName);
    }
  };
  var handleSubmitClick = function () {
    setSubmitButtonClicked(true);
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
    setResetFilters(false);
    closeDialog();
  };
  var handleCloseButtonClick = function () {
    closeButtonClicked.current = true;
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
      name: "restore" /* RESTORE */,
      value: {}
    });
    setResetFilters(false);
    closeDialog();
  };
  var handleClearButtonClick = function () {
    onRemoveAllAppliedFilters === null || onRemoveAllAppliedFilters === void 0 ? void 0 : onRemoveAllAppliedFilters();
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
      name: "clear" /* CLEAR */,
      value: {}
    });
    setResetFilters(true);
    setFiltersActive(false);
  };
  var onSelectedField = function () {
    setToolbar(toolbarData);
    setResetFilters(false);
    setFiltersActive(true);
  };
  var handleCarouselNextButtonClick = function () {
    var _carousel_nextButton;
    if (carousel === null || carousel === void 0 ? void 0 : (_carousel_nextButton = carousel.nextButton) === null || _carousel_nextButton === void 0 ? void 0 : _carousel_nextButton.analytics) {
      var _carousel_nextButton_analytics = carousel.nextButton.analytics,
        referrerId = _carousel_nextButton_analytics.referrerId,
        linkName = _carousel_nextButton_analytics.linkName;
      trackClick(referrerId, linkName);
    }
    setIsSheetVisibleList(isSheetVisibleList.map(function () {
      return false;
    }));
  };
  var handleCarouselPrevButtonClick = function () {
    var _carousel_previousButton;
    if (carousel === null || carousel === void 0 ? void 0 : (_carousel_previousButton = carousel.previousButton) === null || _carousel_previousButton === void 0 ? void 0 : _carousel_previousButton.analytics) {
      var _carousel_previousButton_analytics = carousel.previousButton.analytics,
        referrerId = _carousel_previousButton_analytics.referrerId,
        linkName = _carousel_previousButton_analytics.linkName;
      trackClick(referrerId, linkName);
    }
    setIsSheetVisibleList(isSheetVisibleList.map(function () {
      return false;
    }));
  };
  var handleCarouselScrollEnd = function () {
    if (scrollEndAnalytics) {
      var referrerId = scrollEndAnalytics.referrerId,
        linkName = scrollEndAnalytics.linkName;
      track(ITrackType.EVENT, {
        data: referrerMapper(referrerId, linkName, "impression")
      });
    }
  };
  var handleAISearchSubmit = function (value) {
    var field = {
      name: "ai_search_query",
      value: value
    };
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters(field);
    setShouldSubmitAISearch(true);
  };
  var allFilterSheetFooterData = {
    __typename: "ShoppingSortAndFilters",
    footerLabel: footerLabel,
    containers: containers
  };
  var mappedFilterSections = /* @__PURE__ */React53.createElement("div", null, sortAndFilterSections.map(function (section, index) {
    return /* @__PURE__ */React53.createElement(SortAndFilterSection, {
      key: "sort-section-".concat(index),
      onSelectedField: onSelectedField,
      resetFilters: resetFilters,
      data: section,
      onRangeSelectionChange: onRangeSelectionChange,
      onStepInputChange: onStepInputChange,
      onSelectionChange: onSelectionChange,
      onFieldClick: onFieldClick,
      isDatedSearch: isDatedSearch,
      currentView: currentView,
      keepSectionExpanded: keepSectionExpanded,
      loading: waitingForQueryResolution
    });
  }));
  var shouldDisplayAISearch = tnlFields === null || tnlFields === void 0 ? void 0 : tnlFields.some(function (field) {
    return field.key === "ai_search_suggestion_1" || field.key === "ai_search_error_message";
  });
  var aiSearchButtonAndSheet = shouldDisplayAISearch && /* @__PURE__ */React53.createElement(AISearchButtonAndSheet, {
    dialogAriaLabel: "AI search dialog",
    closeButtonAriaLabel: "close AI search dialog",
    shouldAddMarginRight: hideQuickAccessFilters || carousel === null,
    onSubmit: handleAISearchSubmit,
    onActionListItemClick: handleAISearchSubmit,
    errorStateString: errorStateString,
    setErrorStateString: setErrorStateString,
    isSmallViewSize: isSmallViewSize,
    tnlFields: tnlFields,
    disabled: loading || waitingForQueryResolution
  });
  var primaryPillContent;
  if ((revealAction === null || revealAction === void 0 ? void 0 : revealAction.__typename) === "UISecondaryFloatingActionButton" && isSmallViewSize) {
    if (revealAction.accessibility || revealAction.badge && revealAction.badge >= 0) {
      primaryPillContent = /* @__PURE__ */React53.createElement("span", {
        "aria-label": revealAction.accessibility || ""
      }, revealAction.badge && revealAction.badge > 0 ? "(".concat(revealAction.badge, ")") : "");
    }
  } else {
    primaryPillContent = revealAction === null || revealAction === void 0 ? void 0 : revealAction.primary;
  }
  var primaryPill = /* @__PURE__ */React53.createElement(EGDSLayoutFlexItem13, {
    shrink: 0
  }, /* @__PURE__ */React53.createElement(EGDSPill3, {
    id: "all-filters-pill",
    active: isOpen,
    icon: (_revealAction_icon = revealAction.icon) === null || _revealAction_icon === void 0 ? void 0 : _revealAction_icon.id,
    onClick: handleTriggerClick,
    selected: Boolean(revealAction.badge),
    onSubmit: handleSubmitClick,
    disabled: loading || waitingForQueryResolution,
    triggerPill: true,
    domRef: primaryPillRef
  }, primaryPillContent));
  var shouldDisplayInlineCompareToggle = isInlineToggle && toggleButton && !isMapView;
  var inlineCompareToggle = shouldDisplayInlineCompareToggle && /* @__PURE__ */React53.createElement(ToggleButtonField, {
    data: toggleButton,
    inline: true
  });
  var alwaysShowCompareToggleInDialog = hideQuickAccessFilters && isThematicSearchEnabled;
  var _quickAccessFilters_length;
  var carouselItemsCount = 1 + ((_quickAccessFilters_length = quickAccessFilters === null || quickAccessFilters === void 0 ? void 0 : quickAccessFilters.length) !== null && _quickAccessFilters_length !== void 0 ? _quickAccessFilters_length : 0) + (shouldDisplayAISearch ? 1 : 0) + (shouldDisplayInlineCompareToggle ? 1 : 0);
  var shoppingSortAndFiltersQuickAccessFiltersProps = {
    data: {
      __typename: "ShoppingSortAndFilters",
      quickAccessFilters: quickAccessFilters
    },
    footerDataLoading: footerDataLoading || waitingForQueryResolution,
    isDatedSearch: isDatedSearch,
    isSheetVisibleList: isSheetVisibleList,
    keepSectionExpanded: keepSectionExpanded,
    loading: loading || waitingForQueryResolution,
    mappedFilterSections: mappedFilterSections,
    onClearFilters: onClearFilters,
    onOpenDialog: onOpenDialog,
    onRangeSelectionChange: onRangeSelectionChange,
    onRemoveAllAppliedFilters: onRemoveAllAppliedFilters,
    onRemoveToggleFilter: onRemoveToggleFilter,
    onSelectedField: onSelectedField,
    onStepInputChange: onStepInputChange,
    onSubmit: onSubmit,
    setFiltersActive: setFiltersActive,
    setIsSheetVisibleList: setIsSheetVisibleList,
    setResetFilters: setResetFilters,
    setSubmitButtonClicked: setSubmitButtonClicked
  };
  var _carousel_nextButton_accessibility, _carousel_previousButton_accessibility;
  return /* @__PURE__ */React53.createElement(SignalWrapper, null, /* @__PURE__ */React53.createElement(React53.Fragment, null, hideQuickAccessFilters ? /* @__PURE__ */React53.createElement(EGDSSpacing20, _object_spread({}, spacing), /* @__PURE__ */React53.createElement(EGDSLayoutFlex12, {
    direction: "row"
  }, aiSearchButtonAndSheet && /* @__PURE__ */React53.createElement(EGDSLayoutFlexItem13, null, aiSearchButtonAndSheet), /* @__PURE__ */React53.createElement(EGDSLayoutFlexItem13, null, primaryPill))) : /* @__PURE__ */React53.createElement(StickyWrapper, {
    isDialogOpen: isOpen,
    stickyByViewsize: stickyByViewsize,
    spacing: carousel ? void 0 : spacing,
    disabled: (isBexSplitViewEnabled || xLOBQAFExposure.bucket === 1) && !isSmallViewSize
  }, carousel ? /* @__PURE__ */React53.createElement(CarouselInnerSpacingAndOverflow, {
    itemsVisible: {
      sm: "auto",
      md: "auto",
      lg: "auto",
      xl: "auto"
    },
    buttonText: {
      nextButton: (_carousel_nextButton_accessibility = carousel === null || carousel === void 0 ? void 0 : (_carousel_nextButton = carousel.nextButton) === null || _carousel_nextButton === void 0 ? void 0 : _carousel_nextButton.accessibility) !== null && _carousel_nextButton_accessibility !== void 0 ? _carousel_nextButton_accessibility : "",
      prevButton: (_carousel_previousButton_accessibility = carousel === null || carousel === void 0 ? void 0 : (_carousel_previousButton = carousel.previousButton) === null || _carousel_previousButton === void 0 ? void 0 : _carousel_previousButton.accessibility) !== null && _carousel_previousButton_accessibility !== void 0 ? _carousel_previousButton_accessibility : ""
    },
    onNextButtonClick: handleCarouselNextButtonClick,
    onPrevButtonClick: handleCarouselPrevButtonClick,
    onScrollEnd: handleCarouselScrollEnd,
    spacing: spacing,
    isPopoverOpenList: _to_consumable_array(Array.from({
      length: carouselItemsCount - isSheetVisibleList.length
    }, function () {
      return false;
    })).concat(_to_consumable_array(isSheetVisibleList)),
    wrapItems: false,
    pagingInset: true,
    hideNavOnScrollEnd: true
  }, aiSearchButtonAndSheet, primaryPill, /* @__PURE__ */React53.createElement(QuickAccessFilters, _object_spread({}, shoppingSortAndFiltersQuickAccessFiltersProps)), inlineCompareToggle) : /* @__PURE__ */React53.createElement(EGDSScrollable2, {
    direction: "horizontal"
  }, aiSearchButtonAndSheet, primaryPill, /* @__PURE__ */React53.createElement(QuickAccessFilters, _object_spread({}, shoppingSortAndFiltersQuickAccessFiltersProps)), inlineCompareToggle && /* @__PURE__ */React53.createElement(EGDSSpacing20, {
    margin: {
      inlinestart: "two"
    }
  }, /* @__PURE__ */React53.createElement(EGDSLayoutFlexItem13, {
    alignSelf: "center"
  }, /* @__PURE__ */React53.createElement("div", null, /* @__PURE__ */React53.createElement(ToggleButtonField, {
    data: toggleButton,
    inline: true
  }))))))), /* @__PURE__ */React53.createElement(EGDSSheetTransition4, {
    isVisible: isOpen
  }, /* @__PURE__ */React53.createElement(DialogComponent, null, /* @__PURE__ */React53.createElement(EGDSSheet4, {
    type: isSmallViewSize ? "full" : "centered",
    isVisible: isOpen,
    returnFocusOnClose: true,
    triggerRef: primaryPillRef
  }, toolbar && /* @__PURE__ */React53.createElement(Toolbar, {
    data: toolbar,
    onCloseButtonClick: handleCloseButtonClick,
    onClearAllButtonClick: handleClearButtonClick
  }), /* @__PURE__ */React53.createElement(EGDSDialogContent2, {
    zeroPadding: true
  }, toggleButton && (alwaysShowCompareToggleInDialog || !isInlineToggle) && /* @__PURE__ */React53.createElement(EGDSSpacing20, {
    padding: {
      blockstart: "six",
      inline: "six"
    }
  }, /* @__PURE__ */React53.createElement("div", null, /* @__PURE__ */React53.createElement(EGDSSpacing20, {
    padding: {
      blockend: "six"
    },
    border: ["blockend"]
  }, /* @__PURE__ */React53.createElement("div", null, /* @__PURE__ */React53.createElement(ToggleButtonField, {
    data: toggleButton
  }))))), /* @__PURE__ */React53.createElement(EGDSSpacing20, {
    padding: {
      blockend: "four",
      inline: "six"
    }
  }, mappedFilterSections)), /* @__PURE__ */React53.createElement(AllFilterSheetFooter, {
    data: allFilterSheetFooterData,
    footerDataLoading: footerDataLoading || waitingForQueryResolution,
    viewType: viewType,
    onClick: handleSubmitClick
  })))));
};
SearchToolsFilterBar.displayName = "SearchToolsFilterBar";
SearchToolsFilterBar.fragment = __Fragment40;
// ../internal/src/components/sort-filter/search-tools-filter-pill.tsx
import React54 from "react";
import { gql as gql52 } from "@apollo/client";
import { EGDSPillContainer as EGDSPillContainer2 } from "@egds/react-core/pill";
import { EGDSSpacing as EGDSSpacing21 } from "@egds/react-core/spacing";
var __Fragment41 = gql52(_templateObject60(), ToggleFilterPillField.fragment);
var filterPillpadding = {
  block: "half"
};
var SearchToolsFilterPill = function (param) {
  var data = param.data,
    onClick = param.onClick,
    onEmptyResults = param.onEmptyResults;
  var quickAccessFilters = data.quickAccessFilters;
  if (!quickAccessFilters) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  return /* @__PURE__ */React54.createElement(EGDSPillContainer2, null, quickAccessFilters === null || quickAccessFilters === void 0 ? void 0 : quickAccessFilters.map(function (filterPill, index) {
    var fieldID = "filter-pill-".concat(index);
    if (filterPill.__typename !== ToggleFilterPillField.fragment.__typename) {
      return null;
    }
    return /* @__PURE__ */React54.createElement(EGDSSpacing21, {
      key: fieldID,
      padding: filterPillpadding
    }, /* @__PURE__ */React54.createElement("div", {
      "data-stid": fieldID
    }, /* @__PURE__ */React54.createElement(ToggleFilterPillField, {
      data: filterPill
    })));
  }));
};
SearchToolsFilterPill.displayName = "SearchToolsFilterPill";
SearchToolsFilterPill.fragment = __Fragment41;
// ../internal/src/components/sort-filter/search-tools-filters.tsx
import React55, { useEffect as useEffect8, useState as useState8 } from "react";
import { gql as gql53 } from "@apollo/client";
import { EGDSCard } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex13, EGDSLayoutFlexItem as EGDSLayoutFlexItem14 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing22 } from "@egds/react-core/spacing";
import { useExperiment as useExperiment9 } from "@shared-ui/experiment-context";
var __Fragment42 = gql53(_templateObject61(), ToggleButtonField.fragment, SortAndFilterSection.fragment);
var SearchToolsFilters = function (props) {
  var data = props.data,
    onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onSelectionChange = props.onSelectionChange,
    typeaheadAdapters = props.typeaheadAdapters,
    onRangeSelectionChange = props.onRangeSelectionChange,
    useUnsetMargin = props.useUnsetMargin,
    useUnsetTopBorder = props.useUnsetTopBorder,
    onEmptyResults = props.onEmptyResults,
    keepSectionExpanded = props.keepSectionExpanded,
    typeaheadLogger = props.typeaheadLogger,
    onKeyDown = props.onKeyDown,
    currentView = props.currentView,
    onClearFilters = props.onClearFilters;
  var filterSections = data.filterSections,
    toggleButton = data.toggleButton,
    tnlFields = data.tnlFields;
  var _useState8 = _sliced_to_array(useState8(function () {
      var _parseGraphQLPair;
      return (_parseGraphQLPair = parseGraphQLPair(tnlFields || [], "ai_search_error_message")) === null || _parseGraphQLPair === void 0 ? void 0 : _parseGraphQLPair.value;
    }), 2),
    errorStateString = _useState8[0],
    setErrorStateString = _useState8[1];
  var shouldDisplayAISearch = tnlFields === null || tnlFields === void 0 ? void 0 : tnlFields.some(function (field) {
    return field.key === "ai_search_suggestion_1" || field.key === "ai_search_error_message";
  });
  var isAiFiltersVisualIdentityUpdate = useExperiment9("AI_Filters_Visual_Identity_Update").exposure.bucket === 1;
  useEffect8(function () {
    if (tnlFields) {
      var _parseGraphQLPair;
      setErrorStateString((_parseGraphQLPair = parseGraphQLPair(tnlFields, "ai_search_error_message")) === null || _parseGraphQLPair === void 0 ? void 0 : _parseGraphQLPair.value);
    }
  }, [tnlFields]);
  if (!Array.isArray(filterSections)) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  var handleAISearchSubmit = function (value) {
    var field = {
      name: "ai_search_query",
      value: value
    };
    onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters(field);
  };
  var handleAISearchTextInputChange = function () {
    setErrorStateString(void 0);
  };
  return /* @__PURE__ */React55.createElement(React55.Fragment, null, toggleButton && /* @__PURE__ */React55.createElement(EGDSSpacing22, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React55.createElement("div", null, /* @__PURE__ */React55.createElement(EGDSCard, {
    padded: true,
    border: true
  }, /* @__PURE__ */React55.createElement(EGDSLayoutFlex13, null, /* @__PURE__ */React55.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */React55.createElement(ToggleButtonField, {
    data: toggleButton
  })))))), shouldDisplayAISearch && /* @__PURE__ */React55.createElement(AISearchSection, {
    textInputLabel: "I'm looking for...",
    placeholder: "Hotels with breakfast",
    buttonAriaLabel: "search",
    listTitle: "Try these",
    badgeText: "Beta",
    sectionTitle: "AI Search",
    subtext: "Describe your ideal stay to get the best matches",
    sectionSpacing: {
      padding: {
        blockstart: "six"
      },
      border: ["blockstart"],
      margin: {
        blockstart: "six"
      }
    },
    contentSpacing: {
      padding: {
        blockstart: "two"
      }
    },
    onSubmit: handleAISearchSubmit,
    errorStateString: errorStateString,
    onTextInputChange: handleAISearchTextInputChange,
    tnlFields: tnlFields,
    isAiFiltersVisualIdentityUpdate: isAiFiltersVisualIdentityUpdate
  }), filterSections.map(function (section, index) {
    return /* @__PURE__ */React55.createElement(SortAndFilterSection, {
      key: "filter-section-".concat(index),
      data: section,
      typeaheadAdapters: typeaheadAdapters,
      onMultiSelectClose: onMultiSelectClose,
      onMultiSelectItemRemove: onMultiSelectItemRemove,
      onMultiSelectClearAll: onMultiSelectClearAll,
      onSelectionChange: onSelectionChange,
      onRangeSelectionChange: onRangeSelectionChange,
      useUnsetMargin: useUnsetMargin,
      useUnsetTopBorder: useUnsetTopBorder,
      keepSectionExpanded: keepSectionExpanded,
      typeaheadLogger: typeaheadLogger,
      onKeyDown: onKeyDown,
      currentView: currentView
    });
  }));
};
SearchToolsFilters.displayName = "SearchToolsFilters";
SearchToolsFilters.fragment = __Fragment42;
// ../internal/src/components/sort-filter/search-tools-sort.tsx
import React56 from "react";
import { gql as gql54 } from "@apollo/client";
var __Fragment43 = gql54(_templateObject62(), DropdownField.fragment);
var SearchToolsSort = function (param) {
  var data = param.data,
    onKeyPress = param.onKeyPress,
    onClick = param.onClick,
    onEmptyResults = param.onEmptyResults;
  var sortSections = data.sortSections;
  if (!Array.isArray(sortSections)) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  return /* @__PURE__ */React56.createElement(React56.Fragment, null, sortSections.map(function (section) {
    return section.fields.map(function (field, index) {
      if (!(field.__typename === DropdownField.fragment.__typename)) {
        return null;
      }
      return /* @__PURE__ */React56.createElement("div", {
        "data-test-id": section.id,
        key: index
      }, /* @__PURE__ */React56.createElement(DropdownField, {
        key: "sort-field-".concat(index),
        data: field,
        onKeyPress: onKeyPress,
        onClick: onClick
      }));
    });
  }));
};
SearchToolsSort.displayName = "SearchToolsSort";
SearchToolsSort.fragment = __Fragment43;
// ../internal/src/components/sort-filter/search-tools-sort-and-filter.tsx
import React57 from "react";
import { gql as gql55 } from "@apollo/client";
import { EGDSDialogContent as EGDSDialogContent3 } from "@egds/react-core/dialog";
import { EGDSSheet as EGDSSheet5, EGDSSheetTransition as EGDSSheetTransition5 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing23 } from "@egds/react-core/spacing";
import { useDialog as useDialog5 } from "@shared-ui/dialog-context";
import { defaultViewSizes as defaultViewSizes6, useMediaQueries as useMediaQueries6 } from "@shared-ui/viewport-context";
var __Fragment44 = gql55(_templateObject63(), AllFilterSheetFooter.fragment, ToggleButtonField.fragment, SortAndFilterSection.fragment, containersFragment);
var viewType2 = "SORT_AND_FILTERS" /* SORT_AND_FILTERS */;
var SearchToolsSortAndFilter = function (props) {
  var data = props.data,
    onEmptyResults = props.onEmptyResults,
    onFieldClick = props.onFieldClick,
    onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onSubmit = props.onSubmit,
    onOpenDialog = props.onOpenDialog,
    onClearFilters = props.onClearFilters,
    typeaheadAdapters = props.typeaheadAdapters,
    onSelectionChange = props.onSelectionChange,
    onRangeSelectionChange = props.onRangeSelectionChange,
    onRemoveAllAppliedFilters = props.onRemoveAllAppliedFilters,
    keepSectionExpanded = props.keepSectionExpanded,
    onStepInputChange = props.onStepInputChange,
    withUpdatedNotification = props.withUpdatedNotification,
    onKeyDown = props.onKeyDown,
    onDone = props.onDone,
    footerDataLoading = props.footerDataLoading,
    currentView = props.currentView;
  var _ref = data || {},
    __typename = _ref.__typename,
    sortSections = _ref.sortSections,
    filterSections = _ref.filterSections,
    legacySections = _ref.sections,
    containers = _ref.containers,
    footerLabel = _ref.footerLabel,
    toggleButton = _ref.toggleButton;
  var _containers_find;
  var _ref1 = (_containers_find = containers === null || containers === void 0 ? void 0 : containers.find(function (container) {
      return container.__typename === "ShoppingSortAndFilterDialogContainer" && container.view === viewType2;
    })) !== null && _containers_find !== void 0 ? _containers_find : {},
    toolbarData = _ref1.toolbar,
    revealAction = _ref1.revealAction,
    applyAction = _ref1.applyAction;
  var combinedSections = [sortSections, filterSections, legacySections];
  var isSmallViewSize = useMediaQueries6({
    viewSizes: defaultViewSizes6
  }) === defaultViewSizes6.SMALL;
  var _useDialog5 = _sliced_to_array(useDialog5("".concat(__typename, "-").concat(viewType2)), 3),
    isDialogOpen = _useDialog5[0],
    dialogActions = _useDialog5[1],
    DialogComponent = _useDialog5[2];
  var openDialog = dialogActions.openDialog,
    closeDialog = dialogActions.closeDialog;
  var _React57_useState = _sliced_to_array(React57.useState(toolbarData), 2),
    toolbar = _React57_useState[0],
    setToolbar = _React57_useState[1];
  var _React57_useState1 = _sliced_to_array(React57.useState(false), 2),
    resetFilters = _React57_useState1[0],
    setResetFilters = _React57_useState1[1];
  var triggerRef = React57.useRef(null);
  var handleTriggerClick = React57.useCallback(function () {
    if (onOpenDialog) {
      onOpenDialog();
    }
    setResetFilters(false);
    setToolbar(toolbarData);
    openDialog();
  }, [onOpenDialog, openDialog, toolbarData]);
  var handleSubmitClick = React57.useCallback(function () {
    if (onSubmit) {
      onSubmit();
    }
    closeDialog();
  }, [onSubmit, closeDialog]);
  var handleCloseButtonClick = React57.useCallback(function () {
    if (onClearFilters) {
      onClearFilters({
        name: "restore" /* RESTORE */,
        value: {}
      });
    }
    closeDialog();
  }, [closeDialog]);
  var handleClearButtonClick = React57.useCallback(function () {
    var _toolbar_actions_secondaries;
    if (onRemoveAllAppliedFilters) {
      onRemoveAllAppliedFilters();
    }
    if (onClearFilters) {
      onClearFilters({
        name: "clear" /* CLEAR */,
        value: {}
      });
    }
    setResetFilters(true);
    var _toolbar_actions_secondaries_map;
    var newToolbar = toolbar && _object_spread_props(_object_spread({}, toolbar), {
      actions: _object_spread_props(_object_spread({}, toolbar.actions), {
        secondaries: (_toolbar_actions_secondaries_map = (_toolbar_actions_secondaries = toolbar.actions.secondaries) === null || _toolbar_actions_secondaries === void 0 ? void 0 : _toolbar_actions_secondaries.map(function (element) {
          return _object_spread_props(_object_spread({}, element), {
            disabled: true
          });
        })) !== null && _toolbar_actions_secondaries_map !== void 0 ? _toolbar_actions_secondaries_map : []
      })
    });
    setToolbar(newToolbar);
  }, [onRemoveAllAppliedFilters]);
  var onSelectedField = React57.useCallback(function () {
    setToolbar(toolbarData);
    setResetFilters(false);
  }, [toolbarData]);
  var hasSections = combinedSections.some(function (sections) {
    return Array.isArray(sections) && sections.length > 0;
  });
  if (!hasSections || !revealAction || !applyAction) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  var allFilterSheetFooterData = {
    __typename: "ShoppingSortAndFilters",
    footerLabel: footerLabel,
    containers: containers
  };
  return /* @__PURE__ */React57.createElement(React57.Fragment, null, /* @__PURE__ */React57.createElement(UIFloatingActionButton, {
    data: revealAction,
    isFullWidth: true,
    onClick: handleTriggerClick,
    withUpdatedNotification: withUpdatedNotification,
    triggerRef: triggerRef
  }), /* @__PURE__ */React57.createElement(EGDSSheetTransition5, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React57.createElement(DialogComponent, null, /* @__PURE__ */React57.createElement(EGDSSheet5, {
    type: isSmallViewSize ? "full" : "centered",
    isVisible: isDialogOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, toolbar && /* @__PURE__ */React57.createElement(Toolbar, {
    data: toolbar,
    onCloseButtonClick: handleCloseButtonClick,
    onClearAllButtonClick: handleClearButtonClick
  }), /* @__PURE__ */React57.createElement(EGDSDialogContent3, {
    zeroPadding: true
  }, toggleButton && /* @__PURE__ */React57.createElement(EGDSSpacing23, {
    padding: {
      blockstart: "six",
      inline: "four"
    }
  }, /* @__PURE__ */React57.createElement("div", null, /* @__PURE__ */React57.createElement(EGDSSpacing23, {
    padding: {
      blockend: "six"
    },
    border: ["blockend"]
  }, /* @__PURE__ */React57.createElement("div", null, /* @__PURE__ */React57.createElement(ToggleButtonField, {
    data: toggleButton
  }))))), /* @__PURE__ */React57.createElement(EGDSSpacing23, {
    padding: {
      blockend: "four",
      inline: "four"
    }
  }, /* @__PURE__ */React57.createElement("div", {
    "data-test-id": "sort-filter-drawer"
  }, combinedSections.map(function (sections) {
    if (!Array.isArray(sections)) {
      return null;
    }
    return sections.map(function (section, index) {
      return /* @__PURE__ */React57.createElement(SortAndFilterSection, {
        key: "sort-section-".concat(index),
        data: section,
        typeaheadAdapters: typeaheadAdapters,
        onFieldClick: onFieldClick,
        onMultiSelectClose: onMultiSelectClose,
        onMultiSelectItemRemove: onMultiSelectItemRemove,
        onMultiSelectClearAll: onMultiSelectClearAll,
        onSelectionChange: onSelectionChange,
        onSelectedField: onSelectedField,
        onRangeSelectionChange: onRangeSelectionChange,
        onStepInputChange: onStepInputChange,
        keepSectionExpanded: keepSectionExpanded,
        resetFilters: resetFilters,
        onKeyDown: onKeyDown,
        onDone: onDone,
        currentView: currentView
      });
    });
  })))), /* @__PURE__ */React57.createElement(AllFilterSheetFooter, {
    data: allFilterSheetFooterData,
    footerDataLoading: footerDataLoading,
    viewType: viewType2,
    onClick: handleSubmitClick,
    isButtonTracked: true
  })))));
};
SearchToolsSortAndFilter.displayName = "SearchToolsSortAndFilter";
SearchToolsSortAndFilter.fragment = __Fragment44;
// ../internal/src/components/sort-filter/search-tools-filter-dialog.tsx
import React58 from "react";
import { gql as gql56 } from "@apollo/client";
import { EGDSBadgeNotification as EGDSBadgeNotification2 } from "@egds/react-core/badge";
import { EGDSButtonSize as EGDSButtonSize7, EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { EGDSDialogContent as EGDSDialogContent4 } from "@egds/react-core/dialog";
import { EGDSLayoutFlex as EGDSLayoutFlex14, EGDSLayoutFlexItem as EGDSLayoutFlexItem15 } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition as EGDSLayoutPosition2 } from "@egds/react-core/layout-position";
import { EGDSSheet as EGDSSheet6, EGDSSheetTransition as EGDSSheetTransition6 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing24 } from "@egds/react-core/spacing";
import { useClickTracker as useClickTracker30 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog6 } from "@shared-ui/dialog-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var __Fragment45 = gql56(_templateObject64(), AllFilterSheetFooter.fragment, SortAndFilterSection.fragment, containersFragment);
var viewType3 = "FILTER_DIALOG" /* FILTER_DIALOG */;
var SearchToolsFilterDialog = function (props) {
  var _toolbarData_actions, _toolbarData_actions_secondaries_, _toolbarData_actions1;
  var data = props.data,
    onEmptyResults = props.onEmptyResults,
    onMultiSelectClose = props.onMultiSelectClose,
    onMultiSelectItemRemove = props.onMultiSelectItemRemove,
    onMultiSelectClearAll = props.onMultiSelectClearAll,
    onSubmit = props.onSubmit,
    onOpenDialog = props.onOpenDialog,
    onClearFilters = props.onClearFilters,
    typeaheadAdapters = props.typeaheadAdapters,
    onSelectionChange = props.onSelectionChange,
    onRangeSelectionChange = props.onRangeSelectionChange,
    onRemoveAllAppliedFilters = props.onRemoveAllAppliedFilters,
    onStepInputChange = props.onStepInputChange,
    keepSectionExpanded = props.keepSectionExpanded,
    footerDataLoading = props.footerDataLoading,
    currentView = props.currentView,
    loading = props.loading;
  var __typename = data.__typename,
    containers = data.containers,
    filterSections = data.filterSections,
    legacySections = data.sections,
    footerLabel = data.footerLabel;
  var _containers_find;
  var _ref = (_containers_find = containers === null || containers === void 0 ? void 0 : containers.find(function (container) {
      return container.__typename === "ShoppingSortAndFilterDialogContainer" && container.view === viewType3;
    })) !== null && _containers_find !== void 0 ? _containers_find : {},
    toolbarData = _ref.toolbar,
    revealAction = _ref.revealAction,
    applyAction = _ref.applyAction;
  var combinedSections = [filterSections, legacySections];
  var _useDialog6 = _sliced_to_array(useDialog6("".concat(__typename, "-").concat(viewType3)), 3),
    isOpen = _useDialog6[0],
    dialogActions = _useDialog6[1],
    DialogComponent = _useDialog6[2];
  var openDialog = dialogActions.openDialog,
    closeDialog = dialogActions.closeDialog;
  var _React58_useState = _sliced_to_array(React58.useState(toolbarData), 2),
    toolbar = _React58_useState[0],
    setToolbar = _React58_useState[1];
  var _React58_useState1 = _sliced_to_array(React58.useState(false), 2),
    resetFilters = _React58_useState1[0],
    setResetFilters = _React58_useState1[1];
  var _React58_useState2 = _sliced_to_array(React58.useState((toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions = toolbarData.actions) === null || _toolbarData_actions === void 0 ? void 0 : _toolbarData_actions.secondaries) && (toolbarData === null || toolbarData === void 0 ? void 0 : (_toolbarData_actions1 = toolbarData.actions) === null || _toolbarData_actions1 === void 0 ? void 0 : (_toolbarData_actions_secondaries_ = _toolbarData_actions1.secondaries[0]) === null || _toolbarData_actions_secondaries_ === void 0 ? void 0 : _toolbarData_actions_secondaries_.disabled)), 2),
    filtersActive = _React58_useState2[0],
    setFiltersActive = _React58_useState2[1];
  var _React58_useState3 = _sliced_to_array(React58.useState(true), 2),
    submitButtonClicked = _React58_useState3[0],
    setSubmitButtonClicked = _React58_useState3[1];
  var triggerRef = React58.useRef(null);
  React58.useEffect(function () {
    var _toolbar_actions_secondaries;
    if (!toolbar) {
      return;
    }
    setToolbar(_object_spread_props(_object_spread({}, toolbar), {
      actions: {
        __typename: "UIToolbarActions",
        primary: _object_spread({}, toolbar.actions.primary),
        secondaries: ((_toolbar_actions_secondaries = toolbar.actions.secondaries) === null || _toolbar_actions_secondaries === void 0 ? void 0 : _toolbar_actions_secondaries.map(function (element) {
          return _object_spread_props(_object_spread({}, element), {
            disabled: !filtersActive && resetFilters
          });
        })) || []
      }
    }));
  }, [filtersActive, resetFilters]);
  React58.useEffect(function () {
    if (!isOpen && !submitButtonClicked) {
      onClearFilters === null || onClearFilters === void 0 ? void 0 : onClearFilters({
        name: "restore" /* RESTORE */,
        value: {}
      });
      setResetFilters(false);
    }
    setSubmitButtonClicked(false);
  }, [isOpen, submitButtonClicked]);
  var track = useClickTracker30();
  var handleTriggerClick = React58.useCallback(function () {
    var _revealAction_analytics;
    if (onOpenDialog) {
      onOpenDialog();
    }
    if (revealAction && revealAction.__typename === "UISecondaryFloatingActionButton" && ((_revealAction_analytics = revealAction.analytics) === null || _revealAction_analytics === void 0 ? void 0 : _revealAction_analytics.__typename) === "ClientSideAnalytics") {
      var _revealAction_analytics1 = revealAction.analytics,
        referrerId = _revealAction_analytics1.referrerId,
        linkName = _revealAction_analytics1.linkName;
      track(referrerId, linkName);
    }
    openDialog();
  }, [openDialog, onOpenDialog, revealAction, track]);
  var handleSubmitClick = React58.useCallback(function () {
    setSubmitButtonClicked(true);
    if (onSubmit) {
      onSubmit();
    }
    closeDialog();
  }, [onSubmit, closeDialog]);
  var handleCloseButtonClick = React58.useCallback(function () {
    if (onClearFilters) {
      onClearFilters({
        name: "restore" /* RESTORE */,
        value: {}
      });
    }
    setResetFilters(false);
    closeDialog();
  }, [closeDialog]);
  var handleClearButtonClick = React58.useCallback(function () {
    if (onRemoveAllAppliedFilters) {
      onRemoveAllAppliedFilters();
    }
    if (onClearFilters) {
      onClearFilters({
        name: "clear" /* CLEAR */,
        value: {}
      });
    }
    setResetFilters(true);
    setFiltersActive(false);
  }, [onRemoveAllAppliedFilters]);
  var onSelectedField = React58.useCallback(function () {
    setToolbar(toolbarData);
    setResetFilters(false);
    setFiltersActive(true);
  }, [toolbarData]);
  var hasSections = combinedSections.some(function (sections) {
    return Array.isArray(sections) && sections.length > 0;
  });
  if (!hasSections || !revealAction || !applyAction) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  if (revealAction.__typename !== "UISecondaryFloatingActionButton") {
    return null;
  }
  var badge = revealAction.badge,
    icon = revealAction.icon,
    primary = revealAction.primary;
  var btnContent = /* @__PURE__ */React58.createElement(React58.Fragment, null, !!badge && /* @__PURE__ */React58.createElement(EGDSLayoutFlexItem15, null, /* @__PURE__ */React58.createElement(EGDSLayoutPosition2, {
    type: "relative",
    position: {
      right: "two",
      bottom: "half"
    }
  }, /* @__PURE__ */React58.createElement(EGDSBadgeNotification2, {
    count: badge.toString(),
    theme: "action",
    visible: true
  }))), icon && !badge && /* @__PURE__ */React58.createElement(EGDSLayoutFlexItem15, null, /* @__PURE__ */React58.createElement(Icon, {
    data: icon
  })), /* @__PURE__ */React58.createElement(EGDSLayoutFlexItem15, null, /* @__PURE__ */React58.createElement("div", null, primary)));
  var allFilterSheetFooterData = {
    __typename: "ShoppingSortAndFilters",
    footerLabel: footerLabel,
    containers: containers
  };
  return /* @__PURE__ */React58.createElement(Viewport, null, /* @__PURE__ */React58.createElement(ViewSmall, null, /* @__PURE__ */React58.createElement(React58.Fragment, null, /* @__PURE__ */React58.createElement(EGDSTertiaryButton2, {
    isFullWidth: true,
    onClick: handleTriggerClick,
    size: EGDSButtonSize7.MEDIUM,
    domRef: triggerRef
  }, /* @__PURE__ */React58.createElement(EGDSLayoutFlex14, {
    direction: "column",
    alignItems: "center"
  }, btnContent)), /* @__PURE__ */React58.createElement(EGDSSheetTransition6, {
    isVisible: isOpen
  }, /* @__PURE__ */React58.createElement(DialogComponent, null, /* @__PURE__ */React58.createElement(EGDSSheet6, {
    type: "full",
    isVisible: isOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, toolbar && /* @__PURE__ */React58.createElement(Toolbar, {
    data: toolbar,
    onCloseButtonClick: handleCloseButtonClick,
    onClearAllButtonClick: handleClearButtonClick
  }), /* @__PURE__ */React58.createElement(EGDSDialogContent4, {
    zeroPadding: true
  }, /* @__PURE__ */React58.createElement(EGDSSpacing24, {
    padding: {
      blockend: "twelve",
      inline: "four"
    },
    margin: {
      blockend: "three"
    }
  }, /* @__PURE__ */React58.createElement("div", null, combinedSections.map(function (sections) {
    if (!Array.isArray(sections) || sections.length === 0) {
      return null;
    }
    return sections.map(function (section, index) {
      return /* @__PURE__ */React58.createElement(SortAndFilterSection, {
        key: "filter-section-".concat(index),
        data: section,
        typeaheadAdapters: typeaheadAdapters,
        onMultiSelectClose: onMultiSelectClose,
        onMultiSelectItemRemove: onMultiSelectItemRemove,
        onMultiSelectClearAll: onMultiSelectClearAll,
        onSelectionChange: onSelectionChange,
        onSelectedField: onSelectedField,
        onStepInputChange: onStepInputChange,
        onRangeSelectionChange: onRangeSelectionChange,
        keepSectionExpanded: keepSectionExpanded,
        useUnsetTopBorder: true,
        resetFilters: resetFilters,
        currentView: currentView,
        loading: loading
      });
    });
  })))), /* @__PURE__ */React58.createElement(AllFilterSheetFooter, {
    data: allFilterSheetFooterData,
    footerDataLoading: footerDataLoading,
    viewType: viewType3,
    onClick: handleSubmitClick,
    isButtonTracked: true
  })))))), /* @__PURE__ */React58.createElement(ViewMedium, null, /* @__PURE__ */React58.createElement(React58.Fragment, null, /* @__PURE__ */React58.createElement(EGDSTertiaryButton2, {
    isFullWidth: true,
    onClick: handleTriggerClick,
    size: EGDSButtonSize7.MEDIUM,
    domRef: triggerRef
  }, /* @__PURE__ */React58.createElement(EGDSLayoutFlex14, {
    space: badge ? "four" : "two"
  }, btnContent)), /* @__PURE__ */React58.createElement(EGDSSheetTransition6, {
    isVisible: isOpen
  }, /* @__PURE__ */React58.createElement(DialogComponent, null, /* @__PURE__ */React58.createElement(EGDSSheet6, {
    type: "centered",
    isVisible: isOpen,
    returnFocusOnClose: true,
    triggerRef: triggerRef
  }, toolbar && /* @__PURE__ */React58.createElement(Toolbar, {
    data: toolbar,
    onCloseButtonClick: handleCloseButtonClick,
    onClearAllButtonClick: handleClearButtonClick
  }), /* @__PURE__ */React58.createElement(EGDSDialogContent4, {
    zeroPadding: true
  }, /* @__PURE__ */React58.createElement(EGDSSpacing24, {
    padding: {
      blockend: "four",
      inline: "four"
    }
  }, /* @__PURE__ */React58.createElement("div", null, combinedSections.map(function (sections) {
    if (!Array.isArray(sections) || sections.length === 0) {
      return null;
    }
    return sections.map(function (section, index) {
      return /* @__PURE__ */React58.createElement(SortAndFilterSection, {
        key: "filter-section-".concat(index),
        data: section,
        typeaheadAdapters: typeaheadAdapters,
        onMultiSelectClose: onMultiSelectClose,
        onMultiSelectItemRemove: onMultiSelectItemRemove,
        onMultiSelectClearAll: onMultiSelectClearAll,
        onSelectionChange: onSelectionChange,
        onSelectedField: onSelectedField,
        onStepInputChange: onStepInputChange,
        onRangeSelectionChange: onRangeSelectionChange,
        keepSectionExpanded: keepSectionExpanded,
        useUnsetTopBorder: true,
        resetFilters: resetFilters,
        currentView: currentView,
        loading: loading
      });
    });
  })))), /* @__PURE__ */React58.createElement(AllFilterSheetFooter, {
    data: allFilterSheetFooterData,
    footerDataLoading: footerDataLoading,
    viewType: viewType3,
    onClick: handleSubmitClick,
    isButtonTracked: true
  })))))));
};
SearchToolsFilterDialog.displayName = "SearchToolsFilterDialog";
SearchToolsFilterDialog.fragment = __Fragment45;
// ../internal/src/components/sort-filter/search-tools-sort-tabs.tsx
import React60 from "react";
import { gql as gql58 } from "@apollo/client";
// ../internal/src/components/sort-filter/__private/__fragments/tab-selection-field.tsx
import React59, { useCallback as useCallback3, useEffect as useEffect9, useRef as useRef2, useState as useState9 } from "react";
import { gql as gql57 } from "@apollo/client";
import { useFormCallback as useFormCallback9 } from "@egds/react-core/form";
import { EGDSSpacing as EGDSSpacing25 } from "@egds/react-core/spacing";
import { EGDSTab, EGDSTabs, EGDSTabsType } from "@egds/react-core/tabs";
import { EGDSHeading as EGDSHeading15, EGDSText as EGDSText6 } from "@egds/react-core/text";
import { useClickTracker as useClickTracker31 } from "@shared-ui/clickstream-analytics-context";
var __Fragment46 = gql57(_templateObject65(), clientSideAnalyticsFragment);
var useDidUpdateEffect = function (fn, deps) {
  var didMount = useRef2(false);
  useEffect9(function () {
    if (didMount.current) {
      return fn();
    }
    didMount.current = true;
  }, deps);
};
var TabSelectionField = function (param) {
  var data = param.data;
  var _tabOptions_currentTabIndex;
  var track = useClickTracker31();
  var tabOptions = data.tabOptions;
  var defaultIndex = (tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions.findIndex(function (option) {
    return option.selected;
  })) || 0;
  var _useState9 = _sliced_to_array(useState9(defaultIndex), 2),
    currentTabIndex = _useState9[0],
    setCurrentTabIndex = _useState9[1];
  var _tabOptions_currentTabIndex_id;
  var tabSelectionFormCallback = useFormCallback9((_tabOptions_currentTabIndex_id = tabOptions === null || tabOptions === void 0 ? void 0 : (_tabOptions_currentTabIndex = tabOptions[currentTabIndex]) === null || _tabOptions_currentTabIndex === void 0 ? void 0 : _tabOptions_currentTabIndex.id) !== null && _tabOptions_currentTabIndex_id !== void 0 ? _tabOptions_currentTabIndex_id : "", function (event) {
    return event;
  });
  var handleTabSelect = useCallback3(function (selectedTabIndex) {
    var _tabOptions_selectedTabIndex;
    var selectAnalytics = tabOptions === null || tabOptions === void 0 ? void 0 : (_tabOptions_selectedTabIndex = tabOptions[selectedTabIndex]) === null || _tabOptions_selectedTabIndex === void 0 ? void 0 : _tabOptions_selectedTabIndex.selectAnalytics;
    if (selectAnalytics) {
      var referrerId = selectAnalytics.referrerId,
        linkName = selectAnalytics.linkName,
        uisPrimeMessages = selectAnalytics.uisPrimeMessages;
      track(referrerId, linkName, void 0, mapUisMicroMessage(uisPrimeMessages));
    }
    setCurrentTabIndex(selectedTabIndex);
  }, [tabOptions, track]);
  useEffect9(function () {
    setCurrentTabIndex(defaultIndex);
  }, [defaultIndex]);
  useDidUpdateEffect(function () {
    var _tabOptions_currentTabIndex;
    var _tabOptions_currentTabIndex_value;
    var fieldValue = (_tabOptions_currentTabIndex_value = tabOptions === null || tabOptions === void 0 ? void 0 : (_tabOptions_currentTabIndex = tabOptions[currentTabIndex]) === null || _tabOptions_currentTabIndex === void 0 ? void 0 : _tabOptions_currentTabIndex.value) !== null && _tabOptions_currentTabIndex_value !== void 0 ? _tabOptions_currentTabIndex_value : "";
    triggerInputChangeEvent(fieldValue, tabSelectionFormCallback);
  }, [currentTabIndex]);
  if (!(tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions.length)) {
    return null;
  }
  return /* @__PURE__ */React59.createElement(EGDSTabs, {
    selectedTab: currentTabIndex,
    onTabSelect: handleTabSelect,
    tabsType: EGDSTabsType.EQUAL_WIDTH
  }, tabOptions === null || tabOptions === void 0 ? void 0 : tabOptions.map(function (option, index) {
    var accessibility = option.accessibility,
      id = option.id,
      primary = option.primary,
      secondary = option.secondary,
      value = option.value;
    var tabID = "".concat(id, "-").concat(value, "-").concat(index);
    return /* @__PURE__ */React59.createElement(EGDSTab, {
      name: primary,
      id: id,
      key: tabID,
      targetURI: "#",
      tabLinkAttr: {
        id: tabID,
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : ""
      }
    }, /* @__PURE__ */React59.createElement(EGDSSpacing25, {
      padding: {
        inline: "four",
        blockstart: "one"
      }
    }, /* @__PURE__ */React59.createElement("div", null, secondary && /* @__PURE__ */React59.createElement(React59.Fragment, null, /* @__PURE__ */React59.createElement(EGDSHeading15, {
      size: 6,
      tag: "h3"
    }, primary), /* @__PURE__ */React59.createElement(EGDSText6, {
      size: 200,
      spacing: "two"
    }, secondary)))));
  }));
};
TabSelectionField.displayName = "TabSelectionField";
TabSelectionField.fragment = _object_spread_props(_object_spread({}, __Fragment46), {
  __typename: "ShoppingTabSelectionField"
});
// ../internal/src/components/sort-filter/search-tools-sort-tabs.tsx
var __Fragment47 = gql58(_templateObject66(), TabSelectionField.fragment);
var SearchToolsSortTabs = function (param) {
  var data = param.data,
    onEmptyResults = param.onEmptyResults;
  var sortSections = data.sortSections;
  if (!sortSections) {
    onEmptyResults === null || onEmptyResults === void 0 ? void 0 : onEmptyResults();
    return null;
  }
  return /* @__PURE__ */React60.createElement(React60.Fragment, null, sortSections.map(function (section) {
    return section.fields.map(function (field, index) {
      if (field.__typename !== TabSelectionField.fragment.__typename) {
        return null;
      }
      return /* @__PURE__ */React60.createElement("div", {
        "data-test-id": section.id,
        key: index
      }, /* @__PURE__ */React60.createElement(TabSelectionField, {
        key: "tabs-field-".concat(index),
        data: field
      }));
    });
  }));
};
SearchToolsSortTabs.displayName = "SearchToolsSortTabs";
SearchToolsSortTabs.fragment = __Fragment47;
var _obj1;
// ../internal/src/components/sort-filter/search-tools-sort-and-filters-views.tsx
var sortAndFiltersViewMap = (_obj1 = {}, _define_property(_obj1, "FILTERS" /* FILTERS */, SearchToolsFilters), _define_property(_obj1, "SORT" /* SORT */, SearchToolsSort), _define_property(_obj1, "SORT_AND_FILTERS" /* SORT_AND_FILTERS */, SearchToolsSortAndFilter), _define_property(_obj1, "APPLIED_FILTERS" /* APPLIED_FILTERS */, SearchToolsAppliedFilters), _define_property(_obj1, "FILTER_BAR" /* FILTER_BAR */, SearchToolsFilterBar), _define_property(_obj1, "FILTER_DIALOG" /* FILTER_DIALOG */, SearchToolsFilterDialog), _define_property(_obj1, "FILTERS_PILLS" /* FILTERS_PILLS */, SearchToolsFilterPill), _define_property(_obj1, "SORT_TABS" /* SORT_TABS */, SearchToolsSortTabs),
// the use rewards component was removed due to a PR revert
// this declaration is needed to pass build tests
// this will need to be updated once we have a use rewards component
_define_property(_obj1, "USE_REWARDS" /* USE_REWARDS */, SearchToolsSortTabs), _obj1);
// src/components/sort-filters/utils/error-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var CLIENT_EVENTS = {
  /**
  * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
  */
  SEARCH_TOOLS_ACTIVITY_SORT_AND_FILTER_QUERY_ERROR: new SystemEvent(SystemEventLevel.ERROR, "SEARCH_TOOLS_ACTIVITY_SORT_AND_FILTER_QUERY_ERROR"),
  SEARCH_TOOLS_ACTIVITY_SORT_AND_FILTER_NO_DATA: new SystemEvent(SystemEventLevel.INFO, "SEARCH_TOOLS_ACTIVITY_SORT_AND_FILTER_NO_DATA")
};
// src/components/sort-filters/sort-filters.tsx
var __Query = gql59(_templateObject67(), SearchToolsFilters.fragment, SearchToolsAppliedFilters.fragment, SearchToolsSort.fragment, SearchToolsSortAndFilter.fragment, SearchToolsFilterPill.fragment, SearchToolsFilterBar.fragment);
var ActivitySortAndFilters = function (props) {
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    view = props.view,
    onFieldChange = props.onFieldChange,
    onFieldClick = props.onFieldClick,
    isSearchResultsLoading = props.loading,
    onDone = props.onDone,
    onKeyDown = props.onKeyDown;
  var context = useBexApi3().context;
  var systemEvents = useLoggerEvents(CLIENT_EVENTS);
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error,
    previousData = _useQuery.previousData;
  var cachedData = loading && previousData ? previousData : data;
  if (error) {
    systemEvents.SEARCH_TOOLS_ACTIVITY_SORT_AND_FILTER_QUERY_ERROR.log({
      name: error.name,
      error: new Error(error.message)
    });
    return null;
  }
  if (!cachedData || !cachedData.activitySearch.universalSortAndFilter) {
    if (!loading) {
      systemEvents.SEARCH_TOOLS_ACTIVITY_SORT_AND_FILTER_NO_DATA.log({
        message: "No data loaded for the universal sort and filter module"
      });
    }
    return null;
  }
  var handleFieldChange = function (field, event) {
    onFieldChange === null || onFieldChange === void 0 ? void 0 : onFieldChange(field, event);
  };
  var View = sortAndFiltersViewMap[view];
  if (!View) {
    return null;
  }
  return /* @__PURE__ */React61.createElement(EGDSForm, {
    onFieldChange: handleFieldChange
  }, /* @__PURE__ */React61.createElement(View, _object_spread({
    data: cachedData.activitySearch.universalSortAndFilter,
    onClearFilters: handleFieldChange,
    onClick: onFieldClick,
    loading: isSearchResultsLoading,
    onKeyDown: onKeyDown,
    onDone: onDone,
    useUnsetTopBorder: true
  }, props)));
};
ActivitySortAndFilters.displayName = "sharedui-ActivitySortAndFilters";
// src/__generated__/types.ts
var ActivitySort = /* @__PURE__ */function (ActivitySort2) {
  ActivitySort2["CAMPAIGN_DEALS"] = "CAMPAIGN_DEALS";
  ActivitySort2["DISCOUNT"] = "DISCOUNT";
  ActivitySort2["DISTANCE_FROM_HOTEL"] = "DISTANCE_FROM_HOTEL";
  ActivitySort2["PRICE_HIGH_TO_LOW"] = "PRICE_HIGH_TO_LOW";
  ActivitySort2["PRICE_LOW_TO_HIGH"] = "PRICE_LOW_TO_HIGH";
  ActivitySort2["RECOMMENDED"] = "RECOMMENDED";
  return ActivitySort2;
}(ActivitySort || {});
// src/utils/query-params.ts
var ParamsKeys = /* @__PURE__ */function (ParamsKeys2) {
  ParamsKeys2["LOCATION"] = "location";
  ParamsKeys2["RID"] = "rid";
  ParamsKeys2["LAT_LONG"] = "latLong";
  ParamsKeys2["START_DATE"] = "startDate";
  ParamsKeys2["END_DATE"] = "endDate";
  ParamsKeys2["SORT"] = "sort";
  return ParamsKeys2;
}(ParamsKeys || {});
var FILTER_URL_PARAM_PREFIX = "filter.";
var ACTIVITY_TEXT_INPUT_KEYWORD = "slimSearchKeyword";
var getDestination = function (param) {
  var regionName = param.regionName,
    regionId = param.regionId,
    coordinates = param.coordinates;
  var _ref = _sliced_to_array((coordinates === null || coordinates === void 0 ? void 0 : coordinates.split(",").map(function (value) {
      return parseInt(value, 10);
    })) || [null, null], 2),
    latitude = _ref[0],
    longitude = _ref[1];
  return {
    regionName: regionName,
    regionId: regionId,
    coordinates: latitude && longitude ? {
      latitude: latitude,
      longitude: longitude
    } : null
  };
};
var getDateRange = function (param) {
  var startDate = param.startDate,
    endDate = param.endDate;
  if (!startDate || !endDate) {
    return null;
  }
  var startDateObj = new Date(startDate.replace(/-/g, "/"));
  var endDateObj = new Date(endDate.replace(/-/g, "/"));
  if (Number.isNaN(startDateObj.getTime()) || Number.isNaN(endDateObj.getTime())) {
    return null;
  }
  return {
    startDate: {
      year: startDateObj.getFullYear(),
      month: startDateObj.getMonth() + 1,
      day: startDateObj.getDate()
    },
    endDate: {
      year: endDateObj.getFullYear(),
      month: endDateObj.getMonth() + 1,
      day: endDateObj.getDate()
    }
  };
};
var getSortValue = function (param) {
  return ActivitySort[param];
};
var getUpdatedFilterQueryObject = function (queryParams) {
  var filterQueryParams = _to_consumable_array(queryParams).filter(function (param) {
    var _param = _sliced_to_array(param, 1),
      key = _param[0];
    return key.startsWith(FILTER_URL_PARAM_PREFIX) || key === ACTIVITY_TEXT_INPUT_KEYWORD;
  });
  var filterSelections = filterQueryParams.map(function (param) {
    var _param = _sliced_to_array(param, 2),
      key = _param[0],
      value = _param[1];
    return {
      id: key === ACTIVITY_TEXT_INPUT_KEYWORD ? ACTIVITY_TEXT_INPUT_KEYWORD : key.substring(FILTER_URL_PARAM_PREFIX.length),
      value: value.split(",")
    };
  }).flatMap(function (param) {
    var id = param.id,
      value = param.value;
    return value.map(function (val) {
      return {
        id: id,
        value: val
      };
    });
  });
  return {
    selections: filterSelections
  };
};
var getActivitySearchCriteriaFromQueryParams = function (queryParams) {
  var destination = getDestination({
    regionName: queryParams.get("location" /* LOCATION */),
    regionId: queryParams.get("rid" /* RID */),
    coordinates: queryParams.get("latLong" /* LAT_LONG */)
  });
  var dateRange = getDateRange({
    startDate: queryParams.get("startDate" /* START_DATE */),
    endDate: queryParams.get("endDate" /* END_DATE */)
  });
  var filters = getUpdatedFilterQueryObject(queryParams);
  var sort = getSortValue(queryParams.get("sort" /* SORT */));
  return {
    destination: destination,
    dateRange: dateRange,
    filters: filters,
    sort: sort
  };
};
// src/providers/activity-query-params-provider.tsx
import React62 from "react";
var ActivityQueryParamsContext = React62.createContext(null);
var ActivityQueryParamsProvider = function (param) {
  var children = param.children,
    urlSearchParams = param.urlSearchParams;
  var inputs = getActivitySearchCriteriaFromQueryParams(urlSearchParams);
  return /* @__PURE__ */React62.createElement(ActivityQueryParamsContext.Provider, {
    value: inputs
  }, children);
};
var useActivityURLParamsToQueryInputs = function () {
  return React62.useContext(ActivityQueryParamsContext);
};
export { ActivityQueryParamsProvider, ActivitySortAndFilters, ParamsKeys, SortAndFiltersViewType, getActivitySearchCriteriaFromQueryParams, useActivityURLParamsToQueryInputs }; /* istanbul ignore file -- @preserve */